const ar_SY = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'أصلي / OEM',
    'chatAiDevis.qualityCompatible': 'متوافق',
    'chatAiDevis.qualityReconditionné': 'مجدّد',
    'chatAiDevis.qualityPremium': 'بريميوم',
    'chatAiDevis.qualityStandard': 'عادي',
    'chatAiDevis.fieldName': 'الاسم',
    'chatAiDevis.fieldPhone': 'التلفون',
    'chatAiDevis.fieldEmail': 'الإيميل',
    'chatAiDevis.familyAccessoryStock': 'إكسسوار · مخزون',
    'chatAiDevis.familyAccessoryCapped': 'إكسسوار · ≤ 49€',
    'chatAiDevis.familyAccessory': 'إكسسوار',
    'chatAiDevis.familyPart': 'قطعة',
    'chatAiDevis.familyScreen': 'شاشة',
    'chatAiDevis.badgeFallback': 'سعر تقديري (احتياطي)',
    'chatAiDevis.badgeModelScore': 'درجة المطابقة {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'درجة المطابقة',
    'chatAiDevis.badgeNeedsReview': 'لازم تتأكّد منها',
    'chatAiDevis.altOtherParts': 'قطع تانية (كل المورّدين)',
    'chatAiDevis.altSelected': 'المختارة',
    'chatAiDevis.useBtn': 'استخدم',
    'chatAiDevis.compareTitle': 'مقارنة Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'الحالي:',
    'chatAiDevis.htSuffix': 'بدون ضريبة',
    'chatAiDevis.compareNoneFound': 'ما في ولا قطعة عند المورّدين التلاتة.',
    'chatAiDevis.colSupplier': 'المورّد',
    'chatAiDevis.colPart': 'القطعة',
    'chatAiDevis.colPurchaseHt': 'الشرا بدون ضريبة',
    'chatAiDevis.colTtcEst': 'شامل الضريبة (تقديري)',
    'chatAiDevis.colStock': 'المخزون',
    'chatAiDevis.colExactModel': 'الموديل المطابق',
    'chatAiDevis.badgeCheapest': 'الأرخص',
    'chatAiDevis.badgeCurrent': 'الحالي',
    'chatAiDevis.scoreInline': 'درجة {{score}}',
    'chatAiDevis.compareNoResultFor': 'بدون نتيجة: {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'طلب CADBOT — كاش المورّد فاضي. حطّ سعر الشرا بدون ضريبة وبعدين اضغط تحقّق لترسل عرض السعر.',
    'chatAiDevis.purchaseMissingZero': 'سعر الشرا ناقص (0 €) — حدِّث القطعة أو حطّ سعر الشرا بإيدك.',
    'chatAiDevis.supplierPrimary': 'رئيسي',
    'chatAiDevis.supplierAlternate': 'بديل',
    'chatAiDevis.defaultRepair': 'تصليح',
    'chatAiDevis.defaultPart': 'قطعة',
    'chatAiDevis.defaultClient': 'الزبون',
    'chatAiDevis.identityIncompleteInline': 'بيانات الزبون ناقصة ({{fields}}) — لازمة قبل التحقّق',
    'chatAiDevis.willSendTo': 'رح يتبعت عرض السعر لـ {{email}}',
    'chatAiDevis.phName': 'الاسم الكامل *',
    'chatAiDevis.phPhone': 'التلفون *',
    'chatAiDevis.phEmail': 'الإيميل *',
    'chatAiDevis.saveIdentityBtn': 'احفظ بيانات الزبون',
    'chatAiDevis.ttcCalcul': 'شامل الضريبة · /calcul',
    'chatAiDevis.selectedPart': 'القطعة المختارة',
    'chatAiDevis.purchasePriceHt': 'سعر الشرا بدون ضريبة',
    'chatAiDevis.labor': 'أجرة الشغل',
    'chatAiDevis.recalcTotal': 'إعادة حساب المجموع',
    'chatAiDevis.hideCompare': 'خبّي المقارنة',
    'chatAiDevis.compareBtn': 'قارن Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'عرض البدائل (قائمة)',
    'chatAiDevis.hideAlternatives': 'خبّي البدائل (قائمة)',
    'chatAiDevis.botStaff': 'بوت الموظفين',
    'chatAiDevis.bestPartAuto': 'أحسن قطعة (تلقائي)',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'تحقّق (لحاله)',
    'chatAiDevis.reject': 'رفض',
    'chatAiDevis.print': 'اطبع',
    'chatAiDevis.dirAdminTitle': 'الإدارة / أدمن المحل',
    'chatAiDevis.delete': 'احذف',
    'chatAiDevis.approvedShort': 'تم التحقّق',
    'chatAiDevis.rejectedShort': 'مرفوض',
    'chatAiDevis.batchLabel': 'دفعة {{count}} عروض سعر',
    'chatAiDevis.clientChat': 'شات الزبون',
    'chatAiDevis.approveAllSend': 'تحقّق من الـ {{count}} وابعت',
    'chatAiDevis.deleteBatch': 'احذف الدفعة',
    'chatAiDevis.pageTitle': 'عروض الأسعار بالذكاء الاصطناعي — التحقّق',
    'chatAiDevis.pageSubtitle': '4 خيارات لكل طلب شاشة · InCell · OLED · مجدّد · أصلي',
    'chatAiDevis.filterPending': 'قيد الانتظار',
    'chatAiDevis.filterApproved': 'تم التحقّق منها',
    'chatAiDevis.filterRejected': 'مرفوضة',
    'chatAiDevis.filterAll': 'الكل',
    'chatAiDevis.infoTitle': 'الدردشة بالذكاء الاصطناعي و Auto-Devis — المورّدين',
    'chatAiDevis.infoJensPrimary': 'هو المورّد الرئيسي (الأولوية بالتقييم).',
    'chatAiDevis.infoAnd': 'و',
    'chatAiDevis.infoMobilaxLcd': 'منرجعلهم إذا في تطابق أحسن أو إذا Jens ما عندها القطعة.',
    'chatAiDevis.infoEachRange': 'كل فئة (InCell، OLED، إلخ) ممكن تجي من مورّد مختلف — راجعها قبل التحقّق.',
    'chatAiDevis.infoCompareExplain': '«قارن Jens / Mobilax / LCD-Phone» بيعرض سعر الشرا بدون ضريبة، والإجمالي الشامل للضريبة التقديري، والمخزون، والموديل المطابق عند كل مورّد — «استخدم» بيبدّل المسودّة.',
    'chatAiDevis.infoBadgesLabel': 'الشارات:',
    'chatAiDevis.infoBadgesCheck': '— افحص القطعة قبل التحقّق.',
    'chatAiDevis.infoBotStaffExplain': '(اللوحة عاليمين) — وصّف تصليح لإنشاء المسودّات، أو اكتب «comparer» لتشوف كل المورّدين.',
    'chatAiDevis.loading': 'عم يحمّل…',
    'chatAiDevis.noQuotesPending': 'ما في عروض أسعار قيد الانتظار.',
    'chatAiDevis.noQuotes': 'ما في عروض أسعار.',
    'chatAiDevis.emptyHint': 'استخدم بوت Auto-Devis عاليمين لتنشئ واحد (مثال: «شاشة iPhone 14»).',
    'chatAiDevis.backToStaff': '→ رجوع لمساحة الموظفين',
    'chatAiDevis.botAutoDevis': 'بوت Auto-Devis',
    'chatAiDevis.staffSpace': '→ مساحة الموظفين',
    'chatAiDevis.errPdfPreview': 'خطأ بمعاينة PDF',
    'chatAiDevis.alertPurchaseMissingPrint': 'سعر الشرا ناقص — حطّ سعر أو حدِّث القطعة قبل الطباعة.',
    'chatAiDevis.errPrintTicket': 'خطأ بطباعة تذكرة 80mm',
    'chatAiDevis.errRecalc': 'خطأ بإعادة الحساب',
    'chatAiDevis.errPartNotFound': 'القطعة مو موجودة بكاش المورّد',
    'chatAiDevis.errCompare': 'خطأ بمقارنة المورّدين',
    'chatAiDevis.errAlternatives': 'خطأ بتحميل البدائل',
    'chatAiDevis.errSaveIdentity': 'خطأ بحفظ بيانات الزبون',
    'chatAiDevis.alertIdentityIncomplete': 'بيانات الزبون ناقصة: {{fields}}. الاسم والتلفون والإيميل لازمين قبل ما تتحقّق وتبعت عرض السعر.',
    'chatAiDevis.mailWillSend': 'رح يتبعت إيميل مع ملف PDF لـ: {{email}}',
    'chatAiDevis.noClientEmail': '(ما في إيميل للزبون — التحقّق بس عبر الشات)',
    'chatAiDevis.confirmApprove': 'بدك تتحقّق من عرض السعر هاد وتبعتو للزبون؟',
    'chatAiDevis.sumupWarn': 'انتبه: ما قدر ينعمل رابط الدفع SumUp ({{error}}). زر الإيميل رح يعرض الدفع لما تدوس عليه؛ تأكّد من مفتاح SumUp API بالإعدادات.',
    'chatAiDevis.sumupUnavailable': 'SumUp مو متاح',
    'chatAiDevis.approvedMailSent': 'تم التحقّق من عرض السعر — انبعت الإيميل لـ {{email}}.',
    'chatAiDevis.approvedSent': 'تم التحقّق من عرض السعر وانبعت للزبون.',
    'chatAiDevis.errApprove': 'خطأ بالتحقّق',
    'chatAiDevis.confirmApproveBatch': 'بدك تتحقّق من الـ {{count}} عروض سعر وتبعت الملخّص للزبون؟',
    'chatAiDevis.batchApproved': 'تم التحقّق من {{count}} عروض سعر وانبعتت للزبون.',
    'chatAiDevis.errApproveBatch': 'خطأ بالتحقّق من الدفعة',
    'chatAiDevis.promptRejectReason': 'سبب الرفض (اختياري):',
    'chatAiDevis.errGeneric': 'خطأ',
    'chatAiDevis.confirmDeleteDevis': 'بدك تحذف عرض السعر {{ref}} نهائيًا؟\n\nما في رجعة.',
    'chatAiDevis.errDelete': 'خطأ بالحذف',
    'chatAiDevis.confirmDeleteBatch': 'بدك تحذف الـ {{count}} عروض سعر يلي بالدفعة نهائيًا؟\n\nما في رجعة.',
    'chatAiDevis.errDeleteBatch': 'خطأ بحذف الدفعة',
    'saLayout.nav_dashboard': 'لوحة التحكم',
    'saLayout.nav_analytics': 'التحليلات',
    'saLayout.nav_companies': 'الشركات',
    'saLayout.nav_subscriptions': 'الاشتراكات',
    'saLayout.nav_users': 'المستخدمين',
    'saLayout.nav_stats': 'الإحصائيات',
    'saLayout.nav_communications': 'المراسلات',
    'saLayout.nav_impersonation': 'وضع الدعم',
    'saLayout.nav_config': 'الإعدادات',
    'saLayout.nav_integrations': 'تكاملات API',
    'saLayout.nav_security': 'الأمان (المصادقة الثنائية)',
    'saLayout.nav_logs': 'السجل والتدقيق',
    'saLayout.super_admin': 'المشرف الأعلى',
    'saLayout.role_super_admin': 'المشرف الأعلى',
    'saLayout.logout': 'تسجيل الخروج',
    'saLayout.top_bar_title': 'لوحة المشرف الأعلى',
    'saConfig.error': 'خطأ',
    'saConfig.confirmMaintenance': 'بدّك تفعّل وضع الصيانة؟ الزباين ما رح يقدروا يدخلوا عالمنصة بعد هلق.',
    'saConfig.title': 'الإعدادات',
    'saConfig.subtitle': 'الإعدادات العامة للمنصة',
    'saConfig.saved': 'تم الحفظ',
    'saConfig.saving': 'عم يُحفظ...',
    'saConfig.save': 'حفظ',
    'saConfig.maintenanceTitle': 'وضع الصيانة',
    'saConfig.maintenanceDesc': 'منع دخول الزباين مؤقتًا',
    'saConfig.generalSettings': 'الإعدادات العامة',
    'saConfig.platformName': 'اسم المنصة',
    'saConfig.gracePeriod': 'فترة السماح (أيام)',
    'saConfig.plans': 'خطط الأسعار',
    'saConfig.planPrice': 'السعر (يورو/شهر)',
    'saConfig.maxShops': 'الحد الأقصى للمحلات',
    'saConfig.maxUsers': 'الحد الأقصى للمستخدمين',
    'saConfig.features': 'الميزات',
    'saImpersonation.title': 'وضع الدعم (انتحال الهوية)',
    'saImpersonation.subtitle': 'الدخول مؤقتًا على حساب شركة',
    'saImpersonation.confirmEnter': 'بدّك تفوت على وضع الدعم لهالشركة؟',
    'saImpersonation.errorGeneric': 'خطأ',
    'saImpersonation.activeBannerTitle': 'وضع الدعم شغّال',
    'saImpersonation.connectedAs': 'فايت باسم: {{name}}',
    'saImpersonation.stopSupport': 'اطلع من وضع الدعم',
    'saImpersonation.warningTitle': 'انتبه — خاصية حساسة',
    'saImpersonation.warningText': 'انتحال الهوية بيعطيك دخول كامل على حساب العميل. كل إجراءاتك بتتسجّل. كلمة سر العميل ما رح تتغيّر أبدًا.',
    'saImpersonation.searchPlaceholder': 'دوّر عن شركة...',
    'saImpersonation.emptyList': 'ما في ولا شركة',
    'saImpersonation.companyMeta': '{{email}} - الباقة {{plan}}',
    'saImpersonation.enterBtn': 'فوت',
    'saPackages.title': 'إدارة الحزم',
    'saPackages.subtitle': 'بدّل مباشرةً ملفات ZIP ووكيل Windows يلّي منقدّمن بالإنتاج.',
    'saPackages.refresh': 'تحديث',
    'saPackages.statAvailable': 'العناصر المتوفّرة',
    'saPackages.statTotalSize': 'الحجم الكلّي',
    'saPackages.statAlert': 'تنبيه',
    'saPackages.alertText': 'الاستبدالات بتكتب فوق الملف المباشر. ما في حذف منفصل.',
    'saPackages.statusAvailable': 'متوفّر',
    'saPackages.statusMissing': 'مفقود',
    'saPackages.download': 'تنزيل',
    'saPackages.activeFile': 'الملف الفعّال',
    'saPackages.size': 'الحجم',
    'saPackages.lastUpdate': 'آخر تحديث',
    'saPackages.uploadedBy': 'مرفوع من قِبل',
    'saPackages.replaceLiveFile': 'استبدال الملف المباشر',
    'saPackages.uploading': 'عم يترفّع…',
    'saPackages.replace': 'استبدال',
    'saPackages.replaceHint': 'الملف المختار بيحلّ مباشرةً محلّ الملف يلّي منقدّمو للمستخدمين على remobiles.com.',
    'saPackages.selectedFile': 'الملف المحدَّد: {{name}}',
    'saPackages.errorLoad': 'خطأ بتحميل الملفات',
    'saPackages.downloadLinkUnavailable': 'رابط التنزيل مو متاح',
    'saPackages.downloadFailed': 'ما قدرنا ننزّل',
    'saPackages.selectFileFor': 'اختار ملف لـ {{label}}.',
    'saPackages.confirmReplace': 'بدّك تستبدل {{label}} هلّق بـ {{name}}؟',
    'saPackages.replaceSuccess': 'انستبدل {{label}} بنجاح.',
    'saPackages.errorUpload': 'خطأ وقت الرفع',
    'saPackages.superAdminOnly': 'الوصول لمسؤول النظام الأعلى بس',
    'saPackages.superAdminDesc': 'هالصفحة بتسمحلك تحدّث الملفات يلّي منقدّما حاليًا remobiles.com. روابط التنزيل العامة بتضلّ مُدارة عن طريق المسارات الموقّعة بالـ backend.',
    'saDashboard.title': 'لوحة التحكم',
    'saDashboard.subtitle': 'نظرة عامة على منصة {{brand}}',
    'saDashboard.companies': 'الشركات',
    'saDashboard.activeCount': '{{count}} نشطة',
    'saDashboard.users': 'المستخدمين',
    'saDashboard.shops': 'المحلات',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'الإيراد الشهري المتكرر',
    'saDashboard.newThisMonth': 'جديدة هالشهر',
    'saDashboard.expired': 'منتهية',
    'saDashboard.suspended': 'موقوفة',
    'saDashboard.recentCompanies': 'آخر الشركات',
    'saDashboard.viewAll': 'عرض الكل',
    'saDashboard.noCompanies': 'ما في شركات لسا',
    'saDashboard.recentActivity': 'آخر النشاطات',
    'saDashboard.noActivity': 'ما في نشاط حديث',
    'saAnalytics.title': 'تحليلات المنصة',
    'saAnalytics.subtitle': 'المؤشرات العامة والأداء حسب الشركة',
    'saAnalytics.kpiRepairsToday': 'التصليحات اليوم',
    'saAnalytics.kpiActiveRepairs': 'التصليحات الشغّالة',
    'saAnalytics.kpiRevenueMonth': 'مدخول هالشهر',
    'saAnalytics.kpiClientsTotal': 'مجموع الزباين',
    'saAnalytics.kpiRepairsWeek': 'تصليحات الأسبوع',
    'saAnalytics.kpiRepairsMonth': 'تصليحات الشهر',
    'saAnalytics.kpiRepairsTotal': 'مجموع التصليحات',
    'saAnalytics.kpiRevenueTotal': 'مجموع المدخول',
    'saAnalytics.kpiActiveCompanies': 'الشركات الشغّالة',
    'saAnalytics.companyPerformance': 'الأداء حسب الشركة',
    'saAnalytics.companiesCount': '{{count}} شركة',
    'saAnalytics.emptyCompanies': 'ما في شركات شغّالة',
    'saAnalytics.colCompany': 'الشركة',
    'saAnalytics.colPlan': 'الخطة',
    'saAnalytics.colRepairs': 'التصليحات',
    'saAnalytics.colActive': 'شغّالة',
    'saAnalytics.colClients': 'الزباين',
    'saAnalytics.colStock': 'المخزون',
    'saAnalytics.colSales': 'المبيعات',
    'saAnalytics.colRevenue': 'المدخول',
    'saAnalytics.colAvgTime': 'متوسط الوقت',
    'saAnalytics.daysShort': '{{n}} يوم',
    'saLogs.title': 'السجل والأمان',
    'saLogs.subtitle': 'تدقيق الإجراءات وحالة النظام',
    'saLogs.systemHealth': 'حالة النظام',
    'saLogs.database': 'قاعدة البيانات',
    'saLogs.statusOk': 'تمام',
    'saLogs.statusError': 'خطأ',
    'saLogs.filterAll': 'كل الإجراءات',
    'saLogs.filterCreateCompany': 'إنشاء شركة',
    'saLogs.filterUpdateCompany': 'تعديل شركة',
    'saLogs.filterSuspend': 'تعليق',
    'saLogs.filterActivate': 'إعادة التفعيل',
    'saLogs.filterImpersonate': 'انتحال الهوية',
    'saLogs.filterCreateUser': 'إنشاء مستخدم',
    'saLogs.filterDeleteUser': 'حذف مستخدم',
    'saLogs.filterResetPassword': 'إعادة تعيين كلمة السر',
    'saLogs.filterUpdateSubscription': 'تعديل الاشتراك',
    'saLogs.filterUpdateConfig': 'تعديل الإعدادات',
    'saLogs.entriesCount': '{{count}} إدخال',
    'saLogs.empty': 'ما في إدخالات بالسجل',
    'saLogs.onTarget': 'على {{target}}',
    'saLogs.byUserAt': 'من {{user}} - {{date}}',
    'saComm.title': 'المراسلات',
    'saComm.messagesSent': '{{count}} رسالة مبعوتة',
    'saComm.newMessage': 'رسالة جديدة',
    'saComm.emptyList': 'ما في ولا مراسلة مبعوتة',
    'saComm.noSubject': 'بدون موضوع',
    'saComm.allClients': 'كل الزباين',
    'saComm.companiesCount': '{{count}} شركة',
    'saComm.modalTitle': 'ابعت مراسلة',
    'saComm.typeLabel': 'النوع',
    'saComm.typeNotification': 'إشعار',
    'saComm.typeMaintenance': 'صيانة',
    'saComm.typeUpdate': 'تحديث',
    'saComm.recipients': 'المستلمين',
    'saComm.targetSelected': 'مختارين',
    'saComm.targetedCompanies': 'الشركات المستهدفة',
    'saComm.subjectLabel': 'الموضوع *',
    'saComm.messageLabel': 'الرسالة *',
    'saComm.cancel': 'إلغاء',
    'saComm.send': 'ابعت',
    'saComm.errorGeneric': 'خطأ',
    'saSecurity.pageTitle': 'أمان الحساب',
    'saSecurity.pageSubtitle': 'المصادقة الثنائية (2FA) وتقييد عناوين IP وإعدادات الأمان',
    'saSecurity.errorGeneric': 'خطأ',
    'saSecurity.twoFAEnabledSuccess': 'تم تفعيل المصادقة الثنائية (2FA) بنجاح!',
    'saSecurity.invalidCode': 'الرمز غير صحيح',
    'saSecurity.twoFADisabled': 'تم تعطيل المصادقة الثنائية (2FA)',
    'saSecurity.saveError': 'خطأ أثناء الحفظ',
    'saSecurity.twoFATitle': 'المصادقة الثنائية (2FA)',
    'saSecurity.statusEnabled': 'مفعّل',
    'saSecurity.statusDisabled': 'معطّل',
    'saSecurity.setupBtn': 'إعداد المصادقة الثنائية (2FA)',
    'saSecurity.scanQrInstruction': 'امسح رمز QR هذا باستخدام Google Authenticator:',
    'saSecurity.qrCodeAlt': 'رمز QR',
    'saSecurity.manualKeyInstruction': 'أو أدخل هذا المفتاح يدويًا:',
    'saSecurity.verificationCodeLabel': 'رمز التحقق',
    'saSecurity.verifyBtn': 'تحقق',
    'saSecurity.disableInstruction': 'لتعطيل المصادقة الثنائية (2FA)، أدخل رمزك الحالي:',
    'saSecurity.ipRestrictionTitle': 'تقييد عناوين IP (اختياري)',
    'saSecurity.ipRestrictionSubtitle': 'تقييد وصول المشرف العام إلى عناوين IP معيّنة',
    'saSecurity.ipPlaceholder': 'عنوان IP واحد بكل سطر (مثال: 192.168.1.1)',
    'saSecurity.saved': 'تم الحفظ',
    'saSecurity.save': 'حفظ',
    'saStats.title': 'إحصائيات الأعمال',
    'saStats.subtitle': 'تحليلات وتوقعات مالية',
    'saStats.mrrTitle': 'الإيرادات الشهرية المتكررة (MRR)',
    'saStats.planDistTitle': 'توزيع الخطط',
    'saStats.emptyData': 'ما في بيانات',
    'saStats.churnTitle': 'معدل إلغاء الاشتراك (Churn)',
    'saStats.cancelledCount': '{{count}} إلغاء',
    'saStats.growthTitle': 'النمو - شركات جديدة',
    'repairUi.repairs': 'التصليحات',
    'repairUi.repairSheet': 'بطاقة التصليح',
    'repairUi.edit': 'تعديل',
    'repairUi.print': 'طباعة',
    'repairUi.backToRepairs': 'رجوع للتصليحات',
    'repairUi.editRepair': 'تعديل التصليح',
    'repairUi.newDeposit': 'إيداع جديد',
    'repairUi.ref': 'مرجع',
    'saSubscriptions.title': 'الاشتراكات',
    'saSubscriptions.count': '{{count}} اشتراك',
    'saSubscriptions.filter_all_statuses': 'كل الحالات',
    'saSubscriptions.filter_all_plans': 'كل الخطط',
    'saSubscriptions.status_active': 'نشط',
    'saSubscriptions.status_suspended': 'موقوف',
    'saSubscriptions.status_expired': 'منتهي',
    'saSubscriptions.status_overdue': 'متأخر',
    'saSubscriptions.status_cancelled': 'ملغى',
    'saSubscriptions.col_company': 'الشركة',
    'saSubscriptions.col_plan': 'الخطة',
    'saSubscriptions.col_price': 'السعر',
    'saSubscriptions.col_status': 'الحالة',
    'saSubscriptions.col_next_billing': 'الفوترة الجاية',
    'saSubscriptions.col_discount': 'الحسم',
    'saSubscriptions.col_actions': 'إجراءات',
    'saSubscriptions.empty': 'ما في اشتراكات',
    'saSubscriptions.action_edit': 'تعديل',
    'saSubscriptions.action_extend': 'تمديد',
    'saSubscriptions.modal_title': 'تعديل الاشتراك',
    'saSubscriptions.label_discount': 'الحسم (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'إلغاء',
    'saSubscriptions.save': 'حفظ',
    'saSubscriptions.prompt_extend_days': 'كم يوم بدك تضيف:',
    'saSubscriptions.error': 'خطأ',
    'saUsers.title': 'المستخدمين',
    'saUsers.totalUsers': '{{count}} مستخدم',
    'saUsers.newUser': 'مستخدم جديد',
    'saUsers.searchPlaceholder': 'بحث...',
    'saUsers.filterAllRoles': 'كل الأدوار',
    'saUsers.roleSuperAdmin': 'مدير عام',
    'saUsers.roleAdmin': 'مدير',
    'saUsers.roleUser': 'موظف',
    'saUsers.roleTechnicien': 'فني',
    'saUsers.roleClient': 'زبون',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'ما في مستخدمين',
    'saUsers.colUser': 'المستخدم',
    'saUsers.colRole': 'الدور',
    'saUsers.colCompany': 'الشركة',
    'saUsers.colCreatedAt': 'تاريخ الإنشاء',
    'saUsers.colActions': 'إجراءات',
    'saUsers.resetPassword': 'إعادة تعيين كلمة السر',
    'saUsers.delete': 'حذف',
    'saUsers.labelUsername': 'اسم المستخدم',
    'saUsers.labelEmail': 'الإيميل',
    'saUsers.labelPassword': 'كلمة السر',
    'saUsers.companyNone': 'لا شيء',
    'saUsers.cancel': 'إلغاء',
    'saUsers.create': 'إنشاء',
    'saUsers.labelNewPassword': 'كلمة السر الجديدة',
    'saUsers.reset': 'إعادة تعيين',
    'saUsers.error': 'خطأ',
    'saUsers.resetSuccess': 'تمت إعادة تعيين كلمة السر بنجاح',
    'saUsers.confirmDelete': 'حذف المستخدم {{username}}؟',
    'saCompanies.status_active': 'نشط',
    'saCompanies.status_suspended': 'موقوف',
    'saCompanies.status_overdue': 'متأخر',
    'saCompanies.status_archived': 'مؤرشف',
    'saCompanies.error': 'خطأ',
    'saCompanies.confirm_suspend': 'بدك توقف هالشركة؟',
    'saCompanies.suspend_reason_manual': 'موقوف يدوي',
    'saCompanies.confirm_archive': 'بدك تأرشف هالشركة؟ هالعملية ما بترجع.',
    'saCompanies.reminder_sent': 'انبعت إيميل التذكير',
    'saCompanies.reminder_error': 'صار خطأ وقت الإرسال',
    'saCompanies.title': 'الشركات',
    'saCompanies.total_companies': '{{count}} شركة بالمجمل',
    'saCompanies.new_company': 'شركة جديدة',
    'saCompanies.search_placeholder': 'دوّر...',
    'saCompanies.filter_all_status': 'كل الحالات',
    'saCompanies.filter_overdue': 'متأخر',
    'saCompanies.filter_all_plans': 'كل الخطط',
    'saCompanies.empty': 'ما في ولا شركة',
    'saCompanies.col_company': 'الشركة',
    'saCompanies.col_plan': 'الخطة',
    'saCompanies.col_status': 'الحالة',
    'saCompanies.col_users': 'المستخدمين',
    'saCompanies.col_registered': 'تاريخ التسجيل',
    'saCompanies.col_actions': 'الإجراءات',
    'saCompanies.action_view': 'عرض',
    'saCompanies.action_reminder': 'ابعت تذكير بالدفع',
    'saCompanies.action_suspend': 'إيقاف',
    'saCompanies.action_reactivate': 'إعادة التفعيل',
    'saCompanies.action_archive': 'أرشفة',
    'saCompanies.field_company_name': 'اسم الشركة',
    'saCompanies.field_contact': 'جهة الاتصال الرئيسية',
    'saCompanies.field_email': 'الإيميل',
    'saCompanies.field_phone': 'التلفون',
    'saCompanies.field_address': 'العنوان',
    'saCompanies.field_plan': 'خطة الاشتراك',
    'saCompanies.plan_option_start': 'Start ({{price}}/شهر)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/شهر)',
    'saCompanies.plan_option_super': 'Super ({{price}}/شهر)',
    'saCompanies.field_shop_count': 'عدد المحلات',
    'saCompanies.admin_account': 'حساب مسؤول الشركة',
    'saCompanies.field_admin_email': 'إيميل المسؤول',
    'saCompanies.field_password': 'كلمة السر',
    'saCompanies.field_notes': 'ملاحظات داخلية',
    'saCompanies.cancel': 'إلغاء',
    'saCompanies.create_company': 'إنشاء الشركة',
    'saCompanies.users_count': '{{count}} مستخدم',
    'saCompanies.subscription': 'الاشتراك',
    'saCompanies.monthly_price': 'السعر الشهري',
    'saCompanies.next_billing': 'الفاتورة الجاية',
    'saCompanies.no_users': 'ما في مستخدمين',
    'qrRouter.redirecting': 'عم نحوّلك...',
    'subscriptionPages.verifyingPayment': 'عم نتأكد من الدفع...',
    'subscriptionPages.successTitle': 'تم الدفع بنجاح!',
    'subscriptionPages.successBody': 'اشتراكك صار فعّال هلّق.',
    'subscriptionPages.goToDashboard': 'افتح لوحة التحكم',
    'subscriptionPages.processingPayment': 'عم نعالج الدفع...',
    'subscriptionPages.errorTitle': 'خطأ',
    'subscriptionPages.errorBody': 'ما قدرنا نتأكد من الدفع.',
    'subscriptionPages.backToDashboard': 'ارجع على لوحة التحكم',
    'subscriptionPages.cancelTitle': 'الدفع انلغى',
    'subscriptionPages.cancelBody': 'الدفع انلغى. فيك تجرّب مرة تانية بأي وقت.',
    'common.error': 'خطأ',
    'notes.uploadError': 'في خطأ وقت رفع الملف',
    'notes.downloadError': 'في خطأ وقت التنزيل',
    'notes.confirmDeleteFile': 'بدك تمحي هالملف؟',
    'notes.uploading': 'عم يترفع...',
    'notes.attach': 'إرفاق',
    'notes.addedBy': 'ضافه {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} بايت',
    'notes.sizeKb': '{{size}} ك.ب',
    'notes.sizeMb': '{{size}} م.ب',
    'historique.subtitle': 'المبيعات والفواتير والعرابين',
    'historique.centreActivite': 'مركز النشاط',
    'historique.filtresRecherche': 'الفلاتر والبحث',
    'historique.rechercher': 'بحث',
    'historique.searchPlaceholder': 'منتج، مرجع…',
    'historique.vendeur': 'البائع',
    'historique.tous': 'الكل',
    'historique.dateDebut': 'تاريخ البداية',
    'historique.dateFin': 'تاريخ النهاية',
    'historique.magasin': 'المحل',
    'historique.filtrer': 'فلترة',
    'historique.reinitialiser': 'إعادة تعيين',
    'historique.totalVentes': 'إجمالي المبيعات',
    'historique.totalAcomptes': 'إجمالي العرابين',
    'historique.totalRetraits': 'إجمالي السحوبات',
    'historique.totalGlobal': 'الإجمالي العام',
    'historique.commVentes': 'عمولة المبيعات ({{pct}}%)',
    'historique.commReparations': 'عمولة التصليحات ({{pct}}%)',
    'historique.commCommandes': 'عمولة الطلبات ({{pct}}%)',
    'historique.totalCommissions': 'إجمالي العمولات',
    'historique.popupsAutoriser': 'يرجى السماح بالنوافذ المنبثقة حتى تطبع.',
    'historique.erreurTelechargement': 'صار خطأ أثناء التنزيل',
    'historique.vendeurDatesRequis': 'يرجى إدخال البائع والتواريخ',
    'historique.erreurImpressionRapport': 'خطأ بطباعة التقرير',
    'historique.erreurConfirmationSumup': 'خطأ أثناء تأكيد SumUp',
    'historique.confirmRefusPaiement': 'بدك تعلّم هالدفعة كمرفوضة / ملغاة؟',
    'historique.erreurRefusSumup': 'خطأ أثناء رفض SumUp',
    'dash.forceOpen': 'فتح إجباري',
    'dash.force': 'فرض',
    'dash.forceOpenTitle': 'فرض فتح صندوق {{magasin}}',
    'dash.forceOpenWarning': 'رح ينسكّر أي صندوق مفتوح أوتوماتيكياً، ورح ينفتح صندوق جديد بالمبلغ المحدد.',
    'dash.noOpenCaisseToForce': 'ما في صندوق مفتوح لفرض إغلاقه بـ {{magasin}}.',
    'dash.thisMagasin': 'هالمحل',
    'dash.statusOpenF': 'مفتوح',
    'dash.statusClosedF': 'مسكّر',
    'dash.openMagasin': 'فتح {{magasin}}',
    'dash.forceOpenShort': 'فرض الفتح',
    'dash.closeMagasin': 'سكّر {{magasin}}',
    'dash.forceCloseShort': 'فرض الإغلاق',
    'dash.subtitleNetwork': 'عرض الشبكة · الصندوق · المؤشرات',
    'dash.subtitleWorkshop': 'الورشة · التصليحات',
    'dash.subtitleDefault': 'لوحة التحكم · المبيعات والنشاط',
    'dash.caisseActionsByStore': 'إجراءات الصندوق حسب المحل',
    'devisFactures.printPopupBlocked': 'لازم تسمح بالنوافذ المنبثقة حتى تقدر تطبع.',
    'devisFactures.errorPrintTicket': 'خطأ بطباعة الإيصال',
    'devisFactures.errorPrintA4': 'خطأ بطباعة A4',
    'devisFactures.errorConvert': 'خطأ بتحويل الطلب',
    'devisFactures.errorDelete': 'خطأ بالحذف',
    'devisFactures.errorInvalidEmail': 'عنوان إيميل غلط',
    'devisFactures.emailSent': 'انبعت {{type}} لـ {{email}}',
    'devisFactures.errorSendEmail': 'خطأ بإرسال الإيميل',
    'devisFactures.linkedTo': 'مربوط بـ {{ref}}',
    'devisFactures.sendByEmail': 'ابعت بالإيميل',
    'devisFactures.detachConfirm': 'بدك تفصل هالعرض عن {{ref}}؟',
    'devisFactures.error': 'خطأ',
    'devisFactures.attachToRepair': 'اربطه بتصليح',
    'devisFactures.emailModalTitle': 'ابعت {{type}} بالإيميل',
    'devisFactures.refLabel': 'المرجع:',
    'devisFactures.a4PdfNote': 'رح ينبعت المستند بصيغة PDF قياس A4',
    'devisFactures.clientEmailLabel': 'إيميل الزبون',
    'devisFactures.emailPlaceholder': 'client@example.com',
    'devisFactures.labelDevis': 'عرض سعر',
    'devisFactures.labelFacture': 'فاتورة',
    'devisFactures.labelCommande': 'طلب',
    'devisFactures.labelAvoir': 'إشعار دائن',
    'devisFactures.labelPaye': 'مدفوع',
    'devisFactures.labelAnnule': 'ملغي',
    'devisFactures.labelEnAttente': 'قيد الانتظار',
    'clients.tabPins': 'رموز PIN / كلمات السر',
    'clients.pin': 'رمز PIN',
    'clients.error': 'خطأ',
    'clients.loadError': 'خطأ أثناء التحميل',
    'clients.saveError': 'خطأ أثناء الحفظ',
    'clients.sendError': 'خطأ بالإرسال',
    'clients.noIdLegacy': 'هالزبون ما إلو معرّف (قديم). عدّلو حتى ينحدث.',
    'clients.ficheAccessDenied': 'ممنوع الدخول: بس المسؤول فيه يشوف بطاقة الزبون.',
    'clients.pinGenerated': 'تم توليد رمز PIN {{pin}} لـ {{nom}}',
    'clients.ficheClient': 'بطاقة الزبون',
    'clients.optional': 'اختياري',
    'clients.genNewPin': 'إنشاء رمز PIN جديد',
    'clients.sendPinEmail': 'إرسال رمز PIN عالإيميل',
    'clients.loyaltyLine': 'الولاء: {{level}} — {{points}} نقطة — {{purchases}} عملية شراء',
    'clients.repairs': 'التصليحات',
    'clients.commandes': 'الطلبات',
    'clients.devis': 'عروض الأسعار',
    'clients.ventesPos': 'مبيعات نقطة البيع',
    'clients.acomptes': 'العربون',
    'clients.noneFem': 'ما في',
    'clients.noneMasc': 'ما في',
    'cmd.clientPartsTitle': 'طلبات قطع الزبائن',
    'cmd.pageIntro': 'ضيف القطع (من المخزون أو للطلب) متل بالتصليح. الدفعات المقدمة بتتخصم من المجموع.',
    'cmd.deposits': 'الدفعات المقدمة',
    'cmd.remainingShort': 'الباقي',
    'cmd.statusConverting': 'عم يتحوّل',
    'cmd.repairBadge': 'تصليح {{ref}}',
    'cmd.toOrderShort': 'للطلب',
    'cmd.stockOutShort': 'طلع من المخزون',
    'cmd.inStockShort': 'بالمخزون',
    'cmd.view': 'شوف',
    'cmd.addDeposit': '+ دفعة',
    'cmd.settled': 'مسدّد',
    'cmd.convertToRepair': 'حوّل لتصليح',
    'cmd.trackingWith': 'التتبّع: {{num}}',
    'cmd.trackingNumber': 'رقم التتبّع',
    'cmd.newClientParts': 'طلب قطع جديد',
    'cmd.partsSectionTitle': 'القطع (متل بالتصليح)',
    'cmd.searchStockPlaceholder': 'دوّر على قطعة بالمخزون…',
    'cmd.noRef': 'بدون مرجع',
    'cmd.toOrder': 'للطلب',
    'cmd.stock': 'مخزون',
    'cmd.qtyShort': 'الكمية',
    'cmd.unitPriceLabel': 'سعر الوحدة (€)',
    'cmd.stockSection': 'المخزون',
    'cmd.alreadyOut': 'تم إخراجها من المخزون',
    'cmd.decrementOnSave': 'بينخصم وقت الحفظ',
    'cmd.stillInStock': 'لسا بالمخزون',
    'cmd.outOnConvert': 'بتطلع وقت التحويل لتصليح',
    'cmd.addPendingBtn': 'قطعة للطلب (مو بالمخزون)',
    'cmd.pendingTitle': 'قطعة للطلب',
    'cmd.designationPlaceholder': 'التسمية *',
    'cmd.refOptPlaceholder': 'المرجع (اختياري)',
    'cmd.salePricePlaceholder': 'سعر البيع €',
    'cmd.partsTotal': 'مجموع القطع',
    'cmd.depositsPaid': 'الدفعات المقدمة المدفوعة',
    'cmd.addDepositTitle': 'ضيف دفعة مقدمة',
    'cmd.orderLabel': 'طلب',
    'cmd.alreadyPaid': 'المدفوع',
    'cmd.depositAmount': 'مبلغ الدفعة المقدمة (€)',
    'cmd.paymentMode': 'طريقة الدفع',
    'cmd.payCash': 'كاش',
    'cmd.payCard': 'بطاقة',
    'cmd.payTransfer': 'حوالة',
    'cmd.payCheck': 'شيك',
    'cmd.newRemainingAfter': 'الباقي الجديد بعد الدفعة:',
    'cmd.depositsPaidTitle': 'الدفعات المقدمة المدفوعة',
    'cmd.noDeposits': 'ما في دفعات مقدمة',
    'cmd.trackingPlaceholder': 'مثلاً: 8R123456789FR',
    'cmd.trackingEmailNote': 'رح ينبعت إيميل للزبون إذا في إيميل مسجّل.',
    'cmd.error': 'خطأ',
    'cmd.errDesignationRequired': 'لازم تسمية للقطعة يلي بدك تطلبها',
    'cmd.errClientPhoneRequired': 'الزبون والتلفون مطلوبين',
    'cmd.errAddPart': 'ضيف قطعة وحدة عالأقل (بحث بالمخزون أو قطعة للطلب)',
    'cmd.errDelete': 'صار خطأ وقت الحذف',
    'cmd.cancelConfirm': 'تلغي هالطلب؟',
    'cmd.errInvalidAmount': 'مبلغ مو صحيح',
    'cmd.errDepositExceeds': 'الدفعة المقدمة ما بتقدر تتجاوز الباقي ({{reste}})',
    'cmd.errPrintTicket': 'خطأ بطباعة الإيصال',
    'cmd.errPrintDepositTicket': 'خطأ بطباعة إيصال الدفعة المقدمة',
    'cmd.convertConfirm': 'تحوّل هالطلب لتصليح؟',
    'cmd.errConvert': 'خطأ بالتحويل لتصليح',
    'cmd.promptClientEmail': 'إيميل الزبون:',
    'cmd.emailSent': 'انبعت سند الطلب لـ {{email}}',
    'cmd.errSendEmail': 'خطأ بإرسال الإيميل',
    'cmd.errTracking': 'خطأ بالتتبّع',
    'pos.insufficientStock': 'المخزون مو كافي',
    'pos.partialPaymentConfirm': 'المبلغ المدفوع ({{paid}}) أقل من المجموع ({{total}}).\n\nالباقي للدفع: {{remaining}}\n\nبدك تأكّد كدفعة جزئية؟',
    'pos.loyaltyRewardEarned': '\n\nالولاء: مبروك! انفتحت المكافأة! خصم 15% عالشرية الجاية أو 10% عالتصليح الجاي!',
    'pos.loyaltyRewardPending': '\n\nالولاء: في مكافأة مستنية (خصم 15% عالشرية الجاية من الكاشير أو 10% عتصليح)',
    'pos.loyaltyProgress': '\n\nالولاء: {{points}}/10 مشتريات. باقي {{remaining}} شرية قبل المكافأة!',
    'pos.partialPaymentLine': '\nدفعة جزئية - الباقي للدفع: {{remaining}}',
    'pos.invoiceSentAuto': '\nانبعتت الفاتورة تلقائيًا لـ {{email}}',
    'pos.offlineSaleMsg': '\n\nوضع بدون إنترنت - انحفظ البيع محليًا.\nرح تصير المزامنة تلقائيًا أول ما يرجع الإنترنت.\n(إرسال الإيميل وتحديث المخزون رح يصيرو وقتها.)',
    'pos.refLabel': 'المرجع: {{ref}}',
    'pos.totalLabel': 'المجموع: {{total}}',
    'pos.saleError': 'صار خطأ وقت البيع.\nرمز HTTP: {{code}}\nيمكن ما انحفظ البيع. دقّق بالسجل.',
    'pos.unknownStatus': 'مجهول',
    'pos.invalidEmailEnter': 'لو سمحت دخّل إيميل صحيح',
    'pos.accountCreated': 'انعمل حساب الزبون! انبعتت بيانات الدخول عالإيميل.',
    'pos.accountCreateError': 'صار خطأ وقت إنشاء الحساب',
    'pos.invalidAmount': 'مبلغ غلط',
    'pos.acompteDesignation': 'عربون تصليح {{ref}}',
    'pos.designationPriceRequired': 'لازم الوصف والسعر',
    'pos.manualAddError': 'خطأ بالإضافة اليدوية',
    'pos.adminValidationFailed': 'فشل تأكيد المسؤول',
    'pos.printTicketError': 'خطأ بطباعة الإيصال',
    'pos.notAllTicketsPrintedConfirm': '⚠️ ما طبعت كل الإيصالات.\n\nلازم الزبون ياخد كل إيصال. بدك تسكّر ع كل حال؟',
    'pos.invalidEmail': 'إيميل غلط',
    'pos.invoiceSentTo': 'انبعتت الفاتورة لـ {{email}}',
    'pos.sendEmailError': 'خطأ بإرسال الإيميل',
    'pos.caisseClosedOffline': 'الصندوق مسكّر. وصّل عالإنترنت وافتح الصندوق من لوحة التحكّم حتى تبيع.',
    'pos.caisseCachedHint': 'انجابت حالة الصندوق من الكاش المحلي (وضع بدون إنترنت). التأكّد النهائي رح يصير أول ما يرجع الإنترنت.',
    'pos.catalog': 'الكتالوج',
    'pos.available': '{{count}} متوفّر',
    'pos.outOfStockShort': 'خلص',
    'pos.acompteRepair': 'عربون تصليح',
    'pos.rewardAvailable': 'المكافأة جاهزة!',
    'pos.rewardAutoApplied': '-15% متطبّق تلقائيًا',
    'pos.purchases': 'مشتريات',
    'pos.beforeReward': '({{count}} قبل المكافأة)',
    'pos.searchClientPlaceholder': 'دوّر...',
    'pos.clientName': 'اسم الزبون',
    'pos.phone': 'التلفون',
    'pos.emailOptional': 'الإيميل (اختياري)',
    'pos.totalCaps': 'المجموع',
    'pos.willGenerateTickets': 'هالبيع رح يطلّع {{count}} إيصالات منفصلة:',
    'pos.neutralItems': 'محايدة',
    'pos.attachedToSession': '(مربوطة بالجلسة)',
    'pos.clientEmailPlaceholder': 'إيميل الزبون',
    'pos.sent': 'انبعت',
    'pos.send': 'ابعت',
    'pos.alsoAddToStock': 'ضيفو كمان عالمخزون',
    'pos.offlineCbHint': 'وضع بدون إنترنت — الدفع بالبطاقة مطفّي (الجهاز بدو شبكة).',
    'pos.whichMagasinTitle': 'بأي محل بدنا نسجّل البيع؟',
    'pos.close': 'سكّر',
    'pos.magasinChoiceHelp': 'اختار المحل يلي رح ينسجّل فيه هالبيع. المحل يلي بتختارو رح ينستخدم للبيع وللأصناف يلي ما إلها محل محدّد.',
    'pos.magasinLabel': 'المحل {{code}}',
    'pos.currentPosSessionFull': 'جلسة الكاشير الحالية: {{code}}. إذا اخترت محل تاني، جلسة الكاشير رح تتحوّل عليه لهالبيع.',
    'pos.validateFor': 'أكّد لـ {{magasin}}',
    'pos.createClientAccount': 'نعمل حساب زبون؟',
    'pos.createAccountPrompt': 'هالزبون لسا ما عندو حساب. بدك تعملّو حساب حتى يوصل لفواتيرو أونلاين؟',
    'pos.creating': 'عم ينعمل...',
    'pos.yesSendCredentials': 'إي، ابعت بيانات الدخول',
    'pos.noThanks': 'لأ، شكرًا',
    'pos.searchRepair': 'دوّر عالتصليح',
    'pos.searchRepairPlaceholder': 'REP0047، اسم الزبون، الموديل...',
    'pos.priceLabel': 'السعر: {{price}}',
    'pos.alreadyPaid': 'المدفوع من قبل: {{amount}}',
    'pos.remainingDue': 'الباقي المستحق: {{amount}}',
    'pos.changeSelection': 'غيّر',
    'pos.totalPrice': 'السعر الكلي',
    'pos.alreadyPaidShort': 'المدفوع من قبل',
    'pos.remainingDueShort': 'الباقي المستحق',
    'pos.acompteAmountLabel': 'مبلغ العربون (يورو)',
    'pos.addToCart': 'ضيفو عالسلة',
    'pos.saleRecordedTickets': 'انسجّل البيع — انعملو {{count}} إيصالات',
    'pos.printAllForClient': 'اطبع الـ {{count}} إيصالات للزبون.',
    'pos.printed': 'انطبع',
    'pos.scanToFind': 'امسح حتى تلاقي {{ref}}',
    'pos.detailUnavailable': 'التفاصيل مو متوفّرة (وضع بدون إنترنت؟)',
    'pos.payment': 'الدفع',
    'pos.printing': 'عم يطبع...',
    'pos.printTicketFor': 'اطبع إيصال {{magasin}}',
    'pos.allTicketsSentToPrint': 'انبعتو كل الإيصالات عالطباعة.',
    'pos.ticketsPrintedCount': 'انطبع {{printed}} / {{total}} إيصال.',
    'pos.printAllTickets': 'اطبع كل الإيصالات',
    'pos.articlesCount': '{{count}} غرض',
    'activite.pageTitle': 'مركز النشاط',
    'activite.pageSubtitle': 'مخطط زمني موحّد · المبيعات · الدفعات · الصندوق · المخزون · التصليحات',
    'activite.historiqueDetaille': 'السجل المفصّل',
    'remcaches.err_connexion': 'خطأ بالاتصال بالسيرفر',
    'remcaches.err_champs_requis': 'اسم المستخدم ورمز PIN ضروريين',
    'remcaches.err_pin_court': 'لازم رمز PIN يكون فيه 4 أرقام على الأقل',
    'remcaches.err_creation': 'صار خطأ وقت الإنشاء',
    'remcaches.config_initiale': 'الإعداد الأولي',
    'remcaches.deja_config': 'الإعداد خلص من قبل',
    'remcaches.admin_existe': 'في مسؤول موجود من قبل. هالصفحة متوقفة.',
    'remcaches.aller_connexion': 'روح لتسجيل الدخول',
    'remcaches.admin_cree': 'تم إنشاء المسؤول بنجاح!',
    'remcaches.label_utilisateur': 'المستخدم:',
    'remcaches.label_role': 'الدور:',
    'remcaches.conserver_identifiants': 'خبّي هالبيانات بمكان آمن. هالصفحة ما رح تضل متاحة.',
    'remcaches.se_connecter': 'تسجيل الدخول',
    'remcaches.label_username': 'اسم المستخدم *',
    'remcaches.ph_username': 'مثلاً: carlos',
    'remcaches.label_pin': 'رمز PIN (كلمة السر) *',
    'remcaches.ph_pin': 'من 4 لـ 6 أرقام',
    'remcaches.label_email': 'الإيميل (اختياري)',
    'remcaches.label_telephone': 'التليفون (اختياري)',
    'remcaches.btn_creer_admin': 'إنشاء المسؤول',
    'remcaches.footer': 'R.E.Mobiles - إعداد آمن',
    'blog.page_title': 'مدوّنة تصليح الموبايلات',
    'blog.subtitle': 'نصائح وحيَل وأخبار عن تصليح الموبايلات بغويانا الفرنسية.',
    'blog.cta_title': 'بدّك تصليح؟',
    'blog.cta_desc': 'تواصل مع Resurrection Mobile لعرض سعر مجاني.',
    'blog.loading': 'عم يحمّل...',
    'blog.article_not_found': 'المقال مو موجود',
    'blog.back_to_blog': 'رجوع عالمدوّنة',
    'blog.home': 'الرئيسية',
    'blog.see_pricing': 'شوف أسعارنا',
    'blog.footer_pricing': 'أسعارنا',
    'blog.empty_title': 'ما في مقالات لهلّق',
    'blog.empty_subtitle': 'رجاع قريبًا تشوف نصائحنا!',
    'brandsModels.error': 'خطأ',
    'brandsModels.deleteBrandConfirm': 'بدّك تحذف الماركة «{{name}}» وكل موديلاتها؟',
    'brandsModels.noModels': 'ما في موديلات.',
    'brandsModels.home': 'الرئيسية',
    'brandsModels.title': 'الماركات والموديلات',
    'brandsModels.countBrands': '{{count}} ماركة',
    'brandsModels.countSeries': '{{count}} سلسلة',
    'brandsModels.countModels': '{{count}} موديل',
    'brandsModels.searchPlaceholder': 'دوّر على ماركة أو سلسلة أو موديل...',
    'brandsModels.newBrandPlaceholder': 'ماركة جديدة...',
    'brandsModels.addBrand': 'إضافة',
    'brandsModels.loading': 'عم يحمّل...',
    'brandsModels.rename': 'تغيير الاسم',
    'brandsModels.delete': 'حذف',
    'brandsModels.addModelPlaceholder': 'ضيف موديل {{brand}}...',
    'brandsModels.addModel': 'موديل',
    'brandsModels.deleteModel': 'احذف هالموديل',
    'brandsModels.noResults': 'ما في نتائج لهالبحث',
    'brandsModels.empty': 'ما في ماركات. ضيف وحدة فوق.',
    'allDocs.title': 'كل المستندات',
    'allDocs.docsCount': '{{count}} مستند',
    'allDocs.stat.devis': 'عروض أسعار',
    'allDocs.stat.factures': 'الفواتير',
    'allDocs.stat.bonsCmd': 'أوامر شراء',
    'allDocs.stat.tickets': 'التذاكر',
    'allDocs.stat.total': 'المجموع',
    'allDocs.searchPlaceholder': 'دوّر بالمرجع أو الزبون أو التلفون...',
    'allDocs.filter': 'فلترة',
    'allDocs.filterAll': 'الكل',
    'allDocs.type.devis': 'عرض سعر',
    'allDocs.type.facture': 'فاتورة',
    'allDocs.type.bonCommande': 'أمر شراء',
    'allDocs.type.ticket': 'تذكرة',
    'allDocs.col.reference': 'المرجع',
    'allDocs.col.type': 'النوع',
    'allDocs.col.client': 'الزبون',
    'allDocs.col.telephone': 'التلفون',
    'allDocs.col.total': 'المجموع',
    'allDocs.col.statut': 'الحالة',
    'allDocs.col.liaisons': 'الروابط',
    'allDocs.col.date': 'التاريخ',
    'allDocs.col.actions': 'الإجراءات',
    'allDocs.loading': 'عم يحمّل...',
    'allDocs.empty': 'ما في ولا مستند',
    'allDocs.status.devis': 'عرض سعر',
    'allDocs.status.enAttente': 'قيد الانتظار',
    'allDocs.status.accepte': 'مقبول',
    'allDocs.status.refuse': 'مرفوض',
    'allDocs.status.payee': 'مدفوعة',
    'allDocs.status.commande': 'تم الطلب',
    'allDocs.status.enCours': 'قيد التنفيذ',
    'allDocs.status.recu': 'مستلم',
    'allDocs.status.livre': 'تم التسليم',
    'allDocs.status.termine': 'مكتمل',
    'allDocs.action.print': 'طباعة / عرض PDF',
    'allDocs.action.download': 'تنزيل PDF',
    'allDocs.action.email': 'إرسال عبر الإيميل',
    'allDocs.footerCount': '{{count}} مستند معروض',
    'allDocs.footerCountPlural': '{{count}} مستندات معروضة',
    'allDocs.printUnavailable': 'طباعة تذكرة 80 مم مو متوفرة لهالمستند (source={{source}}).',
    'allDocs.downloadUnavailable': 'التنزيل مو متوفر لهالنوع من المستندات (source={{source}}).',
    'allDocs.emailUnavailable': 'الإرسال بالإيميل مو متوفر لهالنوع من المستندات (source={{source}}).',
    'allDocs.emailPrompt': 'إيميل المستلم:',
    'allDocs.emailSent': 'انبعت الإيميل!',
    'allDocs.error': 'خطأ: {{msg}}',
    'themeSettings.title': 'تخصيص الألوان',
    'themeSettings.subtitle': 'عدّل شكل منصّتك',
    'themeSettings.cancel': 'إلغاء',
    'themeSettings.saved': 'انحفظ',
    'themeSettings.saving': 'عم ينحفظ...',
    'themeSettings.save': 'حفظ',
    'themeSettings.presetsTitle': 'لوحات ألوان جاهزة',
    'themeSettings.customTitle': 'ألوان مخصّصة',
    'themeSettings.previewTitle': 'معاينة مباشرة',
    'themeSettings.previewCompany': 'شركتي',
    'themeSettings.previewPrimaryBtn': 'الزر الرئيسي',
    'themeSettings.previewSecondaryBtn': 'الزر الثانوي',
    'themeSettings.previewNavDashboard': 'لوحة التحكم',
    'themeSettings.previewNavRepairs': 'التصليحات',
    'themeSettings.previewNavStock': 'المخزون',
    'themeSettings.previewNavClients': 'الزبائن',
    'themeSettings.previewStatusInProgress': 'قيد التنفيذ',
    'themeSettings.previewStatusPending': 'بالانتظار',
    'themeSettings.fieldPrimaryLabel': 'اللون الأساسي',
    'themeSettings.fieldPrimaryDesc': 'الأزرار والروابط والعناصر المميّزة الرئيسية',
    'themeSettings.fieldSecondaryLabel': 'اللون الثانوي',
    'themeSettings.fieldSecondaryDesc': 'الشارات والمؤشّرات والعناصر المميّزة الثانوية',
    'themeSettings.fieldAccentLabel': 'لون التمييز',
    'themeSettings.fieldAccentDesc': 'خلفية الترويسات ونصّ متباين',
    'themeSettings.fieldSidebarBgLabel': 'خلفية الشريط الجانبي',
    'themeSettings.fieldSidebarBgDesc': 'خلفية القائمة الجانبية',
    'themeSettings.fieldSidebarTextLabel': 'نصّ الشريط الجانبي',
    'themeSettings.fieldSidebarTextDesc': 'لون النصّ في القائمة',
    'themeSettings.fieldHeaderBgLabel': 'خلفية الترويسة',
    'themeSettings.fieldHeaderBgDesc': 'خلفية الشريط العلوي',
    'themeSettings.presetRougeJaune': 'أحمر وأصفر',
    'themeSettings.presetGuyane': 'غويانا',
    'themeSettings.presetOceanBleu': 'محيط أزرق',
    'themeSettings.presetRoyalViolet': 'بنفسجي ملكي',
    'themeSettings.presetEmeraude': 'زمرّد',
    'themeSettings.presetSunset': 'غروب الشمس',
    'boutiqueCmd.pageTitle': 'طلبات المتجر الإلكتروني',
    'boutiqueCmd.deleteSelection': 'حذف المحدد ({{count}})',
    'boutiqueCmd.confirmDelete': 'حذف {{count}} طلب؟',
    'boutiqueCmd.errUpdate': 'صار خطأ وقت التحديث',
    'boutiqueCmd.errDelete': 'صار خطأ وقت الحذف',
    'boutiqueCmd.noteSent': '✅ انبعتت الملاحظة للزبون بنجاح',
    'boutiqueCmd.errSendNote': 'صار خطأ وقت إرسال الملاحظة',
    'boutiqueCmd.trackingSavedEmail': '✅ انحفظ رقم التتبّع وانبعت إيميل للزبون!',
    'boutiqueCmd.trackingSaved': '✅ انحفظ رقم التتبّع!',
    'boutiqueCmd.errSaveTracking': 'صار خطأ وقت الحفظ',
    'boutiqueCmd.confirmValidateProof': 'تأكيد إثبات الدفع هاد؟',
    'boutiqueCmd.confirmRejectProof': 'رفض إثبات الدفع هاد؟',
    'boutiqueCmd.errGeneric': 'خطأ',
    'boutiqueCmd.errDownload': 'صار خطأ وقت التنزيل',
    'boutiqueCmd.statutEnAttente': 'قيد الانتظار',
    'boutiqueCmd.statutProofUploaded': 'انبعت الإثبات',
    'boutiqueCmd.statutPayee': 'مدفوع',
    'boutiqueCmd.statutConfirmee': 'مؤكد',
    'boutiqueCmd.statutPreparee': 'انجهّز',
    'boutiqueCmd.statutExpediee': 'انشحن',
    'boutiqueCmd.statutLivree': 'انسلّم',
    'boutiqueCmd.statutAnnulee': 'ملغى',
    'boutiqueCmd.colReference': 'المرجع',
    'boutiqueCmd.colClient': 'الزبون',
    'boutiqueCmd.colArticles': 'المنتجات',
    'boutiqueCmd.colTotal': 'الإجمالي',
    'boutiqueCmd.colAdresse': 'العنوان',
    'boutiqueCmd.colStatut': 'الحالة',
    'boutiqueCmd.colSuivi': 'التتبّع',
    'boutiqueCmd.colPaiement': 'الدفع',
    'boutiqueCmd.colDate': 'التاريخ',
    'boutiqueCmd.colActions': 'الإجراءات',
    'boutiqueCmd.noOrders': 'ما في طلبات',
    'boutiqueCmd.editTracking': 'تعديل',
    'boutiqueCmd.addTrackingTitle': 'إضافة رقم تتبّع',
    'boutiqueCmd.addTrackingBtn': '+ تتبّع',
    'boutiqueCmd.viewProof': 'شوف الإثبات',
    'boutiqueCmd.validatePayment': 'تأكيد الدفع',
    'boutiqueCmd.rejectProof': 'رفض الإثبات',
    'boutiqueCmd.validated': 'مؤكّد',
    'boutiqueCmd.notesMessages': 'ملاحظات/رسائل',
    'boutiqueCmd.notesModalTitle': 'ملاحظات ورسائل - الطلب {{ref}}',
    'boutiqueCmd.clientLabel': 'الزبون:',
    'boutiqueCmd.phoneLabel': 'التلفون:',
    'boutiqueCmd.deliveryAddressLabel': 'عنوان التوصيل:',
    'boutiqueCmd.notSpecified': 'مو محدد',
    'boutiqueCmd.exchangeHistory': 'سجل المراسلات',
    'boutiqueCmd.noNote': 'ما في ملاحظات لهالطلب',
    'boutiqueCmd.staff': '👤 الموظف',
    'boutiqueCmd.client': '👥 الزبون',
    'boutiqueCmd.clientResponse': 'رد الزبون:',
    'boutiqueCmd.sendMessageTitle': '✉️ ابعت رسالة للزبون',
    'boutiqueCmd.notePlaceholder': 'مثال: مرحبا، فيك تأكّد عنوان التوصيل؟ شكرًا.',
    'boutiqueCmd.noteHint': '💡 رح يوصل الزبون هالرسالة وفيه يرد عليها من حسابه',
    'boutiqueCmd.close': 'إغلاق',
    'boutiqueCmd.sending': 'عم يُبعت...',
    'boutiqueCmd.sendToClient': 'ابعت للزبون',
    'boutiqueCmd.trackingNumber': 'رقم التتبّع',
    'boutiqueCmd.orderShortLabel': 'الطلب:',
    'boutiqueCmd.clientShortLabel': 'الزبون:',
    'boutiqueCmd.trackingPlaceholder': 'مثال: LA123456789FR',
    'boutiqueCmd.trackingHint': 'رح يشوف الزبون هالرقم بحسابه',
    'boutiqueCmd.cancel': 'إلغاء',
    'boutiqueCmd.saving': 'عم ينحفظ...',
    'boutiqueCmd.save': 'حفظ',
    'blogAdmin.confirmDelete': 'حذف هالمقال؟',
    'blogAdmin.pageTitle': 'المدوّنة ومقالات السيو',
    'blogAdmin.pageSubtitle': 'انشر المقالات وتحكّم بمحتوى المدوّنة',
    'blogAdmin.viewBlog': 'عرض المدوّنة',
    'blogAdmin.newArticle': 'مقال جديد',
    'blogAdmin.tabArticles': 'المقالات',
    'blogAdmin.tabContent': 'محتوى الصفحة',
    'blogAdmin.editArticle': 'تعديل المقال',
    'blogAdmin.fieldTitle': 'العنوان *',
    'blogAdmin.titlePlaceholder': 'مثال: تصليح شاشة iPhone بكايين: الأسعار والمدة',
    'blogAdmin.fieldExcerpt': 'مقتطف (معاينة)',
    'blogAdmin.excerptPlaceholder': 'وصف قصير للقائمة...',
    'blogAdmin.fieldContent': 'المحتوى * (يدعم Markdown)',
    'blogAdmin.contentPlaceholder': 'اكتب مقالك هون...',
    'blogAdmin.fieldTags': 'الوسوم (مفصولة بفاصلة)',
    'blogAdmin.tagsPlaceholder': 'تصليح, iphone, cayenne',
    'blogAdmin.fieldMeta': 'وصف ميتا للسيو',
    'blogAdmin.metaPlaceholder': 'وصف لجوجل (160 حرف كحد أقصى)',
    'blogAdmin.publishNow': 'النشر فورًا',
    'blogAdmin.update': 'تحديث',
    'blogAdmin.save': 'حفظ',
    'blogAdmin.loading': 'عم يحمّل...',
    'blogAdmin.noArticles': 'ما في مقالات',
    'blogAdmin.noArticlesHint': 'أنشئ أول مقال إلك لتحسين السيو',
    'blogAdmin.statusPublished': 'منشور',
    'blogAdmin.statusDraft': 'مسودة',
    'blogAdmin.byAuthor': 'بواسطة {{author}}',
    'blogAdmin.unpublish': 'إلغاء النشر',
    'blogAdmin.publish': 'نشر',
    'blogAdmin.loadingContent': 'عم يحمّل المحتوى...',
    'blogAdmin.contentNotice1': 'عدّل هون المحتوى يلي بيظهر عالصفحة العامة ',
    'blogAdmin.contentNotice2': '. رح تبيّن التعديلات فورًا.',
    'blogAdmin.blogHeader': 'ترويسة المدوّنة',
    'blogAdmin.mainTitle': 'العنوان الرئيسي',
    'blogAdmin.accentWord': 'الكلمة الملوّنة (تمييز)',
    'blogAdmin.description': 'الوصف',
    'blogAdmin.ctaSection': 'دعوة لإجراء (CTA بالمقالات)',
    'blogAdmin.ctaTitle': 'عنوان CTA',
    'blogAdmin.ctaDescription': 'وصف CTA',
    'blogAdmin.footerSection': 'تذييل الصفحة',
    'blogAdmin.footerText': 'نص التذييل',
    'blogAdmin.hidePreview': 'إخفاء المعاينة',
    'blogAdmin.livePreview': 'معاينة مباشرة',
    'blogAdmin.savedSuccess': 'تم الحفظ بنجاح!',
    'blogAdmin.saving': 'عم يحفظ...',
    'blogAdmin.saveContent': 'حفظ المحتوى',
    'blogAdmin.previewLabel': 'معاينة صفحة المدوّنة',
    'businessCard.title': 'بطاقات العمل',
    'businessCard.subtitle': 'قوالب وتحرير وطباعة A4 (10 بطاقات)',
    'businessCard.previewBtn': 'معاينة',
    'businessCard.edit': 'تعديل',
    'businessCard.printA4': 'طباعة A4 (10 بطاقات)',
    'businessCard.chooseTemplate': 'اختر قالب ({{count}} متوفّر)',
    'businessCard.tplName.classic': 'كلاسيكي',
    'businessCard.tplName.modern': 'عصري',
    'businessCard.tplName.gradient': 'متدرّج',
    'businessCard.tplName.minimal': 'بسيط',
    'businessCard.tplName.gold': 'ذهبي فاخر',
    'businessCard.tplName.ocean': 'محيط',
    'businessCard.tplName.forest': 'غابة',
    'businessCard.tplName.sunset': 'غروب الشمس',
    'businessCard.tplName.corporate': 'مؤسسي',
    'businessCard.tplName.pastel': 'وردي باستيل',
    'businessCard.tplDesc.classic': 'أنيق ومهني',
    'businessCard.tplDesc.modern': 'أنيق بلمسة سماوية',
    'businessCard.tplDesc.gradient': 'خلفية متدرّجة زاهية',
    'businessCard.tplDesc.minimal': 'أبيض وواضح',
    'businessCard.tplDesc.gold': 'أسود وذهبي فخم',
    'businessCard.tplDesc.ocean': 'أزرق غامق مريح',
    'businessCard.tplDesc.forest': 'أخضر طبيعي أنيق',
    'businessCard.tplDesc.sunset': 'برتقالي دافئ',
    'businessCard.tplDesc.corporate': 'أزرق كحلي مهني',
    'businessCard.tplDesc.pastel': 'ناعم وأنثوي',
    'businessCard.logoTransparent': 'شعار بخلفية شفافة',
    'businessCard.cardInfo': 'معلومات البطاقة',
    'businessCard.field.companyName': 'اسم الشركة',
    'businessCard.field.subtitle': 'العنوان الفرعي / النشاط',
    'businessCard.field.ownerName': 'اسم المسؤول',
    'businessCard.field.ownerTitle': 'اللقب / الوظيفة',
    'businessCard.field.phone': 'الهاتف',
    'businessCard.field.email': 'البريد الإلكتروني',
    'businessCard.field.address': 'العنوان',
    'businessCard.field.city': 'المدينة / الرمز البريدي',
    'businessCard.field.website': 'الموقع الإلكتروني',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'إعادة التعيين',
    'businessCard.previewTitle': 'معاينة — {{name}}',
    'businessCard.viewFront': 'عرض الوجه الأمامي',
    'businessCard.viewBack': 'عرض الوجه الخلفي',
    'businessCard.standardFormat': 'الحجم القياسي: 85 × 55 مم',
    'businessCard.allTemplates': 'كل القوالب',
    'businessCard.printTitle': 'بطاقات العمل',
    'businessCard.recto': 'الوجه الأمامي',
    'businessCard.verso': 'الوجه الخلفي',
    'hub.title': 'المركز',
    'hub.refresh': 'تحديث',
    'hub.kpiTicketsOpen': '{{n}} تذاكر مفتوحة',
    'hub.kpiFacturesToday': '{{n}} فواتير اليوم ({{total}})',
    'hub.kpiDevisOpen': '{{n}} عروض أسعار مفتوحة',
    'hub.magasinDefaultName': 'المتجر 1',
    'hub.magasinBadgeTitle': 'المتجر الحالي (نقطة البيع) — {{name}}',
    'hub.counterViewDetailed': 'عرض مفصّل',
    'hub.counterViewCompact': 'عرض مختصر',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} تذاكر · {{devis}} عروض أسعار · {{total}}',
    'hub.counterCompact': '{{tickets}}ت·{{devis}}ع·{{total}}',
    'hub.counterTickets': 'تذاكر',
    'hub.counterDevis': 'عروض أسعار',
    'hub.counterPerDay': '€/يوم',
    'hub.searchPlaceholder': 'دوّر على مرجع (REM0143، POS-...، DEV-00002) أو زبون أو تلفون…',
    'hub.filterAll': 'الكل',
    'hub.filterToday': 'اليوم',
    'hub.filterOverdue': 'متأخر',
    'hub.filterPaid': 'مدفوع',
    'hub.filterUnpaid': 'غير مدفوع',
    'hub.columnReparations': 'تصليحات',
    'hub.columnFactures': 'فواتير',
    'hub.columnDevis': 'عروض الأسعار',
    'hub.seeAll': 'عرض الكل',
    'hub.empty': 'ما في عناصر',
    'hub.actionView': 'عرض',
    'hub.actionPrint': 'طباعة',
    'hub.actionMail': 'إرسال عالإيميل',
    'hub.actionMarkReady': 'تحديد كجاهز',
    'hub.walkinClient': 'زبون عابر',
    'hub.invoicedAs': '→ تمت الفوترة: {{ref}}',
    'hub.errorPrint': 'خطأ أثناء الطباعة',
    'hub.errorPopupBlocked': 'لو سمحت اسمح بالنوافذ المنبثقة للطباعة.',
    'hub.statusWaiting': 'قيد الانتظار',
    'hub.statusInProgress': 'قيد التنفيذ',
    'hub.statusReady': 'جاهز',
    'hub.statusDelivered': 'تم التسليم',
    'hub.statusPaid': 'مدفوعة',
    'hub.statusInvoiced': 'تمت الفوترة',
    'hub.statusSent': 'تم الإرسال',
    'hub.statusAccepted': 'مقبول',
    'hub.statusCancelled': 'ملغى',
    'hub.statusDone': 'منتهى',
    'subscription.title': 'اشتراكي',
    'subscription.subtitle': 'دبّر خطتك والفواتير تبعك',
    'subscription.currentPlan': 'الخطة الحالية',
    'subscription.status': 'الحالة',
    'subscription.statusActive': 'فعّال',
    'subscription.statusTrial': 'تجربة مجانية',
    'subscription.monthlyPrice': 'السعر الشهري',
    'subscription.perMonth': '‏/شهر',
    'subscription.nextBilling': 'الدفعة الجاية',
    'subscription.changePlan': 'تغيير الخطة',
    'subscription.redirecting': 'عم يحوّل...',
    'subscription.upgrade': 'ترقية',
    'subscription.downgrade': 'تخفيض',
    'subscription.upgradeTitle': 'ترقية الخطة',
    'subscription.downgradeTitle': 'تخفيض الخطة',
    'subscription.newPlan': 'الخطة الجديدة',
    'subscription.newMonthlyPrice': 'السعر الشهري الجديد',
    'subscription.upgradeDiffNow': 'الفرق المطلوب هلّق',
    'subscription.changeFee': 'رسوم التغيير',
    'subscription.downgradeFeeNotice': 'في رسوم ثابتة قيمتها {{amount}} بتنطبق على أي تخفيض للخطة.',
    'subscription.cancel': 'إلغاء',
    'subscription.confirmWithAmount': 'تأكيد ({{amount}})',
    'subscription.toastChanged': 'انغيّرت خطتك بنجاح!',
    'subscription.toastCancelled': 'انلغى تغيير الخطة.',
    'subscription.errorPreview': 'صار خطأ وقت المعاينة',
    'subscription.errorChange': 'صار خطأ وقت تغيير الخطة',
    'subscription.featStartRepairs': 'إدارة التصليحات',
    'subscription.featStartClients': 'متابعة الزباين',
    'subscription.featStartQuotesInvoices': 'عروض الأسعار والفواتير',
    'subscription.featStartOnePos': 'نقطة بيع وحدة',
    'subscription.featProAllStart': 'كل شي بخطة Start',
    'subscription.featProMultiUsers': 'متعدد المستخدمين',
    'subscription.featProAdvancedStats': 'إحصائيات متقدمة',
    'subscription.featProThreePos': '3 نقاط بيع',
    'subscription.featProPrioritySupport': 'دعم بالأولوية',
    'subscription.featSuperAllPro': 'كل شي بخطة Pro',
    'subscription.featSuperUnlimitedPos': 'نقاط بيع بلا حدود',
    'subscription.featSuperCustomApi': 'واجهة برمجة مخصّصة',
    'subscription.featSuperDedicatedSupport': 'دعم مخصّص 24/7',
    'subscription.featSuperWhiteLabel': 'علامة بيضاء',
    'terms.title': 'الشروط العامة للاستخدام',
    'terms.edition': 'حزيران 2026',
    'terms.introBefore': 'تحكم هذه الشروط استخدام موقع',
    'terms.introMiddle': '، ومساحة العميل، ودردشة الدعم، وخدمات الإصلاح التي تقدمها',
    'terms.introAfter': '، SASU، كايين، غويانا الفرنسية.',
    'terms.acceptIntro': 'بإنشاء حساب أو بالتواصل معنا (الموقع، الدردشة، واتساب)، فإنك توافق على هذه الشروط وعلى',
    'terms.privacyPolicy': 'سياسة الخصوصية',
    'terms.servicesTitle': 'الخدمات',
    'terms.servicesBody': 'إصلاح الهواتف وبيعها، ومتابعة خدمة ما بعد البيع، وإعداد عروض الأسعار، والدفع عبر الإنترنت عند تفعيله، والدعم عبر الدردشة أو WhatsApp Business.',
    'terms.pricingTitle': 'الأسعار',
    'terms.pricingBody': 'عروض الأسعار والأسعار المُبلَّغة (في المتجر، الدردشة، واتساب) إرشادية حتى تأكيدها في نقطة البيع.',
    'terms.dataTitle': 'البيانات الشخصية',
    'terms.dataBefore': 'تُعالَج بياناتك وفقًا للائحة العامة لحماية البيانات (GDPR). طلب الحذف:',
    'terms.dataAfter': 'أو راجع قسم «حقوقك» في سياسة الخصوصية.',
    'terms.contactTitle': 'التواصل',
    'notifSettings.title': 'إشعارات فورية',
    'notifSettings.intro': 'بتوصلك رسالة تنبيه أصلية (Windows / macOS / Android) أول ما يصير شي مهم بالمحل. مخصّص لموظفي R.E.Mobiles.',
    'notifSettings.statusUnsupported': 'مو مدعوم (لازم iOS 16.4+)',
    'notifSettings.statusBlocked': 'محظورة (رُفض الإذن)',
    'notifSettings.statusEnabled': 'مفعّلة ع هالمتصفّح',
    'notifSettings.statusDisabled': 'مو مفعّلة',
    'notifSettings.activeCount': '{{count}} اشتراك فعّال',
    'notifSettings.enableBtn': 'فعّل الإشعارات',
    'notifSettings.testBtn': 'ابعت إشعار تجريبي',
    'notifSettings.disableBtn': 'إلغاء التفعيل',
    'notifSettings.iosHintPre': 'ع iPhone، إشعارات الويب الفورية بدها',
    'notifSettings.iosHintPost': 'وتثبيت التطبيق ع الشاشة الرئيسية (PWA). حدّث الـ iPhone وبعدين رجّع ثبّت التطبيق.',
    'notifSettings.blockedHint': 'انرفض الإذن. افتح إعدادات الموقع بالمتصفّح، واسمح بالإشعارات لهالنطاق وبعدين عيّد تحميل الصفحة.',
    'notifSettings.categoriesTitle': 'الفئات',
    'notifSettings.categoriesHint': 'طفّي يلّي ما بدّك توصلك. بيتطبّق فورًا، لهالحساب.',
    'notifSettings.catNewTicketLabel': 'تذكرة تصليح جديدة',
    'notifSettings.catNewTicketDesc': 'انعمل إيداع بالمحل.',
    'notifSettings.catTicketReadyLabel': 'التذكرة صارت «جاهز»',
    'notifSettings.catTicketReadyDesc': 'الفنّي بيحطّ التصليح جاهز. ما تنسى تخبّر الزبون.',
    'notifSettings.catNewInvoiceLabel': 'فاتورة POS جديدة',
    'notifSettings.catNewInvoiceDesc': 'هلّق انقبضت مصاري بيعة.',
    'notifSettings.catNewChatLabel': 'رسالة جديدة بالشات',
    'notifSettings.catNewChatDesc': 'رسالة مباشرة من الفريق أو الزبون أو B2B.',
    'notifSettings.catDevisLabel': 'عرض سعر انعمل أو انقبل',
    'notifSettings.catDevisDesc': 'بينعمل عرض سعر جديد أو الزبون بيضغط «قبول».',
    'notifSettings.accountLabel': 'الحساب',
    'notifSettings.roleLabel': 'الدور',
    'notifSettings.totalSubsLabel': 'مجموع الاشتراكات',
    'notifSettings.errPermDenied': 'انرفض الإذن. فعّل الإشعارات من إعدادات المتصفّح.',
    'notifSettings.errPermNotGranted': 'ما انعطى الإذن.',
    'notifSettings.errVapidUnavailable': 'مفتاح VAPID مو متوفّر ع السيرفر.',
    'notifSettings.infoEnabled': 'انفعّلت الإشعارات ع هالمتصفّح.',
    'notifSettings.errEnableFailed': 'فشل التفعيل.',
    'notifSettings.infoDisabled': 'انطفت الإشعارات ع هالمتصفّح.',
    'notifSettings.errDisableFailed': 'فشل إلغاء التفعيل.',
    'notifSettings.errPrefsUpdate': 'فشل تحديث الإعدادات.',
    'notifSettings.infoTestSent': 'انبعت إشعار تجريبي ({{sent}}/{{subs}}). شوف مركز الإشعارات بنظام تشغيلك.',
    'notifSettings.errNoneSent': 'ما انبعت ولا إشعار. تأكّد إنو الإشعارات مفعّلة ع هالمتصفّح.',
    'notifSettings.errTestFailed': 'فشل الاختبار.',
    'guyarepairLogin.subscriberSpace': 'مساحة المشترك',
    'guyarepairLogin.businessLoginTitle': 'تسجيل دخول الشركة',
    'guyarepairLogin.businessLoginSubtitle': 'سجّل الدخول على لوحة تحكم GUYAREPAIR تبعك',
    'guyarepairLogin.emailLabel': 'الإيميل',
    'guyarepairLogin.emailPlaceholder': 'you@email.com',
    'guyarepairLogin.passwordLabel': 'كلمة السر',
    'guyarepairLogin.passwordPlaceholder': 'كلمة السر تبعك',
    'guyarepairLogin.loggingIn': 'عم يسجّل الدخول...',
    'guyarepairLogin.loginButton': 'تسجيل الدخول',
    'guyarepairLogin.twoFATitle': 'التحقق بخطوتين (2FA)',
    'guyarepairLogin.twoFASubtitle': 'دخّل الرمز من تطبيق المصادقة تبعك',
    'guyarepairLogin.otpLabel': 'رمز من 6 أرقام',
    'guyarepairLogin.verifying': 'عم يتحقق...',
    'guyarepairLogin.verifyButton': 'تحقّق',
    'guyarepairLogin.backToLogin': 'رجوع لتسجيل الدخول',
    'guyarepairLogin.notSubscribedYet': 'لسا ما اشتركت؟',
    'guyarepairLogin.freeTrial': 'تجربة مجانية',
    'guyarepairLogin.secureConnection': 'اتصال آمن',
    'guyarepairLogin.guyarepairHome': 'الصفحة الرئيسية GUYAREPAIR',
    'guyarepairLogin.errInvalidCredentials': 'بيانات الدخول غلط',
    'guyarepairLogin.err2FAInvalid': 'رمز التحقق بخطوتين غلط',
    'analytics.period_today': 'اليوم',
    'analytics.period_7d': '7 أيام',
    'analytics.period_30d': '30 يوم',
    'analytics.period_90d': '90 يوم',
    'analytics.period_365d': 'سنة',
    'analytics.alert_suspicious_found': 'انكشف {{count}} عنوان IP مشبوه!',
    'analytics.alert_no_suspicious': 'ما في ولا عنوان IP مشبوه.',
    'analytics.page_title': 'التحليلات — الزيارات',
    'analytics.page_subtitle': 'تتبع الزيارات بكل مواقعك',
    'analytics.refresh': 'تحديث',
    'analytics.tab_dashboard': 'لوحة التحكم',
    'analytics.tab_visits': 'الزيارات',
    'analytics.tab_blocked': 'عناوين IP المحظورة',
    'analytics.tab_alerts': 'تنبيهات IP',
    'analytics.all_sites': 'كل المواقع',
    'analytics.kpi_total_visits': 'إجمالي الزيارات',
    'analytics.kpi_unique_visitors': 'زوار فريدين',
    'analytics.kpi_active_sites': 'مواقع نشطة',
    'analytics.kpi_countries': 'البلدان',
    'analytics.visits_per_day': 'الزيارات بكل يوم',
    'analytics.by_site': 'حسب الموقع',
    'analytics.by_country': 'حسب البلد',
    'analytics.top_pages': 'الصفحات الأكثر زيارة',
    'analytics.visits_per_hour': 'الزيارات بكل ساعة',
    'analytics.empty_no_visits': 'ما في زيارات مسجلة لهالفترة',
    'analytics.empty_install_script': 'لازم تثبّت سكربت التتبع على مواقعك',
    'analytics.search_placeholder': 'دوّر حسب IP أو الصفحة أو البلد...',
    'analytics.col_date': 'التاريخ',
    'analytics.col_site': 'الموقع',
    'analytics.col_page': 'الصفحة',
    'analytics.col_country_city': 'البلد / المدينة',
    'analytics.col_screen': 'الشاشة',
    'analytics.col_action': 'إجراء',
    'analytics.no_visits': 'ما في زيارات',
    'analytics.blocked_inline': '(محظور)',
    'analytics.unblock': 'إلغاء الحظر',
    'analytics.block': 'حظر',
    'analytics.visits_count': '{{count}} زيارة',
    'analytics.blocked_ips_title': 'عناوين IP المحظورة',
    'analytics.active_count': '{{count}} نشط',
    'analytics.col_status': 'الحالة',
    'analytics.col_reason': 'السبب',
    'analytics.col_blocked_by': 'محظور من',
    'analytics.no_blocked_ips': 'ما في عناوين IP محظورة',
    'analytics.status_blocked': 'محظور',
    'analytics.status_inactive': 'غير نشط',
    'analytics.reblock': 'إعادة الحظر',
    'analytics.alert_config_title': 'إعدادات التنبيهات',
    'analytics.checking': 'عم يفحص...',
    'analytics.check_now': 'افحص هلّق',
    'analytics.saving': 'عم يحفظ...',
    'analytics.save': 'حفظ',
    'analytics.alerts_enabled': 'التنبيهات مفعّلة',
    'analytics.alerts_enabled_desc': 'يراقب عناوين IP المشبوهة كل 15 دقيقة',
    'analytics.threshold_label': 'الحد (زيارات/ساعة)',
    'analytics.alert_email_label': 'إيميل التنبيه',
    'analytics.autoblock': 'الحظر التلقائي',
    'analytics.autoblock_desc': 'حظر عناوين IP يلي بتتجاوز الحد تلقائيًا',
    'analytics.alert_history_title': 'سجل التنبيهات',
    'analytics.alerts_count': '{{count}} تنبيه',
    'analytics.no_alerts': 'ما انطلق ولا تنبيه',
    'analytics.col_visits_per_hour': 'زيارات/ساعة',
    'analytics.col_sites': 'المواقع',
    'analytics.col_autoblocked': 'محظور تلقائيًا',
    'analytics.col_email': 'إيميل',
    'analytics.yes': 'نعم',
    'analytics.no': 'لا',
    'analytics.sent': 'تم الإرسال',
    'analytics.confirm_block_title': 'تحظر عنوان IP هاد؟',
    'analytics.confirm_block_ip_prefix': 'رح ينحظر عنوان IP ',
    'analytics.confirm_block_ip_suffix': ' على كل المواقع',
    'analytics.block_reason_placeholder': 'سبب الحظر (اختياري)...',
    'analytics.cancel': 'إلغاء',
    'analytics.blocking': 'عم يحظر...',
    'analytics.confirm_block': 'تأكيد الحظر',
    'guyarepairLanding.navTarifs': 'الأسعار',
    'guyarepairLanding.navAnnuaire': 'الدليل',
    'guyarepairLanding.navMaReparation': 'تصليحي',
    'guyarepairLanding.navConnexion': 'تسجيل الدخول',
    'guyarepairLanding.navEssaiGratuit': 'تجربة مجانية',
    'guyarepairLanding.heroBadge': 'منصة SaaS لإدارة التصليحات',
    'guyarepairLanding.heroTitleLine1': 'دبّر ورشة',
    'guyarepairLanding.heroTitleLine2': 'التصليح',
    'guyarepairLanding.heroTitleHighlight': 'بكل بساطة',
    'guyarepairLanding.heroSubtitle': '‏GUYAREPAIR هو الحل المتكامل لورش التصليح. نقطة بيع، وتتبّع التصليحات، وإدارة المخزون، والفوترة، وولاء الزباين — كل شي بمنصة وحدة.',
    'guyarepairLanding.heroCtaStart': 'ابدأ مجاناً',
    'guyarepairLanding.heroCtaPricing': 'شوف الأسعار',
    'guyarepairLanding.repairLookupTitle': 'دوّر على تصليحي',
    'guyarepairLanding.repairLookupSubtitle': 'أدخل رقم التصليح لمتابعة حالته',
    'guyarepairLanding.repairLookupPlaceholder': 'مثلاً: TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'بحث',
    'guyarepairLanding.repairErrorDefault': 'صار خطأ أثناء البحث',
    'guyarepairLanding.repairFoundAt': 'لقينا التصليح عند',
    'guyarepairLanding.statutTermine': 'خالص',
    'guyarepairLanding.statutEnCours': 'عم يشتغل عليه',
    'guyarepairLanding.statutEnAttente': 'بالانتظار',
    'guyarepairLanding.labelReference': 'الرقم المرجعي',
    'guyarepairLanding.labelAppareil': 'الجهاز',
    'guyarepairLanding.labelProbleme': 'المشكلة',
    'guyarepairLanding.voirPageDe': 'شوف صفحة {{nom}}',
    'guyarepairLanding.directoryTitle': 'لاقِ فنّي التصليح',
    'guyarepairLanding.directorySubtitle': 'دوّر على محل تصليح شريك لـ GUYAREPAIR',
    'guyarepairLanding.searchPlaceholder': 'اسم المحل، المدينة...',
    'guyarepairLanding.resultats': '{{count}} نتيجة',
    'guyarepairLanding.featuresTitle': 'كل شي بتحتاجه',
    'guyarepairLanding.featuresSubtitle': 'مجموعة متكاملة من الأدوات لورشتك',
    'guyarepairLanding.feature1Title': 'إدارة التصليحات',
    'guyarepairLanding.feature1Desc': 'تتبّع كامل لكل تصليح، من التشخيص لحدّ التسليم',
    'guyarepairLanding.feature2Title': 'نقطة البيع (POS)',
    'guyarepairLanding.feature2Desc': 'قبض المصاري، وحساب الأسعار، وإدارة صندوق مدمجة',
    'guyarepairLanding.feature3Title': 'المخزون والجرد',
    'guyarepairLanding.feature3Desc': 'حركات المخزون، والتنبيهات، والموردين، والطلبات',
    'guyarepairLanding.feature4Title': 'الزباين والولاء',
    'guyarepairLanding.feature4Desc': 'قاعدة بيانات الزباين، وبرنامج ولاء مع مكافآت',
    'guyarepairLanding.feature5Title': 'عروض الأسعار والفواتير',
    'guyarepairLanding.feature5Desc': 'إنشاء سريع لعروض الأسعار، وتحويلها لفواتير، وإرسالها عالإيميل',
    'guyarepairLanding.feature6Title': 'محلات متعددة',
    'guyarepairLanding.feature6Desc': 'دبّر عدة محلات من لوحة تحكم وحدة',
    'guyarepairLanding.pricingTitle': 'أسعار بسيطة وواضحة',
    'guyarepairLanding.pricingSubtitle': 'اختر الخطة المناسبة لشغلك',
    'guyarepairLanding.popular': 'الأكثر طلباً',
    'guyarepairLanding.perMonth': 'يورو/شهر',
    'guyarepairLanding.commencer': 'ابدأ',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. جميع الحقوق محفوظة.',
    'guyarepairLanding.trademarkNotice': '‏GUYAREPAIR هي العلامة التجارية للخدمة.',
    'guyarepairLanding.passwordTooShort': 'لازم تكون كلمة السر 6 أحرف عالأقل',
    'guyarepairLanding.registerErrorDefault': 'صار خطأ أثناء التسجيل',
    'guyarepairLanding.registerSuccessTitle': 'تم التسجيل بنجاح!',
    'guyarepairLanding.successAccountCreated': 'تم إنشاء حسابك مع',
    'guyarepairLanding.successTrial': 'تجربة مجانية لمدة 5 أيام',
    'guyarepairLanding.successLoginHint': 'سجّل الدخول لتجهيز مساحتك. انبعت إيميل ترحيب.',
    'guyarepairLanding.seConnecter': 'تسجيل الدخول',
    'guyarepairLanding.createAccountTitle': 'أنشئ حسابك',
    'guyarepairLanding.planLine': 'خطة {{nom}} — {{prix}} يورو/شهر',
    'guyarepairLanding.planLabel': 'الخطة',
    'guyarepairLanding.companyNameLabel': 'اسم الشركة',
    'guyarepairLanding.contactNameLabel': 'اسم جهة الاتصال',
    'guyarepairLanding.phoneLabel': 'التلفون',
    'guyarepairLanding.emailLabel': 'الإيميل',
    'guyarepairLanding.passwordLabel': 'كلمة السر',
    'guyarepairLanding.cityLabel': 'المدينة',
    'guyarepairLanding.addressLabel': 'العنوان',
    'guyarepairLanding.directoryToggle': 'الظهور بدليل GUYAREPAIR العام',
    'guyarepairLanding.creating': 'عم ينعمل...',
    'guyarepairLanding.createMyAccount': 'إنشاء حسابي',
    'guyarepairLanding.alreadyRegistered': 'مسجّل من قبل؟',
    'alertsConfig.saved': 'انحفظت إعدادات التنبيهات',
    'alertsConfig.error': 'خطأ',
    'alertsConfig.title': 'التنبيهات التلقائية',
    'alertsConfig.subtitle': 'ظبّط التنبيهات التلقائية لشركتك. رح يوصلك إيميل كل يوم إذا تحققت الشروط.',
    'alertsConfig.emailAlertsLabel': 'التنبيهات عبر الإيميل',
    'alertsConfig.emailAlertsDesc': 'فعّل التنبيهات التلقائية عبر الإيميل (تصليحات منتظرة، نفاد المخزون)',
    'alertsConfig.repairAlertsTitle': 'تنبيهات التصليحات المنتظرة',
    'alertsConfig.repairAlertsDesc': 'بيوصلك إيميل لما يكون في تصليح منتظر من أكتر من X يوم.',
    'alertsConfig.delayLabel': 'المهلة (أيام)',
    'alertsConfig.daysShort': '{{n}}ي',
    'alertsConfig.stockAlertsTitle': 'تنبيهات المخزون',
    'alertsConfig.stockAlertsDesc': 'بيوصلك إيميل لما تخلص القطع من المخزون أو تنزل تحت حد معيّن.',
    'alertsConfig.lowStockThresholdLabel': 'حد انخفاض المخزون',
    'alertsConfig.clientNotifLabel': 'إشعارات الزباين',
    'alertsConfig.clientNotifDesc': 'إرسال إيميل للزبون لما تتغيّر حالة التصليح (مخلّص، عم يتصلّح، إلخ.)',
    'alertsConfig.emailSenderInfo': 'رح ينبعت الإيميل من عنوانك المظبوط، أو من GUYAREPAIR بشكل افتراضي.',
    'alertsConfig.saving': 'عم يتحفظ...',
    'alertsConfig.save': 'حفظ',
    'companyAnalytics.title': 'التحليلات',
    'companyAnalytics.subtitle': 'نظرة عامة على أداء شركتك',
    'companyAnalytics.loadError': 'صار خطأ وقت التحميل',
    'companyAnalytics.kpiRepairsToday': 'التصليحات اليوم',
    'companyAnalytics.kpiThisWeek': '{{count}} هالأسبوع',
    'companyAnalytics.kpiRevenueToday': 'الإيرادات اليوم',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} هالشهر',
    'companyAnalytics.kpiClients': 'الزبائن',
    'companyAnalytics.kpiNewThisMonth': '{{count}} جديد هالشهر',
    'companyAnalytics.kpiAvgTime': 'متوسط الوقت',
    'companyAnalytics.daysShort': '{{count}} ي',
    'companyAnalytics.kpiPerRepair': 'لكل تصليح',
    'companyAnalytics.statTotalRepairs': 'إجمالي التصليحات',
    'companyAnalytics.statActive': 'الشغالة',
    'companyAnalytics.statCompleted': 'الخالصة',
    'companyAnalytics.statStockItems': 'أصناف المخزون',
    'companyAnalytics.statOutOfStock': 'خلص من المخزون',
    'companyAnalytics.repairsByStore': 'التصليحات الجارية حسب المحل',
    'companyAnalytics.repairsM1Explicit': '{{count}} تصليحات M1 صريحة',
    'companyAnalytics.repairsLegacy': '{{count}} تصليحات قديمة (قبل M2)',
    'companyAnalytics.totalShown': 'الإجمالي المعروض: {{count}}',
    'companyAnalytics.repairsM2': '{{count}} تصليحات M2',
    'companyAnalytics.repairsTrend14Days': 'التصليحات (آخر 14 يوم)',
    'companyAnalytics.statusDistribution': 'توزيع الحالات',
    'companyAnalytics.noRepairs': 'ما في تصليحات',
    'companyAnalytics.revenue': 'الإيرادات',
    'companyAnalytics.revToday': 'اليوم',
    'companyAnalytics.revThisWeek': 'هالأسبوع',
    'companyAnalytics.revThisMonth': 'هالشهر',
    'companyAnalytics.revTotal': 'الإجمالي',
    'companyAnalytics.statusPending': 'عم تنطر',
    'companyAnalytics.statusInProgress': 'عم تشتغل',
    'companyAnalytics.statusCompleted': 'خالص',
    'companyAnalytics.statusDelivered': 'تسلّم',
    'companyAnalytics.statusCancelled': 'ملغى',
    'staffCommissions.title': 'عمولاتي',
    'staffCommissions.pdfDownloadError': 'صار خطأ وقت تنزيل الـPDF',
    'staffCommissions.downloadMonthSheet': 'نزّل كشف الشهر:',
    'staffCommissions.generating': 'عم يتجهّز…',
    'staffCommissions.downloadPdf': 'نزّل PDF',
    'staffCommissions.toReceive': 'للقبض',
    'staffCommissions.alreadyReceived': 'مقبوض',
    'staffCommissions.totalCumulative': 'المجموع التراكمي',
    'staffCommissions.detailByType': 'التفاصيل حسب النوع',
    'staffCommissions.toPay': 'للدفع: {{amount}}',
    'staffCommissions.paidDetail': 'مدفوع: {{amount}}',
    'staffCommissions.noCommissionYet': 'لسا ما في عمولات',
    'staffCommissions.filterAll': 'الكل',
    'staffCommissions.filterPending': 'للدفع',
    'staffCommissions.filterPaid': 'المدفوعة',
    'staffCommissions.filterCancelled': 'الملغية',
    'staffCommissions.colDate': 'التاريخ',
    'staffCommissions.colType': 'النوع',
    'staffCommissions.colTransaction': 'المعاملة',
    'staffCommissions.colAmountTtc': 'المبلغ مع الضريبة',
    'staffCommissions.colCommission': 'العمولة',
    'staffCommissions.colStatus': 'الحالة',
    'staffCommissions.noCommission': 'ما في عمولات',
    'staffCommissions.month1': 'كانون الثاني',
    'staffCommissions.month2': 'شباط',
    'staffCommissions.month3': 'آذار',
    'staffCommissions.month4': 'نيسان',
    'staffCommissions.month5': 'أيار',
    'staffCommissions.month6': 'حزيران',
    'staffCommissions.month7': 'تموز',
    'staffCommissions.month8': 'آب',
    'staffCommissions.month9': 'أيلول',
    'staffCommissions.month10': 'تشرين الأول',
    'staffCommissions.month11': 'تشرين الثاني',
    'staffCommissions.month12': 'كانون الأول',
    'staffCommissions.typeVentes': 'بيع كاشير',
    'staffCommissions.typeCommandes': 'طلبية',
    'staffCommissions.typeAcomptes': 'عربون',
    'staffCommissions.typeReparations': 'تصليح',
    'staffCommissions.typeFactures': 'فاتورة',
    'staffCommissions.typeDevis': 'عرض سعر',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'زيارة ميدانية',
    'labelConfig.title': 'إعداد الملصقات',
    'labelConfig.subtitle': 'عدّل الهوامش والأبعاد حسب طابعتك',
    'labelConfig.reset': 'القيم الافتراضية',
    'labelConfig.save': 'حفظ',
    'labelConfig.saving': 'عم يحفظ...',
    'labelConfig.saved': 'تم الحفظ',
    'labelConfig.save_error': 'خطأ بالحفظ: {{error}}',
    'labelConfig.global_dimensions': 'الأبعاد العامة',
    'labelConfig.label_width': 'عرض الملصق',
    'labelConfig.label_height': 'ارتفاع الملصق',
    'labelConfig.cols': 'الأعمدة',
    'labelConfig.rows': 'الصفوف',
    'labelConfig.margins_spacing': 'الهوامش والتباعد',
    'labelConfig.left_margin': 'الهامش الأيسر',
    'labelConfig.top_margin': 'الهامش العلوي',
    'labelConfig.h_spacing': 'تباعد أفقي',
    'labelConfig.v_spacing': 'تباعد عمودي',
    'labelConfig.col_offset_title': 'إزاحة لكل عمود',
    'labelConfig.cols_count': '({{count}} أعمدة)',
    'labelConfig.col_n': 'عمود {{n}}',
    'labelConfig.col_offset_hint': 'القيم الموجبة = إزاحة لليمين. السالبة = لليسار.',
    'labelConfig.row_offset_title': 'إزاحة لكل صف',
    'labelConfig.rows_count': '({{count}} صفوف)',
    'labelConfig.row_n': 'صف {{n}}',
    'labelConfig.row_offset_hint': 'القيم الموجبة = إزاحة لفوق. السالبة = لتحت.',
    'labelConfig.preview_title': 'معاينة ورقة A4',
    'labelConfig.preview_count': '{{cols}} × {{rows}} = {{total}} ملصق/ورقة',
    'labelConfig.preview_dims': '{{width}} × {{height}} مم',
    'paymentConfig.title': 'إعدادات الدفع',
    'paymentConfig.statusActiveTitle': 'الدفع أونلاين شغّال',
    'paymentConfig.providerLabel': 'المزوّد: {{name}}',
    'paymentConfig.statusInactiveTitle': 'الدفع أونلاين مطفّي',
    'paymentConfig.statusInactiveDesc': 'ظبّط مزوّد حتى تقبل الدفع أونلاين. بس الدفع بلا إنترنت متوفّر (كاش، بطاقة بالمحل).',
    'paymentConfig.chooseProvider': 'اختار مزوّد الدفع تبعك:',
    'paymentConfig.apiKeysTitle': 'مفاتيح API تبع {{name}}',
    'paymentConfig.savedPlaceholder': 'محفوظة: {{value}}',
    'paymentConfig.save': 'حفظ',
    'paymentConfig.testConnection': 'جرّب الاتصال',
    'paymentConfig.infoTitle': 'معلومات مهمة',
    'paymentConfig.info1': 'الدفعات أونلاين بتوصل دغري لحساب التاجر تبعك.',
    'paymentConfig.info2': 'مفاتيح API تبعك بتنشفّر وبتتخزّن بأمان.',
    'paymentConfig.info3': 'بلا إعداد صحيح، بس الدفع بلا إنترنت متوفّر.',
    'paymentConfig.info4': 'كل شركة بتدير مفاتيحها لحالها بشكل مستقل.',
    'paymentConfig.saveError': 'خطأ بالحفظ',
    'paymentConfig.testError': 'خطأ بالاختبار',
    'paymentConfig.disableConfirm': 'بدّك تطفّي الدفع أونلاين؟',
    'paymentConfig.stripeDesc': 'دفع بالبطاقة، Apple Pay، Google Pay',
    'paymentConfig.sumupDesc': 'جهاز دفع POS V2 + دفع أونلاين (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'المفتاح العام (pk_...)',
    'paymentConfig.fieldSecretKey': 'المفتاح السري (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'سرّ الـ webhook ‏(whsec_...)',
    'paymentConfig.fieldApiKey': 'مفتاح API',
    'paymentConfig.fieldMerchantCode': 'رمز التاجر',
    'paymentConfig.fieldClientId': 'معرّف العميل (Client ID)',
    'paymentConfig.fieldClientSecret': 'سرّ العميل (Client Secret)',
    'loyaltyAdmin.title': 'برنامج الولاء',
    'loyaltyAdmin.subtitle': 'متابعة نقاط ومكافآت الزبائن',
    'loyaltyAdmin.refresh': 'تحديث',
    'loyaltyAdmin.kpiMembers': 'الأعضاء',
    'loyaltyAdmin.kpiPendingRewards': 'مكافآت قيد الانتظار',
    'loyaltyAdmin.kpiRedeemed': 'مكافآت مستخدمة',
    'loyaltyAdmin.kpiThreshold': 'حد المكافأة',
    'loyaltyAdmin.purchasesSuffix': 'مشتريات',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% تصليح',
    'loyaltyAdmin.topClients': 'أكتر الزبائن ولاءً',
    'loyaltyAdmin.clientFallback': 'زبون',
    'loyaltyAdmin.flashOffers': 'عروض فلاش',
    'loyaltyAdmin.newOffer': 'عرض جديد',
    'loyaltyAdmin.createFlashOffer': 'إنشاء عرض فلاش',
    'loyaltyAdmin.offerTitlePlaceholder': 'عنوان العرض (مثال: Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'الوصف (مثال: تصليح الشاشة بسعر مخفّض)',
    'loyaltyAdmin.discountLabel': 'الخصم (%)',
    'loyaltyAdmin.endDateLabel': 'تاريخ الانتهاء',
    'loyaltyAdmin.targetLevelsLabel': 'المستويات المستهدفة',
    'loyaltyAdmin.creating': 'عم يتم الإنشاء...',
    'loyaltyAdmin.createOffer': 'إنشاء العرض',
    'loyaltyAdmin.noOffers': 'ما في أي عرض فلاش',
    'loyaltyAdmin.offerMeta': 'المستهدفون: {{levels}} | إيميلات: {{emails}}',
    'loyaltyAdmin.offerEnd': ' | الانتهاء: {{date}}',
    'loyaltyAdmin.deactivate': 'إلغاء التفعيل',
    'loyaltyAdmin.activate': 'تفعيل',
    'loyaltyAdmin.sendByEmail': 'إرسال بالإيميل',
    'loyaltyAdmin.delete': 'حذف',
    'loyaltyAdmin.allMembers': 'كل الأعضاء ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'بحث...',
    'loyaltyAdmin.colClient': 'الزبون',
    'loyaltyAdmin.colPhone': 'التلفون',
    'loyaltyAdmin.colPurchases': 'المشتريات',
    'loyaltyAdmin.colPoints': 'النقاط',
    'loyaltyAdmin.colTotalSpent': 'إجمالي المصروف',
    'loyaltyAdmin.colStatus': 'الحالة',
    'loyaltyAdmin.colRewards': 'المكافآت',
    'loyaltyAdmin.noMembers': 'ما في أعضاء',
    'loyaltyAdmin.rewardAvailable': 'مكافأة متاحة',
    'loyaltyAdmin.purchasesRemaining': 'باقي {{count}} مشتريات',
    'loyaltyAdmin.pageOf': 'صفحة {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': 'بدك تحذف هالعرض؟',
    'loyaltyAdmin.emailsSent': 'تم إرسال الإيميلات',
    'loyaltyAdmin.levelBronze': 'برونزي',
    'loyaltyAdmin.levelArgent': 'فضي',
    'loyaltyAdmin.levelOr': 'ذهبي',
    'emailConfig.pageTitle': 'إعدادات الإيميل',
    'emailConfig.pageSubtitle': 'اضبط سيرفر SMTP لإرسال الفواتير وعروض الأسعار والتنبيهات عبر الإيميل.',
    'emailConfig.smtpSection': 'سيرفر SMTP',
    'emailConfig.fieldHost': 'عنوان سيرفر SMTP',
    'emailConfig.fieldPort': 'المنفذ (البورت)',
    'emailConfig.fieldUser': 'مستخدم SMTP (الإيميل)',
    'emailConfig.fieldPassword': 'كلمة سر الإيميل',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (خليه فاضي لتبقى الكلمة القديمة)',
    'emailConfig.passwordPlaceholderNew': 'كلمة سر إيميل Hostinger',
    'emailConfig.useSsl': 'استخدام SSL/TLS (مفضّل مع المنفذ 465)',
    'emailConfig.enableEmails': 'تفعيل إرسال الإيميلات',
    'emailConfig.tipTitle': 'نصيحة Hostinger:',
    'emailConfig.tipBody': 'كلمة سر الإيميل غير كلمة سر hPanel. فيك تتأكد منها أو تعيد ضبطها من hPanel ← الإيميلات ← حسابات الإيميل ← إدارة.',
    'emailConfig.senderSection': 'المُرسِل',
    'emailConfig.fieldSenderName': 'اسم المُرسِل',
    'emailConfig.fieldSenderEmail': 'إيميل المُرسِل',
    'emailConfig.saving': 'عم يتحفظ…',
    'emailConfig.save': 'حفظ',
    'emailConfig.testing': 'عم يتبعت…',
    'emailConfig.testConnection': 'جرّب الاتصال',
    'emailConfig.disable': 'تعطيل',
    'emailConfig.loadError': 'خطأ بالتحميل (HTTP {{status}})',
    'emailConfig.saveSuccess': 'انحفظت الإعدادات. هلّق فيك تضغط «جرّب الاتصال».',
    'emailConfig.saveErrorFallback': 'خطأ بالحفظ',
    'emailConfig.testSuccess': 'انبعت إيميل تجربة. دقّق على صندوق الوارد.',
    'emailConfig.testErrorFallback': 'فشل اختبار SMTP. دقّق على كلمة سر إيميل Hostinger (غير كلمة سر hPanel).',
    'emailConfig.disableConfirm': 'تعطيل الإعدادات المخصّصة؟ رح يرجع السيرفر لإعدادات .env الافتراضية.',
    'emailConfig.disableSuccess': 'انعطّلت الإعدادات المخصّصة.',
    'emailConfig.disableErrorFallback': 'خطأ وقت التعطيل',
    'promosCalendar.title': 'روزنامة العروض',
    'promosCalendar.subtitle': 'العروض المبرمجة حسب اليوم',
    'promosCalendar.empty': 'ما في عروض مبرمجة لهالشهر.',
    'adminIntegrations.supplierCredentials': 'معلومات دخول الموردين (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'إنشاء صور المخزون (ذكاء اصطناعي) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'تدقيق فئات المخزون — موبايل / IMEI / إكسسوارات',
    'printerTokens.title': 'رموز وكيل الطابعة',
    'printerTokens.desc': 'إدارة الرموز يلي بيستخدمها وكيل ويندوز ليتأكد من هويته عند الخادم الخلفي. رمز لكل جهاز (هي الأفضل) أو رمز مشترك للتركيبات الصغيرة.',
    'printerTokens.newBtn': 'رمز جديد',
    'printerTokens.includeRevoked': 'تضمين الرموز المبطَلة',
    'printerTokens.refresh': 'تحديث',
    'printerTokens.loading': 'عم يحمّل…',
    'printerTokens.emptyPre': 'ما في رموز. اضغط على',
    'printerTokens.emptyPost': 'لإنشاء واحد.',
    'printerTokens.colLabel': 'التسمية',
    'printerTokens.colType': 'النوع',
    'printerTokens.colPreview': 'معاينة',
    'printerTokens.colCreated': 'تاريخ الإنشاء',
    'printerTokens.colLastUsed': 'آخر استخدام',
    'printerTokens.colStatus': 'الحالة',
    'printerTokens.colActions': 'إجراءات',
    'printerTokens.typeShared': 'مشترك',
    'printerTokens.typePersonal': 'شخصي',
    'printerTokens.createdBy': 'من قبل {{user}}',
    'printerTokens.statusRevoked': 'مبطَل',
    'printerTokens.statusActive': 'نشط',
    'printerTokens.revoke': 'إبطال',
    'printerTokens.securityTitle': 'الأمان',
    'printerTokens.securityHashPre': 'الرموز بتنخزن على شكل بصمة (SHA-256). الرمز الكامل',
    'printerTokens.securityHashEmph': 'ما بينعرض أبدًا مرة تانية',
    'printerTokens.securityHashPost': 'بعد ما بينعمل. إذا نسيتو، بطّلو واعمل رمز جديد.',
    'printerTokens.securityAudit': 'كل إنشاء وإبطال بينتسجّل بسجل تدقيق المسؤول.',
    'printerTokens.createTitle': 'رمز وكيل جديد',
    'printerTokens.createLabelField': 'التسمية (مثلاً: كمبيوتر الكاشير، لابتوب كارلوس)',
    'printerTokens.createLabelPlaceholder': 'كمبيوتر الكاشير',
    'printerTokens.createSharedLabel': 'رمز مشترك (بينفع يُستخدم على كذا جهاز)',
    'printerTokens.createSharedHint': 'رمز مشترك واحد بس بيكون فعّال بنفس الوقت. لأجل الأمان، الأفضل رمز لكل جهاز.',
    'printerTokens.cancel': 'إلغاء',
    'printerTokens.create': 'إنشاء',
    'printerTokens.revealTitle': 'تم إنشاء الرمز — انسخو هلق',
    'printerTokens.revealLabelPrefix': 'التسمية:',
    'printerTokens.revealConfigPre': 'اضبط وكيل ويندوز بهالرمز بالترويسة',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'تم النسخ',
    'printerTokens.copy': 'نسخ',
    'printerTokens.revealClose': 'سجّلت الرمز',
    'printerTokens.revokeTitle': 'تبطيل هالرمز؟',
    'printerTokens.revokeMsgPre': 'الرمز',
    'printerTokens.revokeMsgPost': 'ما رح يقدر بعد هلق يتأكد من هوية أي وكيل. هالعملية بتنحفظ بالسجل وما بتمحي الرمز (فيك تعرضو إذا أشّرت على «تضمين الرموز المبطَلة»).',
    'printerTokens.actionError': 'خطأ: {{detail}}',
    'servicePrices.pageTitle': 'أسعار التصليح',
    'servicePrices.pageSubtitle': 'ظبّط الأسعار ومحتوى الصفحة العامة',
    'servicePrices.viewPublicPage': 'شوف الصفحة العامة',
    'servicePrices.add': 'إضافة',
    'servicePrices.tabPrices': 'الأسعار',
    'servicePrices.tabContent': 'محتوى الصفحة',
    'servicePrices.editPriceTitle': 'تعديل السعر',
    'servicePrices.newPriceTitle': 'سعر جديد',
    'servicePrices.brand': 'الماركة *',
    'servicePrices.choose': 'اختار...',
    'servicePrices.model': 'الموديل',
    'servicePrices.modelPlaceholder': 'مثال: iPhone 14 Pro',
    'servicePrices.repairType': 'نوع التصليح *',
    'servicePrices.delay': 'المدة',
    'servicePrices.delayPlaceholder': 'مثال: 30 دقيقة',
    'servicePrices.priceMin': 'أقل سعر (يورو)',
    'servicePrices.priceMax': 'أعلى سعر (يورو)',
    'servicePrices.order': 'الترتيب',
    'servicePrices.visiblePublic': 'ظاهر للعموم',
    'servicePrices.btnUpdate': 'تعديل',
    'servicePrices.btnSave': 'حفظ',
    'servicePrices.loading': 'عم يحمّل...',
    'servicePrices.noPrices': 'ما في أسعار مسجّلة',
    'servicePrices.noPricesHint': 'ضيف أول أسعار عندك لتبيّن بالصفحة العامة',
    'servicePrices.colRepair': 'التصليح',
    'servicePrices.colPrice': 'السعر',
    'servicePrices.colVisible': 'ظاهر',
    'servicePrices.colActions': 'إجراءات',
    'servicePrices.allModels': 'كل الموديلات',
    'servicePrices.contentLoading': 'عم يحمّل المحتوى...',
    'servicePrices.contentBannerPre': 'عدّل هون المحتوى يلي بيبيّن بالصفحة العامة',
    'servicePrices.contentBannerPost': '. بتبيّن التعديلات فورًا بعد الحفظ.',
    'servicePrices.headerSection': 'رأس الصفحة',
    'servicePrices.mainTitle': 'العنوان الرئيسي',
    'servicePrices.accentWord': 'كلمة ملوّنة (تمييز)',
    'servicePrices.seoDescription': 'وصف SEO',
    'servicePrices.contactInfo': 'معلومات التواصل',
    'servicePrices.phone': 'التلفون',
    'servicePrices.phoneDisplay': 'التلفون المعروض',
    'servicePrices.whatsappLabel': 'واتساب (مع رمز الدولة)',
    'servicePrices.address': 'العنوان',
    'servicePrices.hours': 'أوقات الدوام',
    'servicePrices.trustBadges': 'شارات الثقة',
    'servicePrices.addShort': '+ إضافة',
    'servicePrices.titleField': 'العنوان',
    'servicePrices.description': 'الوصف',
    'servicePrices.faqTitle': 'الأسئلة الشائعة (FAQ)',
    'servicePrices.question': 'السؤال',
    'servicePrices.answer': 'الجواب',
    'servicePrices.ctaSection': 'قسم الحث على الإجراء (CTA)',
    'servicePrices.ctaTitle': 'عنوان CTA',
    'servicePrices.ctaDescription': 'وصف CTA',
    'servicePrices.footer': 'ذيل الصفحة',
    'servicePrices.line1': 'السطر 1',
    'servicePrices.line2': 'السطر 2',
    'servicePrices.hidePreview': 'إخفاء المعاينة',
    'servicePrices.livePreview': 'معاينة مباشرة',
    'servicePrices.savedSuccess': 'انحفظ بنجاح!',
    'servicePrices.saving': 'عم يحفظ...',
    'servicePrices.saveContent': 'حفظ المحتوى',
    'servicePrices.previewLabel': 'معاينة الصفحة العامة',
    'servicePrices.faqShort': 'الأسئلة الشائعة',
    'servicePrices.confirmDelete': 'تحذف هالسعر؟',
    'servicePrices.repairTypes.ecran': 'الشاشة',
    'servicePrices.repairTypes.batterie': 'البطارية',
    'servicePrices.repairTypes.connecteurCharge': 'مدخل الشحن',
    'servicePrices.repairTypes.cameraArriere': 'الكاميرا الخلفية',
    'servicePrices.repairTypes.cameraAvant': 'الكاميرا الأمامية',
    'servicePrices.repairTypes.hautParleur': 'السماعة',
    'servicePrices.repairTypes.micro': 'المايك',
    'servicePrices.repairTypes.boutonPower': 'زر التشغيل',
    'servicePrices.repairTypes.boutonVolume': 'زر الصوت',
    'servicePrices.repairTypes.vitreArriere': 'القزاز الخلفي',
    'servicePrices.repairTypes.nappeFaceId': 'كابل Face ID',
    'servicePrices.repairTypes.carteMere': 'اللوحة الأم',
    'servicePrices.repairTypes.diagnostique': 'التشخيص',
    'servicePrices.repairTypes.desoxydation': 'تنظيف الأكسدة',
    'servicePrices.repairTypes.autre': 'غير ذلك',
    'companySettings.toast.loadError': 'صار خطأ وقت تحميل الإعدادات',
    'companySettings.toast.saveSuccess': 'انحفظت الإعدادات بنجاح',
    'companySettings.toast.saveError': 'صار خطأ وقت الحفظ',
    'companySettings.toast.notImage': 'لازم يكون الملف صورة',
    'companySettings.toast.tooLarge': 'لازم حجم الملف ما يتجاوز 5 ميغابايت',
    'companySettings.toast.logoSuccess': 'تحدّث الشعار بنجاح',
    'companySettings.toast.logoError': 'صار خطأ وقت رفع الشعار',
    'companySettings.toast.previewError': 'صار خطأ وقت إنشاء المعاينة',
    'companySettings.tabs.info': 'المعلومات',
    'companySettings.tabs.documents': 'المستندات (الفواتير، عروض الأسعار، أوامر الشراء)',
    'companySettings.tabs.payment': 'الدفع',
    'companySettings.tabs.logo': 'الشعار',
    'companySettings.tabs.preview': 'معاينة PDF',
    'companySettings.tabs.security': 'الأمان',
    'companySettings.title': 'إعدادات الشركة',
    'companySettings.subtitle': 'ظبّط معلومات شركتك ومستنداتك',
    'companySettings.save': 'حفظ',
    'companySettings.info.sectionTitle': 'معلومات الشركة',
    'companySettings.info.companyNameLabel': 'اسم الشركة',
    'companySettings.info.companyNamePlaceholder': 'مثال: شركتي ش.م.م',
    'companySettings.info.legalFormLabel': 'الشكل القانوني',
    'companySettings.info.legalFormPlaceholder': 'مثال: ش.م.م، ش.ذ.م.م، مؤسسة فردية...',
    'companySettings.info.capitalLabel': 'رأس المال',
    'companySettings.info.capitalPlaceholder': 'مثال: 1000 يورو',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'مثال: 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'مثال: Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'التلفون',
    'companySettings.info.phonePlaceholder': 'مثال: +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'الإيميل',
    'companySettings.info.emailPlaceholder': 'مثال: contact@monentreprise.com',
    'companySettings.info.postalLabel': 'الرمز البريدي',
    'companySettings.info.postalPlaceholder': 'مثال: 97300',
    'companySettings.info.addressLabel': 'العنوان',
    'companySettings.info.addressPlaceholder': 'مثال: 10 الشارع الرئيسي',
    'companySettings.info.cityLabel': 'المدينة',
    'companySettings.info.cityPlaceholder': 'مثال: كايين',
    'companySettings.info.tvaLabel': 'بيان ضريبة القيمة المضافة',
    'companySettings.info.tvaPlaceholder': 'بيان ضريبي بيطلع على المستندات',
    'companySettings.documents.devisSectionTitle': 'إعدادات عروض الأسعار',
    'companySettings.documents.devisValidityLabel': 'مدة صلاحية عرض السعر',
    'companySettings.documents.devisValidityPlaceholder': 'مدة صلاحية عرض السعر',
    'companySettings.documents.devisConditionsLabel': 'الشروط العامة (عرض السعر)',
    'companySettings.documents.devisConditionsPlaceholder': 'الشروط العامة اللي بتطلع على عروض الأسعار',
    'companySettings.documents.bcSectionTitle': 'إعدادات أوامر الشراء',
    'companySettings.documents.bcConditionsLabel': 'شروط أمر الشراء',
    'companySettings.documents.bcConditionsPlaceholder': 'شروط تنفيذ الخدمات',
    'companySettings.documents.factureSectionTitle': 'إعدادات الفواتير',
    'companySettings.documents.facturePaymentLabel': 'شروط الدفع',
    'companySettings.documents.facturePaymentPlaceholder': 'مثال: الدفع عند الاستلام...',
    'companySettings.documents.facturePenaltiesLabel': 'غرامات التأخير',
    'companySettings.documents.facturePenaltiesPlaceholder': 'بند غرامات التأخير',
    'companySettings.documents.factureRecoveryLabel': 'تعويض التحصيل',
    'companySettings.documents.factureRecoveryPlaceholder': 'بند التعويض المقطوع',
    'companySettings.documents.factureReserveLabel': 'الاحتفاظ بحق الملكية',
    'companySettings.documents.factureReservePlaceholder': 'بند الاحتفاظ بحق الملكية',
    'companySettings.documents.warrantySectionTitle': 'الكفالة',
    'companySettings.documents.warrantyLabel': 'بيان الكفالة',
    'companySettings.documents.warrantyPlaceholder': 'مثال: كفالة 6 أشهر على القطع والأجرة من تاريخ التصليح.',
    'companySettings.documents.warrantyHint': 'رح يطلع هالبيان تحت الفواتير إذا انعبّى.',
    'companySettings.payment.sectionTitle': 'الدفع عبر الإنترنت',
    'companySettings.payment.disableTitle': 'تعطيل الدفع عبر الإنترنت',
    'companySettings.payment.disableDesc': 'لمّا يتفعّل، بتنخبّى خيارات الدفع عبر الإنترنت (Stripe) على كل عروض الأسعار. الزباين بس بيقدروا يطلبوا رابط دفع SumUp.',
    'companySettings.payment.statusDisabled': 'الدفع عبر الإنترنت مُعطَّل - الزباين رح يشوفوا بس نموذج طلب SumUp',
    'companySettings.payment.statusEnabled': 'الدفع عبر الإنترنت مُفعَّل - الزباين بيقدروا يدفعوا مباشرة عبر الإنترنت',
    'companySettings.payment.howTitle': 'كيف بيشتغل؟',
    'companySettings.payment.step1': '1. الزبون بيستلم عرض السعر عالإيميل وبيقبله',
    'companySettings.payment.step2': '2. بدل ما يدفع عبر الإنترنت، بيعبّي نموذج بإيميله/تلفونه',
    'companySettings.payment.step3': '3. بتستلم إشعار بطلب الدفع',
    'companySettings.payment.step4': '4. بتبعت رابط دفع SumUp يدوي للزبون',
    'companySettings.logo.sectionTitle': 'شعار الشركة',
    'companySettings.logo.description': 'رح يطلع هالشعار على فواتيرك وعروض أسعارك وأوامر الشراء (صيغ PNG وJPG، بحد أقصى 5 ميغابايت).',
    'companySettings.logo.alt': 'الشعار',
    'companySettings.logo.none': 'ما في شعار',
    'companySettings.logo.uploading': 'عم يترفع...',
    'companySettings.logo.choose': 'اختار شعار',
    'companySettings.logo.hint': 'رح يتغيّر حجم الشعار تلقائيًا على مستندات PDF.',
    'companySettings.preview.sectionTitle': 'معاينة مستنداتك',
    'companySettings.preview.description': 'اعرض نموذج لفاتورة أو عرض سعر بإعداداتك الحالية (الشعار، المعلومات، البيانات القانونية).',
    'companySettings.preview.saveReminder': 'تذكّر تحفظ تغييراتك قبل ما تعمل المعاينة.',
    'companySettings.preview.facture': 'فاتورة',
    'companySettings.preview.devis': 'عرض سعر',
    'companySettings.preview.generating': 'عم يتولّد...',
    'companySettings.preview.generate': 'إنشاء المعاينة',
    'companySettings.preview.iframeTitle': 'معاينة PDF',
    'companySettings.security.genericError': 'خطأ',
    'companySettings.security.invalidCode': 'رمز غلط',
    'companySettings.security.enabledToast': 'تفعّلت المصادقة الثنائية بنجاح!',
    'companySettings.security.disabledToast': 'تعطّلت المصادقة الثنائية',
    'companySettings.security.sectionTitle': 'أمان الحساب',
    'companySettings.security.twoFaTitle': 'المصادقة الثنائية (2FA)',
    'companySettings.security.statusActive': 'مُفعَّل',
    'companySettings.security.statusInactive': 'مُعطَّل',
    'companySettings.security.intro': 'احمِ حسابك بالتحقق بخطوتين. بكل مرة بتسجّل دخول، رح ينطلب منك رمز من 6 أرقام غير كلمة السر.',
    'companySettings.security.configureBtn': 'إعداد المصادقة الثنائية',
    'companySettings.security.step1ScanPrefix': '1. امسح رمز QR هاد باستخدام',
    'companySettings.security.step1ScanSuffix': ' :',
    'companySettings.security.qrAlt': 'رمز QR للمصادقة الثنائية',
    'companySettings.security.manualKeyLabel': 'أو دخّل هالمفتاح يدوي:',
    'companySettings.security.step2Enter': '2. دخّل الرمز اللي ظاهر بالتطبيق:',
    'companySettings.security.activate': 'تفعيل',
    'companySettings.security.protectedMsg': 'حسابك محمي بالمصادقة الثنائية',
    'companySettings.security.disablePrompt': 'للتعطيل، دخّل رمزك الحالي:',
    'companySettings.security.disable': 'تعطيل',
    'docTimezone.title': 'توقيت المستندات',
    'docTimezone.intro': 'اضبط المنطقة الزمنية المستخدمة للتواريخ والأوقات على مستنداتك (التذاكر، الفواتير، عروض الأسعار، طلبات الشراء).',
    'docTimezone.sectionTimezone': 'المنطقة الزمنية',
    'docTimezone.selectLabel': 'اختر منطقتك الزمنية',
    'docTimezone.currentLabel': 'المنطقة الحالية:',
    'docTimezone.selectHint': 'رح تنطبق هالمنطقة الزمنية على كل التواريخ يلي بتظهر على مستنداتك. وقت تسجيل التذاكر ما رح يتغير أبدًا بعد ما ينحفظ.',
    'docTimezone.save': 'حفظ',
    'docTimezone.importantTitle': 'مهم',
    'docTimezone.importantBody': 'بشكل افتراضي، كل المستندات بتستخدم المنطقة الزمنية لغويانا الفرنسية (كايين، UTC-3). إذا غيّرت هالإعداد، المستندات الجديدة رح تستخدم المنطقة الزمنية الجديدة. أما المستندات يلي انعملت من قبل فرح تحتفظ بوقت تسجيلها الأصلي.',
    'docTimezone.toastUpdated': 'تم تحديث المنطقة الزمنية',
    'docTimezone.errUpdate': 'صار خطأ أثناء التحديث',
    'docTimezone.errNetwork': 'خطأ بالشبكة',
    'docTimezone.tzCayenne': 'غويانا الفرنسية (كايين)',
    'docTimezone.tzMartinique': 'مارتينيك / غوادلوب',
    'docTimezone.tzGuadeloupe': 'غوادلوب',
    'docTimezone.tzParis': 'فرنسا القارية (باريس)',
    'docTimezone.tzReunion': 'لا ريونيون',
    'docTimezone.tzNoumea': 'كاليدونيا الجديدة',
    'docTimezone.tzTahiti': 'بولينيزيا الفرنسية (تاهيتي)',
    'flashOffers.confirmDelete': 'بدّك تحذف هالعرض؟',
    'flashOffers.emailsSentFallback': 'انبعتت الإيميلات',
    'flashOffers.pageTitle': 'عروض فلاش وتنزيلات',
    'flashOffers.pageSubtitle': 'دبّر عروضك الترويجية المؤقتة وابعتها للزباين الأوفياء',
    'flashOffers.newOffer': 'عرض جديد',
    'flashOffers.createTitle': 'إنشاء عرض فلاش',
    'flashOffers.labelTitle': 'العنوان *',
    'flashOffers.placeholderTitle': 'مثال: عرض نهاية الأسبوع',
    'flashOffers.labelDiscount': 'الخصم (%)',
    'flashOffers.labelDescription': 'الوصف',
    'flashOffers.placeholderDescription': 'مثال: تصليح الشاشة بسعر مخفّض',
    'flashOffers.labelEndDate': 'تاريخ الانتهاء',
    'flashOffers.labelTargetLevels': 'المستويات المستهدفة',
    'flashOffers.levelBronze': 'برونزي',
    'flashOffers.levelSilver': 'فضي',
    'flashOffers.levelGold': 'ذهبي',
    'flashOffers.creating': 'عم ننشئ...',
    'flashOffers.createOffer': 'إنشاء العرض',
    'flashOffers.emptyTitle': 'ما في ولا عرض فلاش متعمل',
    'flashOffers.emptyHint': 'دوس على «{{btn}}» لتبلّش',
    'flashOffers.badgeExpired': 'منتهية',
    'flashOffers.badgeDisabled': 'مطفّية',
    'flashOffers.endLabel': 'بتخلص: {{date}}',
    'flashOffers.emailsCount': 'الإيميلات: {{count}}',
    'flashOffers.lastSent': 'آخر إرسال: {{date}}',
    'flashOffers.deactivate': 'تعطيل',
    'flashOffers.activate': 'تفعيل',
    'flashOffers.sendByEmail': 'ابعت بالإيميل',
    'flashOffers.delete': 'حذف',
    'mailsAi.oauthDenied': 'تم رفض إذن Google.',
    'mailsAi.sessionExpired': 'انتهت صلاحية الجلسة، جرّب مرة تانية.',
    'mailsAi.tokenExchangeFailed': 'خطأ بالاتصال بـ Google، جرّب مرة تانية.',
    'mailsAi.missingParams': 'معاملات ناقصة.',
    'mailsAi.googleConnectError': 'خطأ بالاتصال بـ Google.',
    'mailsAi.errorWith': 'خطأ: {{msg}}',
    'mailsAi.aiAnalysisError': 'خطأ بتحليل الذكاء الاصطناعي: {{msg}}',
    'mailsAi.confirmDeleteAccount': 'بدك تحذف حساب الإيميل هذا وكل الرسائل المخزّنة تبعو؟',
    'mailsAi.confirmRefetch': 'هاد رح يمحي كل الإيميلات المخزّنة مؤقتًا ويعيد تنزيلها مع عرض HTML الكامل. بدك تكمّل؟',
    'mailsAi.confirmBulkAnalyze': 'تحليل {{count}} إيميل غير مُحلَّل؟ (بياكل من رصيد الذكاء الاصطناعي)',
    'mailsAi.fetchAnalyzedHeader': 'تم جلب {{count}} إيميل جديد وتحليلهن.',
    'mailsAi.alertsDetected': 'تم اكتشاف {{count}} تنبيه:',
    'mailsAi.fetchAnalyzedNoThreat': 'تم جلب {{count}} إيميل جديد وتحليلهن تلقائيًا. ما في أي تهديد.',
    'mailsAi.fetchRetrieved': 'تم جلب {{count}} إيميل جديد.',
    'mailsAi.noNewEmail': 'ما في إيميلات جديدة.',
    'mailsAi.refetchDone': 'خلصت إعادة المزامنة! تم جلب {{count}} إيميل مع عرض HTML.',
    'mailsAi.allVisibleAnalyzed': 'كل الإيميلات الظاهرة متحلّلة من قبل!',
    'mailsAi.bulkAnalyzeDone': 'خلص التحليل! تم تحليل {{done}}/{{total}} إيميل.',
    'mailsAi.emailSent': 'انبعت الإيميل بنجاح!',
    'mailsAi.subtitle': 'إدارة ذكية لإيميلاتك المهنية',
    'mailsAi.autoRefresh': 'تحديث تلقائي',
    'mailsAi.refresh': 'تحديث',
    'mailsAi.analyzeAll': 'تحليل الكل',
    'mailsAi.compose': 'إيميل جديد',
    'mailsAi.addAccount': 'إضافة حساب',
    'mailsAi.loadingAccounts': 'عم يحمّل الحسابات...',
    'mailsAi.noAccountTitle': 'ما في حساب إيميل موصول',
    'mailsAi.noAccountDesc': 'اربط أول حساب إيميل لتبلّش.',
    'mailsAi.fetchingAll': 'عم يجلب كل الإيميلات...',
    'mailsAi.fetchingAllHint': 'ممكن ياخد كم دقيقة',
    'mailsAi.noEmail': 'ما في إيميلات.',
    'mailsAi.noSubject': '(بدون موضوع)',
    'mailsAi.prev': 'السابق',
    'mailsAi.next': 'التالي',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'جهاز SumUp (جهاز الدفع)',
    'sumupTerminal.subtitle': 'جهاز دفع واحد لكل محل — M1 وM2 مستقلين عن بعض. POS V2 بيستخدم جهاز الدفع تبع المحل المختار.',
    'sumupTerminal.hintM1': 'جهاز دفع Resurrection Mobile (SOLO)',
    'sumupTerminal.hintM2': 'بينضبط لما يتقرن جهاز الدفع التاني مع SumUp',
    'sumupTerminal.m2NotConfigured': 'M2 لسا ما انضبط — شي طبيعي إذا جهاز الدفع التاني لسا ما تقرن. لما يتقرن، عبّي الخانات تحت (حساب SumUp M2 منفصل).',
    'sumupTerminal.step1Lead': 'بـ SumUp Cloud ← الأجهزة ← انسخ',
    'sumupTerminal.step1Merchant': 'رمز التاجر',
    'sumupTerminal.step1And': ' و',
    'sumupTerminal.step1Reader': 'معرّف القارئ',
    'sumupTerminal.step2Lead': 'الصق',
    'sumupTerminal.step2Secret': 'المفتاح السري',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'مو المفتاح العام sup_pk_',
    'sumupTerminal.step3Lead': 'اضغط على',
    'sumupTerminal.step3Verify': 'التحقق من مفتاح API',
    'sumupTerminal.step3Rest': '← رمز التاجر بينعبّى لحاله',
    'sumupTerminal.step4Lead': 'اختار جهاز الدفع من اللستة، وبعدين',
    'sumupTerminal.step4Save': 'احفظ',
    'sumupTerminal.labelName': 'اسم جهاز الدفع (اختياري)',
    'sumupTerminal.namePlaceholder': 'مثال: جهازي M1',
    'sumupTerminal.labelApiKey': 'مفتاح API السري تبع SumUp (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'محفوظ: {{masked}}',
    'sumupTerminal.apiKeyHint': 'بس المفتاح السري sup_sk_. SumUp بتعرضو مرة وحدة بس وقت الإنشاء.',
    'sumupTerminal.verifyKeyBtn': '1. التحقق من مفتاح API',
    'sumupTerminal.keyConfirmed': '✓ المفتاح تأكد من SumUp',
    'sumupTerminal.labelMerchantCode': 'رمز التاجر *',
    'sumupTerminal.labelReaderId': 'معرّف القارئ (reader) *',
    'sumupTerminal.discoverBtn': 'دوّر على أجهزتي',
    'sumupTerminal.readerFallback': 'جهاز دفع SumUp',
    'sumupTerminal.labelDeviceId': 'معرّف الجهاز (اختياري)',
    'sumupTerminal.saveBtn': 'احفظ {{mag}}',
    'sumupTerminal.testBtn': 'تجربة {{amount}} على جهاز الدفع',
    'sumupTerminal.checklistTitle': 'ليستة تحقق جهاز الدفع',
    'sumupTerminal.checklistWifi': 'الجهاز شغّال ومتصل بالـ Wi‑Fi',
    'sumupTerminal.checklistPaired': 'الحالة «مقترن» بـ SumUp Cloud',
    'sumupTerminal.checklistSolo': 'برنامج Solo ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'Bluetooth وAPI ما بيشتغلوا مع بعض — سكّر Bluetooth على جهاز SOLO إذا عم تستخدم POS',
    'sumupTerminal.checklistCancel': 'إذا طلع المبلغ وبعدين انلغى لحالو: رجّع وصّل API على جهاز الدفع (مو مشكلة بـ POS)',
    'sumupTerminal.openCloud': 'افتح SumUp Cloud',
    'sumupTerminal.errLoad': 'ما قدرنا نحمّل الإعدادات',
    'sumupTerminal.msgMerchantChanged': 'تغيّر حساب التاجر — تأكد من مفتاح API وبعدين اختار جهاز الدفع.',
    'sumupTerminal.errPasteSecret': 'أول شي الصق المفتاح السري تبع SumUp (sup_sk_…)، مو المفتاح العام sup_pk_.',
    'sumupTerminal.keyOkReaders': 'المفتاح تمام — الحساب {{mc}} · لقينا {{count}} جهاز دفع.',
    'sumupTerminal.keyOkNone': 'المفتاح تمام — الحساب {{mc}} · ما في جهاز دفع مقترن بـ SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'SumUp رفضت مفتاح API',
    'sumupTerminal.msgNoReaders': 'ما لقينا ولا جهاز دفع — تأكد إنو الجهاز مقترن بـ SumUp Cloud.',
    'sumupTerminal.errDiscover': 'خطأ بالبحث عن جهاز الدفع',
    'sumupTerminal.readerSelected': 'انتخب جهاز الدفع: {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'تغيير حساب SumUp: دخّل مفتاح API الجديد (sup_sk_…) قبل ما تحفظ.',
    'sumupTerminal.errVerifyFirst': 'أول شي اضغط على «التحقق من مفتاح API» — لازم SumUp تأكّد المفتاح قبل الحفظ.',
    'sumupTerminal.errReaderRequired': 'معرّف القارئ مطلوب — اضغط على «دوّر على أجهزتي» واختار الجهاز.',
    'sumupTerminal.savedWithNotice': 'انحفظت إعدادات {{mag}}. {{notice}}',
    'sumupTerminal.saved': 'انحفظت إعدادات {{mag}}.',
    'sumupTerminal.errSave': 'خطأ بالحفظ',
    'sumupTerminal.testOk': 'التجربة نجحت — دور على جهاز الدفع',
    'sumupTerminal.errTest': 'التجربة فشلت',
    'adminB2B.accessDenied': 'الدخول مرفوض',
    'adminB2B.reservedAdmins': 'مخصّص للمسؤولين بس.',
    'adminB2B.backToDashboard': 'رجوع للوحة التحكم',
    'adminB2B.back': 'رجوع',
    'adminB2B.title': 'عملاء B2B',
    'adminB2B.accountsSingular': 'الشركات المسجّلة على بوابة B2B — {{count}} حساب',
    'adminB2B.accountsPlural': 'الشركات المسجّلة على بوابة B2B — {{count}} حسابات',
    'adminB2B.colCompany': 'الشركة',
    'adminB2B.colManager': 'المدير',
    'adminB2B.colEmail': 'الإيميل',
    'adminB2B.colPhone': 'التلفون',
    'adminB2B.colStatus': 'الحالة',
    'adminB2B.colRegistered': 'تاريخ التسجيل',
    'adminB2B.empty': 'ما في عملاء B2B',
    'adminB2B.statusValide': 'مقبول',
    'adminB2B.statusEnAttente': 'قيد الانتظار',
    'adminB2B.statusRefuse': 'مرفوض',
    'adminCache.statusCompleted': 'مكتمل',
    'adminCache.statusRunning': 'عم يشتغل...',
    'adminCache.statusUpdating': 'عم يتحدّث',
    'adminCache.statusError': 'خطأ',
    'adminCache.never': 'ولا مرة',
    'adminCache.title': 'بيانات الموردين',
    'adminCache.refreshing': 'عم يتحدّث...',
    'adminCache.refreshData': 'حدّث البيانات',
    'adminCache.step1Title': 'الخطوة 1 — بيانات دخول الموردين.',
    'adminCache.step1Intro': 'دخّل الإيميل وكلمة السر تبع Mobilax وJensMobiles وLCD-Phone بصفحة',
    'adminCache.step1LinkText': 'بيانات دخول الموردين',
    'adminCache.step1Outro': 'بعدين ارجع لهون واضغط « {{action}} » لتغذي عرض السعر الآلي بالذكاء الاصطناعي.',
    'adminCache.configurePasswords': 'إعداد كلمات السر',
    'adminCache.totalCached': 'مجموع المنتجات بالكاش',
    'adminCache.spareParts': 'قطع الغيار',
    'adminCache.accessories': 'إكسسوارات',
    'adminCache.phones': 'تلفونات',
    'adminCache.syncState': 'حالة المزامنة',
    'adminCache.noSync': 'ما صار ولا مزامنة',
    'adminCache.exploreCache': 'استكشف الكاش',
    'adminCache.searchPlaceholder': 'دوّر (مثال: كفر iPhone 14، Galaxy A06 جديد)...',
    'adminCache.allTypes': 'كل الأنواع',
    'adminCache.filterParts': 'قطع',
    'adminCache.filterAccessories': 'إكسسوارات',
    'adminCache.filterPhones': 'تلفونات',
    'adminCache.colType': 'النوع',
    'adminCache.colSupplier': 'المورّد',
    'adminCache.colPart': 'القطعة',
    'adminCache.colBrand': 'الماركة',
    'adminCache.colPrice': 'السعر',
    'adminCache.colStock': 'المخزون',
    'adminCache.colRef': 'المرجع',
    'adminCache.catPart': 'قطعة',
    'adminCache.catAccessory': 'إكسسوار',
    'adminCache.catPhone': 'تلفون',
    'adminCache.inStock': 'متوفر',
    'adminCache.outOfStock': 'مو متوفر',
    'adminCache.noResults': 'ما في نتائج لـ "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'تطبيق Windows للموظفين',
    'adminDownloads.artifactDesktopDesc': 'أرشيف ZIP بيتوزّع على مستخدمي Windows.',
    'adminDownloads.artifactPackLabel': 'حزمة وكيل الطابعة',
    'adminDownloads.artifactPackDesc': 'أرشيف ZIP مصدري لإعادة بناء وكيل الطباعة.',
    'adminDownloads.artifactExeLabel': 'وكيل Windows',
    'adminDownloads.artifactExeDesc': 'ملف تنفيذي جاهز للتشغيل على جهاز الفني.',
    'adminDownloads.available': 'متوفر',
    'adminDownloads.missing': 'مفقود',
    'adminDownloads.download': 'تنزيل',
    'adminDownloads.activeFile': 'الملف النشط',
    'adminDownloads.size': 'الحجم',
    'adminDownloads.lastUpdate': 'آخر تحديث',
    'adminDownloads.uploadedBy': 'مرفوع من',
    'adminDownloads.replaceLiveFile': 'استبدال الملف المباشر',
    'adminDownloads.uploading': 'عم يترفع...',
    'adminDownloads.replace': 'استبدال',
    'adminDownloads.replaceHint': 'الملف يلّي بتختارو بيستبدل مباشرةً الملف المعروض للمستخدمين على remobiles.com.',
    'adminDownloads.selectedFile': 'الملف المحدد: {{name}}',
    'adminDownloads.loadError': 'خطأ بتحميل الملفات',
    'adminDownloads.downloadLinkUnavailable': 'رابط التنزيل غير متوفر',
    'adminDownloads.downloadFailed': 'ما انعمل التنزيل',
    'adminDownloads.selectFilePrompt': 'اختار ملف لـ {{label}}.',
    'adminDownloads.confirmReplace': 'بدّل {{label}} بـ {{name}} هلّق؟',
    'adminDownloads.replaceSuccess': 'تم استبدال {{label}} بنجاح.',
    'adminDownloads.uploadError': 'خطأ أثناء الرفع',
    'adminDownloads.title': 'المثبّتات والتنزيلات',
    'adminDownloads.subtitle': 'تنزيلات مباشرة لحزم Windows واستبدال مباشر للسوبر أدمن.',
    'adminDownloads.printerConfig': 'إعدادات الطابعة',
    'adminDownloads.refresh': 'تحديث',
    'adminDownloads.availableArtifacts': 'العناصر المتوفرة',
    'adminDownloads.totalSize': 'الحجم الإجمالي',
    'adminDownloads.alert': 'تنبيه',
    'adminDownloads.alertText': 'عمليات الاستبدال بتكتب فوق الملف المباشر. ما في حذف منفصل.',
    'adminDownloads.accessTitle': 'وصول المدير والسوبر أدمن',
    'adminDownloads.accessText': 'هالصفحة بتجمع التنزيلات الظاهرة من remobiles.com. الاستبدال المباشر للملفات بيظهر بس للسوبر أدمن.',
    'adminDownloads.signedLinksNote': 'روابط التنزيل بتضل موقّعة من الباك إند لتفادي كائنات blob بالمتصفح.',
    'adminCachePurge.accessDenied': 'الوصول لكارلوس بس.',
    'adminCachePurge.title': 'حذف المستندات التجارية',
    'adminCachePurge.descIntro': 'صفحة مخفية — كارلوس بس. بتمسح المبيعات والسجلات والطلبات والعرابين وعروض الأسعار/الفواتير',
    'adminCachePurge.descBefore': 'قبل',
    'adminCachePurge.descOutro': 'التاريخ المختار. الإصلاحات ما بتتأثر.',
    'adminCachePurge.warnBackupBefore': 'إجراء بيمسح وما في رجعة. اعمل تصدير نسخة احتياطية من',
    'adminCachePurge.warnBackupLink': 'قاعدة البيانات',
    'adminCachePurge.warnBackupAfter': 'قبل أي حذف فعلي.',
    'adminCachePurge.resultDryRunLine': 'خلصت المحاكاة — رح ينحذف {{count}} مستند قبل {{before}}.',
    'adminCachePurge.resultPurgeLine': 'تم الحذف — انحذف {{count}} مستند قبل {{before}}.',
    'adminCachePurge.sectionParams': 'الإعدادات',
    'adminCachePurge.labelBeforeDate': 'حذف كل شي قبل',
    'adminCachePurge.hintStrictlyBefore': 'قبل الساعة 00:00 من هداك اليوم بالضبط.',
    'adminCachePurge.labelConfirm': 'تأكيد (إلزامي)',
    'adminCachePurge.hintTypeToken': 'اكتب: {{token}}',
    'adminCachePurge.dryRunLabel': 'وضع المحاكاة (تجريبي) — ما بيمسح شي',
    'adminCachePurge.previewBtn': 'معاينة',
    'adminCachePurge.simulateBtn': 'محاكاة الحذف',
    'adminCachePurge.executeBtn': 'تنفيذ الحذف',
    'adminCachePurge.previewHeading': 'معاينة — {{count}} مستند',
    'adminCachePurge.beforeLabel': 'قبل {{before}}',
    'adminCachePurge.previewEmpty': 'ما في بيانات للعرض.',
    'adminCachePurge.colCollection': 'المجموعة',
    'adminCachePurge.colCount': 'العدد',
    'adminCachePurge.colExamples': 'أمثلة',
    'adminCachePurge.sectionExcluded': 'ما انحذف',
    'adminCachePurge.excludedReparations': 'الإصلاحات (الأجهزة)',
    'adminCachePurge.excludedStock': 'المخزون',
    'adminCachePurge.excludedClients': 'الزباين',
    'adminCachePurge.excludedUtilisateurs': 'المستخدمين',
    'adminCachePurge.confirmDryRun': 'محاكاة حذف قبل {{before}} ({{count}} مستند)؟',
    'adminCachePurge.confirmDelete': '⚠️ ما في رجعة — حذف {{count}} مستند تجاري قبل {{before}}؟',
    'adminCachePurge.errorPreview': 'خطأ بالمعاينة',
    'adminCachePurge.errorLoad': 'خطأ بالتحميل',
    'adminCachePurge.errorPurge': 'خطأ بالحذف',
    'adminSupplierCreds.title': 'بيانات دخول الموردين',
    'adminSupplierCreds.subtitle': '{{providers}} — لـ Auto-Devis وكاش الكتالوج',
    'adminSupplierCreds.supplierData': 'بيانات الموردين',
    'adminMagasins.statusActive': 'نشط',
    'adminMagasins.statusArchived': 'مؤرشف',
    'adminMagasins.newStore': 'محل جديد',
    'adminMagasins.fieldCode': 'الكود (بينعمل تلقائي، بيتعدّل)',
    'adminMagasins.fieldName': 'الاسم *',
    'adminMagasins.namePlaceholder': 'مثلاً: محل كايين المركزي',
    'adminMagasins.fieldAddress': 'العنوان',
    'adminMagasins.fieldPhone': 'التلفون',
    'adminMagasins.fieldPrinterIp': 'الطابعة (IP)',
    'adminMagasins.printerIpPlaceholder': 'مثلاً: 192.168.1.50  — خلّيه فاضي إذا ما في طابعة مخصصة',
    'adminMagasins.printerIpHint': 'إذا فاضي → بيرجع لطابعة جلسة الكاشير (POS).',
    'adminMagasins.fieldBadgeColor': 'لون الشارة',
    'adminMagasins.setAsDefault': 'خلّيه المحل الافتراضي',
    'adminMagasins.defaultWillBeDemoted': 'المحل {{code}} ({{name}}) هلّق هو الافتراضي. رح ينشال تلقائي.',
    'adminMagasins.cancel': 'إلغاء',
    'adminMagasins.createStore': 'إنشاء المحل',
    'adminMagasins.nameRequired': 'الاسم مطلوب',
    'adminMagasins.createError': 'خطأ بالإنشاء',
    'adminMagasins.confirmOverrideDefault': 'المحل «{{code}} — {{name}}» هلّق هو المحل الافتراضي.\n\nلمّا تأشّر «خلّيه الافتراضي»، رح ينشال تلقائي.\n\nأكّد؟',
    'adminMagasins.loadError': 'خطأ بالتحميل',
    'adminMagasins.confirmArchive': 'بدك تأرشف المحل {{code}}؟ الأصناف والمبيعات ما رح تنمحي.',
    'adminMagasins.genericError': 'خطأ',
    'adminMagasins.back': 'رجوع',
    'adminMagasins.title': 'المحلات',
    'adminMagasins.subtitle': 'إدارة المحلات (المحلات على الأرض)',
    'adminMagasins.filterActive': 'النشطة',
    'adminMagasins.filterArchived': 'المؤرشفة',
    'adminMagasins.filterAll': 'الكل',
    'adminMagasins.colCode': 'الكود',
    'adminMagasins.colName': 'الاسم',
    'adminMagasins.colAddress': 'العنوان',
    'adminMagasins.colPhone': 'التلفون',
    'adminMagasins.colPrinterIp': 'IP الطابعة',
    'adminMagasins.colColor': 'اللون',
    'adminMagasins.colStatus': 'الحالة',
    'adminMagasins.colActions': 'الإجراءات',
    'adminMagasins.loading': 'عم يحمّل…',
    'adminMagasins.emptyArchived': 'ما في محل مؤرشف.',
    'adminMagasins.emptyActive': 'ما في محل نشط.',
    'adminMagasins.defaultBadge': 'افتراضي',
    'adminMagasins.edit': 'تعديل',
    'adminMagasins.cannotArchiveDefault': 'ما بيصير — المحل الافتراضي',
    'adminMagasins.archive': 'أرشفة',
    'adminMagasins.restore': 'استرجاع',
    'adminMagasins.footerNote': 'المحلات المؤرشفة بتحتفظ بأصنافها ومبيعاتها (R1 — soft delete بس). المحل المعلّم بـ «{{badge}}» ما بينأرشف.',
    'adminPromos.title': 'العروض الترويجية الآلية',
    'adminPromos.subtitle': 'العروض الشغّالة والتقويم والإعدادات',
    'adminPromos.tabCurrent': 'العروض الشغّالة',
    'adminPromos.tabCalendar': 'التقويم الشهري',
    'adminPromos.tabSettings': 'الإعدادات',
    'adminPromos.forceDailyDraw': 'فرض سحب يومي جديد',
    'adminPromos.ref': 'المرجع: {{ref}}',
    'adminPromos.statusActive': '🟢 شغّال',
    'adminPromos.statusInactive': '⚫ مو شغّال',
    'adminPromos.endLabel': 'بينتهي: {{date}}',
    'adminPromos.emptyPromos': 'ما في عروض',
    'adminPromos.regenThisMonth': 'إعادة توليد هالشهر',
    'adminPromos.productsCount': '{{count}} منتج',
    'adminPromos.emptyCalendar': 'ما في تقويم — نعيد التوليد؟',
    'adminPromos.configDaily': 'البوت اليومي التلقائي',
    'adminPromos.excludedCategories': 'الفئات المستبعدة (مفصولة بفواصل)',
    'adminPromos.excludedKeywords': 'الكلمات المفتاحية المستبعدة (regex OR، اختياري — فاضي = بيستخدم الإعدادات الافتراضية)',
    'adminPromos.save': 'حفظ',
    'adminPromos.minPct': 'الحد الأدنى %',
    'adminPromos.maxPct': 'الحد الأقصى %',
    'adminPromos.confirmRegenDaily': 'نسحب عرض يومي جديد هلّق؟',
    'adminPromos.drawResult': 'سحب جديد: {{name}}',
    'adminPromos.statusResult': 'الحالة: {{status}}',
    'adminPromos.confirmRegenCalendar': 'نعيد توليد تقويم {{month}}؟ رح يستبدل الموجود.',
    'adminPromos.calendarRegenResult': '{{status}} — انستخدم {{count}} منتج',
    'adminPromos.settingsSaved': 'انحفظت الإعدادات',
    'adminCadbotPrix.source.ventePos': 'بيع عبر الكاشير',
    'adminCadbotPrix.source.reparation': 'تصليح',
    'adminCadbotPrix.source.devisValide': 'عرض سعر متأكد',
    'adminCadbotPrix.refSource.prixValide': 'سعر متأكد',
    'adminCadbotPrix.refSource.tarifPublic': 'السعر العام',
    'adminCadbotPrix.refSource.calculFournisseur': 'حساب التاجر',
    'adminCadbotPrix.refSource.aucune': 'ما في مرجع',
    'adminCadbotPrix.loadError': 'خطأ بالتحميل',
    'adminCadbotPrix.genericError': 'خطأ',
    'adminCadbotPrix.toastCollected': 'انحفظ {{ventes}} عملية بيع + {{reparations}} عملية تصليح',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} اقتراح جديد، {{maj}} تحديث',
    'adminCadbotPrix.priceInvalid': 'سعر غلط',
    'adminCadbotPrix.toastApproved': 'تأكّد السعر: {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'السعر اليدوي مقفول، الاقتراح بالانتظار',
    'adminCadbotPrix.toastApprovedPublished': 'تحدّثت صفحة الأسعار',
    'adminCadbotPrix.rejectReasonPrompt': 'سبب الرفض (اختياري):',
    'adminCadbotPrix.proposalRejected': 'انرفض الاقتراح',
    'adminCadbotPrix.settingsSaved': 'انحفظت الإعدادات',
    'adminCadbotPrix.confirmRemoveValidated': 'نشيل السعر المتأكد {{model}} · {{part}} · {{quality}}؟',
    'adminCadbotPrix.validatedRemoved': 'انشال السعر المتأكد',
    'adminCadbotPrix.pageTitle': 'تأكيد أسعار CADBOT',
    'adminCadbotPrix.pageSubtitle': 'CADBOT بيسجّل الأسعار يلي انفوترت فعليًا وبيقترح تعديلات. كل سعر متأكد بيغذّي صفحة الأسعار وبيصير أولوية بعروض الأسعار.',
    'adminCadbotPrix.rules': 'القواعد',
    'adminCadbotPrix.collecting': 'عم يجمع…',
    'adminCadbotPrix.memorizeSales': 'تسجيل المبيعات',
    'adminCadbotPrix.analyzing': 'عم يحلّل…',
    'adminCadbotPrix.analyze': 'تحليل',
    'adminCadbotPrix.minSales': 'أقل عدد مبيعات',
    'adminCadbotPrix.tolerancePct': 'أقل فرق (%)',
    'adminCadbotPrix.toleranceEur': 'أقل فرق (€)',
    'adminCadbotPrix.windowDays': 'المدة (أيام)',
    'adminCadbotPrix.publishOnApprove': 'النشر بصفحة الأسعار وقت التأكيد',
    'adminCadbotPrix.countDevisValides': 'نحسب كمان عروض أسعار الذكاء الاصطناعي المعتمدة (غير المبيعات المفوترة)',
    'adminCadbotPrix.filterPending': 'بانتظار التأكيد',
    'adminCadbotPrix.filterApproved': 'متأكدة',
    'adminCadbotPrix.filterRejected': 'مرفوضة',
    'adminCadbotPrix.filterAll': 'الكل',
    'adminCadbotPrix.refresh': 'تحديث',
    'adminCadbotPrix.loading': 'عم يحمّل…',
    'adminCadbotPrix.emptyProposals': 'ما في اقتراح {{scope}}. دوس «{{collect}}» وبعدين «{{analyze}}».',
    'adminCadbotPrix.emptyScopePending': 'بانتظار التأكيد',
    'adminCadbotPrix.tier': 'الفئة',
    'adminCadbotPrix.realSales': '{{count}} عملية بيع فعلية (من {{min}} لـ {{max}})',
    'adminCadbotPrix.lastSaleOn': 'آخر وحدة بـ {{date}}',
    'adminCadbotPrix.statusBadgePending': 'بانتظار التأكيد',
    'adminCadbotPrix.statusBadgeApproved': 'متأكدة',
    'adminCadbotPrix.statusBadgeRejected': 'مرفوضة',
    'adminCadbotPrix.referencePrice': 'السعر المرجعي',
    'adminCadbotPrix.medianRealSales': 'وسيط المبيعات الفعلية',
    'adminCadbotPrix.priceToValidate': 'السعر يلي بدنا نأكّده (قابل للتعديل)',
    'adminCadbotPrix.priceRetained': 'السعر المعتمد',
    'adminCadbotPrix.evidenceSales': 'المبيعات الداعمة ({{count}})',
    'adminCadbotPrix.thDate': 'التاريخ',
    'adminCadbotPrix.thSource': 'المصدر',
    'adminCadbotPrix.thRef': 'المرجع',
    'adminCadbotPrix.thDesignation': 'البيان',
    'adminCadbotPrix.thPriceTtc': 'السعر شامل الضريبة',
    'adminCadbotPrix.validate': 'تأكيد',
    'adminCadbotPrix.validateAt': 'بسعر {{price}} €',
    'adminCadbotPrix.reject': 'رفض',
    'adminCadbotPrix.reviewApproved': 'تأكدت من {{by}} بـ {{date}}',
    'adminCadbotPrix.reviewRejected': 'انرفضت من {{by}} بـ {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(سعر متعدّل يدوي: مقفول، السعر بالانتظار)',
    'adminCadbotPrix.validatedPrices': 'الأسعار المتأكدة ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'لسا ما في سعر متأكد.',
    'adminCadbotPrix.thDevice': 'الجهاز',
    'adminCadbotPrix.thPart': 'القطعة',
    'adminCadbotPrix.thTier': 'الفئة',
    'adminCadbotPrix.thPrice': 'السعر',
    'adminCadbotPrix.thValidated': 'متأكد',
    'adminCadbotPrix.salesCountShort': '{{count}} عملية بيع',
    'adminCadbotPrix.remove': 'شيل',
    'adminCommissions.typeVentes': 'مبيعات',
    'adminCommissions.typeCommandes': 'طلبات',
    'adminCommissions.typeAcomptes': 'دفعات مقدمة',
    'adminCommissions.typeReparations': 'تصليحات',
    'adminCommissions.typeFactures': 'فواتير',
    'adminCommissions.typeDevis': 'عروض أسعار',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'تنقّل',
    'adminCommissions.tagBackfill': 'إعادة احتساب',
    'adminCommissions.tagDoublonPotentiel': 'تكرار محتمل',
    'adminCommissions.tagSuspectReparation': 'تصليح مشبوه',
    'adminCommissions.tagSuspectCommande': 'طلب مشبوه',
    'adminCommissions.confirmCancel': 'بدّك تلغي هالعمولة؟',
    'adminCommissions.noSelection': 'ما في ولا سطر محدد',
    'adminCommissions.confirmBulkMarkPaid': 'تحديد {{count}} عمولة كمدفوعة؟',
    'adminCommissions.confirmRecompute30d': 'إعادة احتساب عمولات آخر 30 يوم للمبيعات الموجودة؟\nآمنة للتكرار: ما بتعمل نسخ مكررة.',
    'adminCommissions.recomputeResult': 'الفحص: {{scanned}} مبيعات — {{created}} عمولات تمّ إنشاؤها',
    'adminCommissions.error': 'خطأ: {{detail}}',
    'adminCommissions.title': 'العمولات',
    'adminCommissions.totalToPay': 'الإجمالي المستحق',
    'adminCommissions.alreadyPaid': 'المدفوع',
    'adminCommissions.recompute30d': 'إعادة احتساب آخر 30 يوم',
    'adminCommissions.recompute30dHint': 'إعادة احتساب رجعية للمبيعات الموجودة',
    'adminCommissions.configPerStaff': 'الإعداد لكل موظف',
    'adminCommissions.configure': 'إعداد',
    'adminCommissions.noStaffFound': 'ما في موظفين',
    'adminCommissions.filters': 'الفلاتر',
    'adminCommissions.allStatuses': 'كل الحالات',
    'adminCommissions.statusToPay': 'مستحقة الدفع',
    'adminCommissions.statusPaid': 'مدفوعة',
    'adminCommissions.statusCancelled': 'ملغاة',
    'adminCommissions.allStaff': 'كل الموظفين',
    'adminCommissions.allTypes': 'كل الأنواع',
    'adminCommissions.auditHeuristic': 'تدقيق استدلالي',
    'adminCommissions.auditAdvanced': 'تدقيق متقدم متعدد الإشارات',
    'adminCommissions.metierAuditReadOnly': 'تدقيق متقدم — للقراءة فقط · سجل Mongo سليم · محلل متعدد الإشارات بس',
    'adminCommissions.metierAuditLoading': 'عم يتم التحليل المهني…',
    'adminCommissions.ledgerCommissionStored': 'عمولة السجل (مخزّنة)',
    'adminCommissions.metierCommissionTheoretical': 'العمولة المهنية النظرية',
    'adminCommissions.totalGapPeriod': 'إجمالي فرق الفترة',
    'adminCommissions.rowsAnalyzed': 'الأسطر المحلّلة',
    'adminCommissions.typeMismatchDetected': 'اختلافات النوع المكتشفة',
    'adminCommissions.auditHeuristicLegend': 'تدقيق استدلالي: تصنيف حسب مرجع المعاملة. ما في كتابة بقاعدة البيانات.',
    'adminCommissions.legendRecompute30d': 'إعادة احتساب 30 يوم',
    'adminCommissions.combinedAuditNote': 'أعمدة Ledger = القيم المخزّنة بـ Mongo (النوع، لقطة المعدّل، commission_amount). أعمدة Métier = تحليل متعدد الإشارات + إعداد الموظف الحالي للنوع المكتشف.',
    'adminCommissions.bulkMarkPaid': 'تحديد كمدفوعة ({{count}})',
    'adminCommissions.clearSelection': 'إلغاء التحديد',
    'adminCommissions.colDate': 'التاريخ',
    'adminCommissions.colStaff': 'الموظف',
    'adminCommissions.colType': 'النوع',
    'adminCommissions.colTransaction': 'المعاملة',
    'adminCommissions.colAmount': 'المبلغ',
    'adminCommissions.colRateApplied': 'المعدّل المطبّق',
    'adminCommissions.colCommission': 'العمولة',
    'adminCommissions.colStatus': 'الحالة',
    'adminCommissions.colLedgerType': 'L. النوع',
    'adminCommissions.colLedgerRate': 'L. المعدّل',
    'adminCommissions.colLedgerCommission': 'L. العمولة',
    'adminCommissions.colMetierType': 'M. النوع',
    'adminCommissions.colMetierRate': 'M. المعدّل',
    'adminCommissions.colMetierCommission': 'M. العمولة',
    'adminCommissions.colGap': 'الفرق',
    'adminCommissions.colAuditSignals': 'إشارات التدقيق',
    'adminCommissions.colRealType': 'النوع الفعلي (تدقيق)',
    'adminCommissions.colAppliedType': 'النوع المطبّق',
    'adminCommissions.colSource': 'المصدر',
    'adminCommissions.loading': 'عم يتم التحميل…',
    'adminCommissions.mixed': 'مختلط',
    'adminCommissions.pairLabel': 'الزوج: {{id}}',
    'adminCommissions.expectedLabel': 'المتوقع: {{type}}',
    'adminCommissions.markPaidShort': 'مدفوع',
    'adminCommissions.noCommissionInFilter': 'ما في عمولة بهالفلتر',
    'adminCommissions.noCommissionHint': 'إذا انفعّلت عمولة هلق، استخدم زر «إعادة احتساب آخر 30 يوم» فوق.',
    'adminCommissions.modalTitle': 'عمولات {{name}}',
    'adminCommissions.cancel': 'إلغاء',
    'adminCommissions.save': 'حفظ',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'فشل',
    'adminCloud.status.skipped': 'متخطّى',
    'adminCloud.docType.ticket': 'تذكرة إصلاح',
    'adminCloud.docType.facture': 'فاتورة',
    'adminCloud.docType.acompte': 'دفعة مقدمة',
    'adminCloud.docType.devis': 'عرض سعر',
    'adminCloud.docType.bonCommande': 'أمر شراء',
    'adminCloud.errors.load': 'خطأ بالتحميل',
    'adminCloud.errors.save': 'خطأ بالحفظ',
    'adminCloud.errors.test': 'خطأ بالاختبار',
    'adminCloud.errors.rebuild': 'خطأ بإعادة البناء',
    'adminCloud.errors.syncToggle': 'خطأ بتبديل المزامنة.',
    'adminCloud.save.success': 'تم حفظ الإعدادات (المفتاح الصريح ما بينعاد إرساله أبدًا).',
    'adminCloud.test.ok': '✓ الاتصال شغّال — {{name}} (المالك: {{owner}}، بتنتهي: {{expires}})',
    'adminCloud.test.ko': 'فشل الاتصال: {{error}}',
    'adminCloud.test.unknownError': 'غير معروف',
    'adminCloud.hierarchy.ok': '✓ التسلسل الهرمي تمام — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'فشل التسلسل الهرمي — {{message}}',
    'adminCloud.access.adminRequired': 'لازم صلاحية مشرف.',
    'adminCloud.sync.resumed': 'رجعت مزامنة السحابة تشتغل.',
    'adminCloud.sync.paused': 'انحطّت مزامنة السحابة ع وقف مؤقت.',
    'adminCloud.title': 'مزامنة السحابة — remobiles.fr',
    'adminCloud.subtitlePre': 'ملفات الـPDF تبعتك (التذاكر، الفواتير، عروض الأسعار، الدفعات المقدمة) بتنأرشف أوتوماتيكيًا بمساحتك الخاصة',
    'adminCloud.refresh': 'تحديث',
    'adminCloud.sync.active': 'مزامنة السحابة شغّالة',
    'adminCloud.sync.pausedLabel': 'مزامنة السحابة ع وقف مؤقت',
    'adminCloud.sync.pausedAt': 'انحطّت ع وقف بـ {{date}}',
    'adminCloud.sync.pausedBy': ' من قبل {{by}}',
    'adminCloud.sync.activeHint': 'كل مستندات الـPDF الجديدة بترفع أوتوماتيكيًا ع remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'وقف مؤقت',
    'adminCloud.sync.resumeBtn': 'استئناف',
    'adminCloud.confirm.resumeTitle': 'نرجّع المزامنة تشتغل؟',
    'adminCloud.confirm.pauseTitle': 'نوقّف المزامنة مؤقتًا؟',
    'adminCloud.confirm.resumeBody': 'المستندات الجديدة رح ترجع تترفع أوتوماتيكيًا ع remobiles.fr.',
    'adminCloud.confirm.pauseBody': 'ما رح يترفع ولا مستند جديد لحتى ترجّع المزامنة. المستندات الموجودة ما رح تتأثر.',
    'adminCloud.cancel': 'إلغاء',
    'adminCloud.stats.globalStatus': 'الحالة العامة',
    'adminCloud.stats.enabled': 'مفعّل',
    'adminCloud.stats.disabled': 'معطّل',
    'adminCloud.stats.uploadsOk': 'الرفعات الناجحة',
    'adminCloud.stats.uploadsKo': 'الرفعات الفاشلة',
    'adminCloud.stats.total': 'الإجمالي',
    'adminCloud.structure.title': 'بنية السحابة المستهدفة (التسلسل الهرمي الحقيقي)',
    'adminCloud.structure.cachedTotal': '{{count}} مجلد بالكاش',
    'adminCloud.structure.createdThisMonth': '{{count}} تخلّق هالشهر',
    'adminCloud.structure.retryHierarchy': 'إعادة محاولة إنشاء التسلسل الهرمي',
    'adminCloud.structure.noUploadToday': '(ما في رفع اليوم)',
    'adminCloud.structure.flat': '(مسطّح)',
    'adminCloud.structure.recentFolders': 'المجلدات المنشأة مؤخرًا',
    'adminCloud.structure.noFolderCache': '(ما في مجلد بالكاش)',
    'adminCloud.structure.policyLabel': 'سياسة',
    'adminCloud.structure.policyBody': ': ما بينبعت أبدًا حذف لمجلد أو ملف ع remobiles.fr. ملفات الاختبار بتضل ظاهرة ع جهة السحابة.',
    'adminCloud.loading': 'عم يحمّل...',
    'adminCloud.connection.title': 'إعدادات الاتصال',
    'adminCloud.connection.uploadUrl': 'رابط الرفع',
    'adminCloud.connection.status': 'الحالة',
    'adminCloud.connection.enableAuto': 'تفعيل المزامنة الأوتوماتيكية',
    'adminCloud.connection.currentKey': 'مفتاح API الحالي: {{masked}}',
    'adminCloud.connection.noKey': '<ما في>',
    'adminCloud.connection.keyPlaceholder': 'الصق هون مفتاح جديد للاستبدال (rcsk_...)',
    'adminCloud.connection.keyHint': 'المفتاح مشفّر (Fernet) بقاعدة البيانات. خلّيه فاضي إذا ما بدّك تغيّرو.',
    'adminCloud.save.btn': 'حفظ',
    'adminCloud.test.btn': 'اختبار الاتصال (whoami)',
    'adminCloud.test.lastTest': 'آخر اختبار: {{mark}} {{date}}',
    'adminCloud.logs.title': 'سجل الرفعات',
    'adminCloud.logs.allStatuses': 'كل الحالات',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'فشل',
    'adminCloud.logs.filterSkipped': 'متخطّى',
    'adminCloud.logs.allTypes': 'كل الأنواع',
    'adminCloud.logs.typeTickets': 'التذاكر',
    'adminCloud.logs.typeFactures': 'الفواتير',
    'adminCloud.logs.typeAcomptes': 'الدفعات المقدمة',
    'adminCloud.logs.typeDevis': 'عروض الأسعار',
    'adminCloud.logs.typeBonsCommande': 'أوامر الشراء',
    'adminCloud.logs.colDate': 'التاريخ',
    'adminCloud.logs.colType': 'النوع',
    'adminCloud.logs.colRef': 'المرجع',
    'adminCloud.logs.colStatus': 'الحالة',
    'adminCloud.logs.colFolder': 'المجلد',
    'adminCloud.logs.colError': 'الخطأ',
    'adminCloud.logs.empty': 'ما في رفعات لهلّق.',
    'size50x30': '50 × 30 مم (معيار Bixolon)',
    'protocolZpl': 'ZPL (موصى فيه لأجهزة Bixolon الجديدة)',
    'protocolBpl': 'BPL (قديم / سلسلة SLP)',
    'fieldClientName': 'اسم الزبون',
    'fieldClientPhone': 'تلفون الزبون',
    'fieldDeviceLock': 'الكود / القفل',
    'fieldModel': 'الموديل',
    'fieldParts': 'القطع / العطل',
    'fieldDate': 'التاريخ',
    'fieldPrice': 'السعر',
    'fieldRef': 'المرجع REM-XXX',
    'errLoad': 'خطأ بتحميل الإعدادات',
    'saved': 'انحفظت الإعدادات.',
    'errSave': 'خطأ بالحفظ',
    'previewNeedRef': 'دخّل مرجع REM-XXX للمعاينة.',
    'errPreview': 'خطأ بإنشاء المعاينة',
    'testQueued': 'انبعت الاختبار عقائمة الانتظار. الوكيل المحلي رح يعالجه أول ما يتصل.',
    'errTest': 'خطأ باختبار الطابعة',
    'confirmRotate': 'إعادة توليد التوكن رح تلغي القديم. بدك تكمّل؟',
    'tokenGenerated': 'انتولّد توكن جديد. انسخه ولصقه بإعدادات الوكيل المحلي.',
    'errRotate': 'خطأ بإعادة توليد التوكن',
    'tokenCopied': 'اننسخ التوكن عالحافظة.',
    'copyFailed': 'ما قدرنا ننسخ.',
    'errDownloadPack': 'ما قدرنا ننزّل{{http}}: {{detail}}',
    'downloadLinkUnavailable': 'رابط التنزيل مش متوفر',
    'downloadStartedHint': 'بلّش التنزيل. إذا ما صار شي، اسمح بالتنزيلات بالمتصفح.',
    'errDownloadApp': 'ما قدرنا ننزّل التطبيق{{http}}: {{detail}}',
    'agentExeDownloaded': 'اننزّل وكيل Windows بنجاح.',
    'errDownloadAgent': 'ما قدرنا ننزّل الوكيل{{http}}: {{detail}}',
    'packDownloaded': 'اننزّلت حزمة الوكيل بنجاح.',
    'securityTitle': 'أمان طابعة الشبكة',
    'securityBody': 'تذكّر تغيّر كلمة سر الأدمن الافتراضية (admin/admin) وتعطّل TELNET و FTP من واجهة الويب تبع الطابعة',
    'securityNoInternet': 'لا تعرّض البورت 9100 عالإنترنت أبدًا.',
    'downloadsTitle': 'التنزيلات والمثبّتات',
    'downloadsDesc': 'وصول مباشر لملفات ZIP تبع Windows ووكيل الطابعة وصفحة الاستبدال المباشر.',
    'openInstallers': 'فتح المثبّتات',
    'loading': 'عم يحمّل...',
    'bixolonSection': 'Bixolon - ملصقات QR',
    'fieldPrinterName': 'اسم الطابعة',
    'fieldIp': 'عنوان IP',
    'fieldPortRaw': 'البورت (RAW socket)',
    'fieldIpMethod': 'طريقة IP',
    'ipMethodManual': 'يدوي (IP ثابت)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'الشبكة الفرعية',
    'fieldGateway': 'البوابة',
    'fieldDns': 'DNS',
    'fieldProtocol': 'بروتوكول الطباعة',
    'fieldDefaultLabelFormat': 'تنسيق الملصق الافتراضي',
    'printerActive': 'الطابعة شغّالة',
    'testConnection': 'اختبار الاتصال',
    'lastTest': 'آخر اختبار: {{date}}',
    'epsonSection': 'Epson - إيصالات الصندوق',
    'epsonDesc': 'هالقيم بتُستخدم للإيصالات قياس 80 مم. وكيل Windows بيقرا هالإعدادات وبعدين بيبعت الإيصال لطابعة Epson تبع المحل.',
    'fieldTicketIp': 'عنوان IP لطابعة Epson',
    'fieldTicketPort': 'بورت Epson',
    'fieldTicketProtocol': 'بروتوكول الإيصال',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (احتياطي)',
    'agentSection': 'الوكيل المحلي',
    'agentDesc': 'الوكيل المحلي بيشتغل على جهاز ضمن الشبكة المحلية (LAN)، بيستقبل المهام عبر الاستطلاع (polling) وبيبعت ملصقات Bixolon أو إيصالات Epson للطابعات المهيّأة. بينستعمل رمز API ليوثّق حاله كوكيل.',
    'tokenCopyNow': 'التوكن (انسخه هلأ - ما رح ينعرض مرة تانية):',
    'agentTokenLabel': 'توكن الوكيل',
    'tokenCreated': '(منشأ)',
    'tokenNotGenerated': '(ما تولّد)',
    'noToken': '— ما في توكن —',
    'hide': 'إخفاء',
    'show': 'إظهار',
    'copy': 'نسخ',
    'regenerateToken': 'إعادة توليد التوكن',
    'generateToken': 'توليد التوكن',
    'agentWinTitle': 'وكيل Windows المحلي',
    'agentWinDesc': 'نزّل الوكيل الجاهز للتشغيل، أو حزمة zip إذا احتجت تعيد بناء الوكيل على جهاز Windows.',
    'directLinks': 'روابط مباشرة',
    'dlDesktopApp': 'تطبيق Windows للموظفين',
    'dlAgentExe': 'وكيل Windows (.exe)',
    'dlAgentPack': 'حزمة الوكيل (.zip)',
    'tempLinksNote': 'روابط مؤقتة موقّعة تلقائيًا. بتنتهي صلاحيتها بعد كم دقيقة.',
    'downloading': 'عم ينزّل...',
    'dlAgentExeBtn': 'تنزيل وكيل Windows (.exe)',
    'dlAgentPackBtn': 'تنزيل حزمة الوكيل (.zip)',
    'desktopAppDesc': 'نزّل تطبيق سطح المكتب R.E.Mobiles المجمّع مسبقًا. بيشغّل الواجهة الأمامية المحلية والواجهة الخلفية المحلية ووكيل الطباعة المضمّن.',
    'dlDesktopAppBtn': 'تنزيل تطبيق Windows (.zip)',
    'printedFields': 'الحقول المطبوعة',
    'fieldFontSize': 'حجم الخط (6-16)',
    'fieldMargin': 'الهامش (0-24 نقطة)',
    'previewPdf': 'معاينة PDF',
    'previewDesc': 'إنشاء ملصق PDF تجريبي لتصليح موجود.',
    'previewRefPlaceholder': 'مرجع REM-XXX',
    'previewBtn': 'معاينة',
    'save': 'حفظ',
    'reload': 'إعادة التحميل',
    'errUnknown': 'خطأ غير معروف',
    'adminPertes.title': 'الخسائر',
    'adminPertes.subtitle': 'مبيعات برّا المخزون انقبضت بأقل من سعر الكتالوج وخصومات فوق الحد المسموح، حسب البائع.',
    'adminPertes.exportCsv': 'تصدير CSV',
    'adminPertes.recalcul': 'إعادة الحساب عالسجل',
    'adminPertes.typeHorsStock': 'برّا المخزون بأقل من السعر',
    'adminPertes.typeRemise': 'خصم زايد',
    'adminPertes.typeSousCatalogue': 'سعر أقل من الكتالوج',
    'adminPertes.preset30j': '30 ي',
    'adminPertes.preset3m': '3 أشهر',
    'adminPertes.preset12m': '12 شهر',
    'adminPertes.presetCustom': 'مخصّص',
    'adminPertes.payCb': 'بطاقة مصرفية',
    'adminPertes.payCash': 'كاش',
    'adminPertes.payCheque': 'شيك',
    'adminPertes.payVirement': 'تحويل',
    'adminPertes.payMixte': 'مختلط',
    'adminPertes.payAvoir': 'رصيد',
    'adminPertes.payAcompte': 'عربون',
    'adminPertes.periode': 'الفترة: {{debut}} → {{fin}}',
    'adminPertes.du': 'من',
    'adminPertes.au': 'إلى',
    'adminPertes.vendeur': 'البائع',
    'adminPertes.type': 'النوع',
    'adminPertes.magasin': 'المتجر',
    'adminPertes.tous': 'الكل',
    'adminPertes.tileTotal': 'إجمالي الخسارة',
    'adminPertes.calculeLe': 'انحسب بـ {{date}}',
    'adminPertes.remisesExcessives': 'خصومات زايدة',
    'adminPertes.auDelaDe': 'أكثر من {{pct}}',
    'adminPertes.tileNb': 'المبيعات المعنيّة',
    'adminPertes.parVendeur': 'حسب البائع',
    'adminPertes.loading': 'عم يحمّل…',
    'adminPertes.aucunePerte': 'ما في خسائر بالفترة.',
    'adminPertes.colTotal': 'الإجمالي',
    'adminPertes.colNbVentes': 'عدد المبيعات',
    'adminPertes.filtrerVendeur': 'فلترة التفاصيل عـ هالبائع',
    'adminPertes.detailTitle': 'تفاصيل المبيعات',
    'adminPertes.pageRange': '{{from}}–{{to}} من {{total}}',
    'adminPertes.pageN': 'صفحة {{page}}',
    'adminPertes.aucuneLigne': 'ما في صفوف لهالفلاتر.',
    'adminPertes.colDate': 'التاريخ',
    'adminPertes.colTicket': 'الإيصال',
    'adminPertes.colArticle': 'الصنف',
    'adminPertes.colQte': 'الكمية',
    'adminPertes.colPrixVendu': 'سعر البيع',
    'adminPertes.colPrixRef': 'السعر المرجعي',
    'adminPertes.colRemise': 'الخصم',
    'adminPertes.colPerte': 'الخسارة',
    'adminPertes.trierPerte': 'ترتيب حسب الخسارة',
    'adminPertes.colStatut': 'الحالة',
    'adminPertes.colActions': 'إجراءات',
    'adminPertes.ticket': 'الإيصال',
    'adminPertes.ouvrirTicket': 'فتح إيصال الصندوق (PDF) بتبويب جديد',
    'adminPertes.voirVente': 'عرض البيع',
    'adminPertes.masquerVente': 'إخفاء محتوى البيع',
    'adminPertes.voirVenteTitle': 'شوف شو انباع بهالإيصال',
    'adminPertes.venteLabel': 'بيع',
    'adminPertes.paiement': 'الدفع:',
    'adminPertes.contenuIndispo': 'محتوى البيع مش متوفر لهالإيصال (افتح إيصال الـ PDF).',
    'adminPertes.ligneEnPerte': '(سطر فيه خسارة)',
    'adminPertes.totalVente': 'إجمالي البيع:',
    'adminPertes.precedent': 'السابق',
    'adminPertes.suivant': 'التالي',
    'adminPertes.lignesParPage': '{{count}} صفوف بالصفحة',
    'adminPertes.legendeTitle': 'كيف بتنحسب الخسائر',
    'adminPertes.legendeHorsStockText': 'بيع «برّا المخزون» انقبض بأقل من سعر الكتالوج مع إنو الصنف كان موجود بقاعدة البيانات وقت البيع. الخسارة =',
    'adminPertes.legendeHorsStockFormula': '(السعر المرجعي − سعر البيع) × الكمية',
    'adminPertes.legendeRemiseText': 'خصم أكبر من {{seuil}} على سطر بيع. بس الجزء يلي فوق {{seuil}} بينحسب:',
    'adminPertes.legendeRemiseFormula': '(الخصم − {{seuil}}) × السعر المرجعي × الكمية',
    'adminPertes.legendeSousCatalogue': 'صنف موجود بالمخزون انباع بأقل من سعر الكتالوج بدون خصم معلَن: نفس معادلة «برّا المخزون بأقل من السعر».',
    'adminPertes.legendeFooter': 'السعر المرجعي هو سعر الكتالوج للصنف بتاريخ البيع. «إعادة الحساب عالسجل» بتعيد قراءة كل المبيعات السابقة؛ العرض الحالي مخزَّن مؤقتًا وبينحدّث تلقائيًا.',
    'adminPertes.confirmRecalcul': 'بدك تعيد حساب الخسائر على كل سجل المبيعات؟ هالعملية بتعيد قراءة كل المبيعات السابقة وممكن تاخد شوي وقت.',
    'adminPertes.recalculDone': 'خلصت إعادة الحساب — تحللت {{count}} عملية بيع',
    'adminPertes.recalculDoneGeneric': 'خلصت إعادة الحساب على كل السجل',
    'adminPertes.recalculFail': 'فشلت إعادة الحساب',
    'adminPertes.exportDone': 'تنزّل ملف الـ CSV',
    'adminPertes.exportUnavailable': 'التصدير مش متوفر (لازم تحدّث الخادم)',
    'adminPertes.exportFail': 'فشل التصدير',
    'adminPertes.refManquante': 'مرجع البيع ناقص: ما لقينا الإيصال',
    'adminPertes.ticketFail': 'ما قدرنا نفتح الإيصال',
    'adminPertes.endpointIndispo': 'نقطة النهاية «الخسائر» مش متوفرة (لازم تحدّث الخادم).',
    'adminPertes.errLoad': 'خطأ بالتحميل',
    'adminPertes.ticketTooltipRef': 'الإيصال {{ref}}',
    'adminPertes.lignes_one': '{{count}} صف',
    'adminPertes.lignes_other': '{{count}} صفوف',
    'adminPertes.articles_one': '{{count}} صنف',
    'adminPertes.articles_other': '{{count}} أصناف',
    'adminPertes.autres_one': '(+{{count}} غيرو)',
    'adminPertes.autres_other': '(+{{count}} غيرن)',
    'adminTodo.cat.ventesHorsStock': 'مبيعات برّا المخزون لازم تتأكّد',
    'adminTodo.cat.cadbotPrix': 'أسعار CADBOT لازم تتثبّت',
    'adminTodo.cat.devisChat': 'عروض الأسعار من الشات لازم تتعالج',
    'adminTodo.cat.acomptesACommander': 'عرابين ← قطع لازم تنطلب',
    'adminTodo.cat.commandesSansSuivi': 'طلبيات بلا رقم تتبّع',
    'adminTodo.cat.sumupAConfirmer': 'دفعات SumUp لازم تتأكد',
    'adminTodo.cat.factureRequests': 'طلبات فاتورة',
    'adminTodo.groupFallback': 'مجموعة',
    'adminTodo.time.now': 'هلّق',
    'adminTodo.time.minutesAgo': 'من {{n}} دقيقة',
    'adminTodo.time.hoursAgo': 'من {{n}} ساعة',
    'adminTodo.error.endpointUnavailable': 'نقطة الوصول «المهام» مو متوفرة (لازم نحدّث الباكند).',
    'adminTodo.error.load': 'خطأ بالتحميل',
    'adminTodo.settings.unavailable': 'الإعدادات مو متوفرة (لازم نحدّث الباكند).',
    'adminTodo.settings.notLoaded': 'الإعدادات ما انحمّلت',
    'adminTodo.settings.saved': 'انحفظت الإعدادات',
    'adminTodo.settings.saveError': 'ما قدرنا نحفظ الإعدادات',
    'adminTodo.title': 'المهام',
    'adminTodo.subtitleUpdated': 'آخر تحديث {{time}} · بيتحدّث لحاله كل 60 ثانية',
    'adminTodo.subtitleDefault': 'كل شي لازمه إجراء، بمكان واحد.',
    'adminTodo.notifications': 'الإشعارات',
    'adminTodo.refresh': 'تحديث',
    'adminTodo.settings.saving': 'عم يحفظ…',
    'adminTodo.settings.loading': 'عم يحمّل الإعدادات…',
    'adminTodo.settings.pushLabel': 'إشعار فوري عالموبايل',
    'adminTodo.settings.pushHint': 'تنبيه أول ما يطلع إجراء جديد.',
    'adminTodo.settings.digestLabel': 'ملخّص يومي الساعة 9 الصبح',
    'adminTodo.settings.digestHint': 'رسالة وحدة كل صبح بكل اللي ضلّ عليك.',
    'adminTodo.settings.categoriesTracked': 'الفئات المتابَعة',
    'adminTodo.allClear': 'ما في شي مستني. كل شي محدّث.',
    'adminTodo.groupNothingPending': 'ما في شي مستني',
    'adminTodo.open': 'فتح',
    'adminTodo.seeAll': 'شوف كل العناصر ({{count}})',
    'adminTodo.openPage': 'فتح الصفحة',
    'adminTodo.pushOn': 'الإشعارات الفورية شغّالة',
    'adminTodo.pushOff': 'الإشعارات الفورية مطفية',
    'adminTodo.digestOn': 'ملخّص الساعة 9 شغّال',
    'adminTodo.digestOff': 'ملخّص الساعة 9 مطفي',
    'adminUsers.role.super_admin.label': 'المشرف الأعلى',
    'adminUsers.role.super_admin.desc': 'وصول كامل للنظام كلو (carlos بس)',
    'adminUsers.role.admin_magasin.label': 'مدير المحل',
    'adminUsers.role.admin_magasin.desc': 'بيدير محل واحد أو كم محل مسندين إلو',
    'adminUsers.role.technicien.label': 'فني صيانة',
    'adminUsers.role.technicien.desc': 'تذاكر الصيانة للمحلين. بدون POS، بدون محاسبة.',
    'adminUsers.role.vendeur.label': 'بياع',
    'adminUsers.role.vendeur.desc': 'POS بكل المحلات. بدون محاسبة، بدون إدارة.',
    'adminUsers.roleUnknown': 'مش معروف',
    'adminUsers.modal.editTitle': 'تعديل {{username}}',
    'adminUsers.createUser': 'إنشاء مستخدم',
    'adminUsers.field.username': 'اسم المستخدم',
    'adminUsers.field.passwordEdit': 'كلمة سر جديدة (خليها فاضية لتضل نفسها)',
    'adminUsers.field.passwordCreate': 'كلمة السر * (الأقل {{min}} حرف)',
    'adminUsers.field.email': 'الإيميل',
    'adminUsers.field.telephone': 'التلفون',
    'adminUsers.field.role': 'دور بالمحل',
    'adminUsers.field.assignedMagasins': 'المحلات المسندة',
    'adminUsers.modal.minOneRequired': '(لازم واحد عالأقل)',
    'adminUsers.modal.ignoredForRole': '— بينحفظ بس بينتجاهل لهالدور (النطاق = كل المحلات)',
    'adminUsers.modal.loadingMagasins': 'عم يحمّل المحلات…',
    'adminUsers.modal.posOnlyTitle': 'غايب / موقوف — POS بس',
    'adminUsers.modal.posOnlyDesc': 'فيه يسجّل دخول ويقبض عالـ POS، بدون ما يوصل للصفحات التانية (التصليحات، المخزون، الزباين، الإدارة…).',
    'adminUsers.action.cancel': 'إلغاء',
    'adminUsers.action.save': 'حفظ',
    'adminUsers.action.create': 'إنشاء',
    'adminUsers.denied.title': 'الوصول مرفوض',
    'adminUsers.denied.desc': 'هالصفحة مخصصة للمشرف الأعلى بس.',
    'adminUsers.denied.back': 'رجوع للوحة التحكم',
    'adminUsers.error.load': 'خطأ بالتحميل',
    'adminUsers.error.passwordMin': 'لازم كلمة السر تكون {{min}} حرف عالأقل.',
    'adminUsers.feedback.updated': 'تم تحديث المستخدم {{username}}.',
    'adminUsers.feedback.created': 'تم إنشاء المستخدم {{username}}.',
    'adminUsers.error.operation': 'صار خطأ أثناء العملية',
    'adminUsers.error.needsMagasinPick': 'اختار أول شي محل الجلسة (النافذة بنص الشاشة)، وبعدين أنشئ المستخدم.',
    'adminUsers.feedback.disabled': 'تم تعطيل {{username}}.',
    'adminUsers.feedback.enabled': 'تمت إعادة تفعيل {{username}}.',
    'adminUsers.error.generic': 'خطأ',
    'adminUsers.action.back': 'رجوع',
    'adminUsers.title': 'المستخدمين الداخليين',
    'adminUsers.subtitle': 'إنشاء / تعديل / تعطيل (المشرف الأعلى بس)',
    'adminUsers.limitInfo': '{{current}}/{{max}} مستخدم · خطة {{plan}}',
    'adminUsers.limitReachedTitle': 'وصلت للحد الأقصى ({{max}} مستخدم كحد أقصى)',
    'adminUsers.limitReached': 'وصلت للحد الأقصى ({{max}})',
    'adminUsers.includeDisabled': 'تضمين المستخدمين المعطّلين',
    'adminUsers.col.role': 'الدور',
    'adminUsers.col.emailTel': 'الإيميل / التلفون',
    'adminUsers.col.status': 'الحالة',
    'adminUsers.col.actions': 'الإجراءات',
    'adminUsers.empty': 'ما في مستخدمين.',
    'adminUsers.allMagasins': 'الكل',
    'adminUsers.status.active': 'فعّال',
    'adminUsers.status.disabled': 'معطّل',
    'adminUsers.status.posOnly': 'غايب · POS بس',
    'adminUsers.action.edit': 'تعديل',
    'adminUsers.commissions': 'العمولات',
    'adminUsers.action.disable': 'تعطيل',
    'adminUsers.action.enable': 'إعادة التفعيل',
    'adminHorsStock.stockUnknown': 'المخزون غير معروف',
    'adminHorsStock.stockCount': 'المخزون {{count}}',
    'adminHorsStock.selected': 'محدد',
    'adminHorsStock.lineDefaultDesignation': 'غرض',
    'adminHorsStock.loadError': 'خطأ بالتحميل',
    'adminHorsStock.lineStillUnresolved': 'لسا في بند «لازم يتأكد» أو بدون مرجع مربوط.',
    'adminHorsStock.saleValidatedWithLoss': 'تم تأكيد البيع {{ref}} — {{total}} بالسجل. الخسارة المسجّلة: {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'تم تأكيد البيع {{ref}} — {{total}} بالسجل، بدون خسارة.',
    'adminHorsStock.validationFailed': 'ما قدرنا نأكّد',
    'adminHorsStock.catalogBadge': 'الكتالوج',
    'adminHorsStock.cashedLineInfo': 'المقبوض {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'خارج المخزون',
    'adminHorsStock.articleExistedQuestion': 'كان الغرض موجود؟',
    'adminHorsStock.optionLoss': 'خسارة — الغرض كان موجود، اربط المرجع',
    'adminHorsStock.optionNonExistent': 'غرض مو موجود — اقبلو متل ما هو',
    'adminHorsStock.optionToVerify': 'لازم يتأكد',
    'adminHorsStock.attachedArticle': 'الغرض المربوط',
    'adminHorsStock.refLabel': 'المرجع {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'سعر الكتالوج',
    'adminHorsStock.unknown': 'غير معروف',
    'adminHorsStock.soldLabel': 'المبيع',
    'adminHorsStock.estimatedLoss': 'الخسارة المقدّرة',
    'adminHorsStock.selectCatalogRef': 'اختار مرجع الكتالوج يلي بيطابق هالغرض.',
    'adminHorsStock.catalogSuggestions': 'اقتراحات الكتالوج',
    'adminHorsStock.noSuggestion': 'ما في اقتراحات لهالبند — استخدم البحث تحت.',
    'adminHorsStock.otherCatalogArticle': 'غرض تاني من الكتالوج',
    'adminHorsStock.searchPlaceholder': 'دوّر بالمرجع / التسمية / EAN…',
    'adminHorsStock.noArticleFound': 'ما انلقى ولا غرض.',
    'adminHorsStock.freeArticleInfo': 'غرض حر: البند بيضل متل ما هو، بدون ربط ولا حركة مخزون.',
    'adminHorsStock.toVerifyInfo': 'بيمنع التأكيد لحتى ينحسم البند (نعم / لأ).',
    'adminHorsStock.toValidateBadge': 'لازم يتأكد',
    'adminHorsStock.cashedBadge': 'مقبوضة',
    'adminHorsStock.cashedAmountLabel': 'المقبوض',
    'adminHorsStock.subtotal': 'المجموع الفرعي',
    'adminHorsStock.discountLabel': 'الحسم',
    'adminHorsStock.historyTotal': 'إجمالي السجل',
    'adminHorsStock.amountLockedInfo': 'المبلغ المقبوض فعليًا: ما فيك تعدّل السعر والكميات والحسم هون.',
    'adminHorsStock.lossesPreview': 'معاينة الخسائر (بس الإدارة بتشوفها)',
    'adminHorsStock.remiseExcessiveLabel': 'حسم أكتر من {{seuil}}٪ (المعطى {{pct}})',
    'adminHorsStock.lossRecorded': 'الخسارة المثبّتة',
    'adminHorsStock.lossSavedInfo': 'بتنسجّل بصفحة الخسائر وقت التأكيد.',
    'adminHorsStock.noLossYet': 'ما في خسارة مثبّتة بهالمرحلة',
    'adminHorsStock.noLossYetSuffix': ' — الحساب بيكمل أول ما تنربط المراجع.',
    'adminHorsStock.noteLabel': 'ملاحظة (اختياري)',
    'adminHorsStock.notePlaceholder': 'مثال: سعر متّفق عليه، الغرض وصل بتاريخ…',
    'adminHorsStock.validateButton': 'أكّد واكتب بالسجل',
    'adminHorsStock.blockedTitle': 'لسا في بند أو أكتر خارج المخزون لازم ينحسم',
    'adminHorsStock.validationBlocked': 'التأكيد متوقّف:',
    'adminHorsStock.blockedVerifierCount': '{{n}} بند «لازم يتأكد»',
    'adminHorsStock.blockedNoRefCount': '{{n}} بند «نعم» بدون مرجع مربوط',
    'adminHorsStock.legendTitle': 'شو بيصير',
    'adminHorsStock.legendIntro': 'البيع مقبوض من قبل: ما فيك تلغيه ولا بيتعدّل المخزون. التأكيد بيربط الغرض الصح، وبيسجّل فرق السعر أو الحسم الزيادة بالخسائر، وبعدين بيكتب البيع بالسجل.',
    'adminHorsStock.legendYesWord': 'نعم',
    'adminHorsStock.legendYesDesc': '— الغرض كان موجود: اختار مرجع الكتالوج (الاقتراحات أو البحث).',
    'adminHorsStock.legendNonWord': 'لأ',
    'adminHorsStock.legendNonDesc': '— غرض حر، بيضل متل ما هو.',
    'adminHorsStock.legendVerifierDesc': '— بيمنع التأكيد لحتى ينحسم البند.',
    'adminHorsStock.legendPertesWord': 'الخسائر',
    'adminHorsStock.legendPertesDesc': '— الفرق بين سعر الكتالوج وسعر البيع، وكمان حصة الحسم يلي أكتر من {{seuil}}٪ من المجموع الفرعي؛ بتنشاف بس هون ومسجّلة بصفحة الخسائر.',
    'adminHorsStock.pageTitle': 'مبيعات خارج المخزون لازم تتأكد',
    'adminHorsStock.pageSubtitle': 'مقبوضة من قبل؛ مو موجودة بالسجل لحتى تأكّدها الإدارة.',
    'adminHorsStock.refresh': 'تحديث',
    'adminHorsStock.emptyState': 'ما في مبيعات خارج المخزون ناطرة تأكيد.',
    'adminHorsStock.processedThisSession': 'يلي انعالجت بهالجلسة',
    'adminHorsStock.lossShortLabel': 'خسارة',
    'adminHorsStock.validatedBadge': 'مأكّدة',
    'stockPhotoAi.title': 'صور المخزون · الذكاء الاصطناعي',
    'stockPhotoAi.subtitle': 'المشرف الأعلى Carlos · توليد OpenAI · محل معزول M1/M2',
    'stockPhotoAi.apiKeysLink': 'مفاتيح OpenAI API',
    'stockPhotoAi.statsTotal': 'أصناف {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'مع صورة',
    'stockPhotoAi.statsMissing': 'بدون صورة',
    'stockPhotoAi.searchPlaceholder': 'دوّر على المرجع أو الوصف…',
    'stockPhotoAi.filter': 'فلترة',
    'stockPhotoAi.generateBatch': 'توليد دفعة (بحد أقصى 10)',
    'stockPhotoAi.batchResult': 'الدفعة {{mag}}: {{ok}} ناجح · {{skipped}} متجاوَز · {{errors}} أخطاء',
    'stockPhotoAi.loading': 'عم يحمّل…',
    'stockPhotoAi.stockLabel': 'المخزون {{qty}}',
    'stockPhotoAi.generateOne': 'توليد بالذكاء الاصطناعي',
    'stockPhotoAi.empty': 'ما في صنف بدون صورة بـ {{mag}}',
    'stockPhotoAi.errorLoad': 'في مشكلة بالتحميل',
    'stockPhotoAi.errorGenerate': 'فشل التوليد',
    'stockPhotoAi.errorBatch': 'فشلت الدفعة',
    'stockPhotoAi.confirmBatch': 'نولّد لحدّ {{max}} صورة بالذكاء الاصطناعي لـ {{mag}}؟ (OpenAI · كلفة API)',
    'stockCatAudit.title': 'تدقيق فئات المخزون',
    'stockCatAudit.subtitle': 'تحليل كامل: موبايل مقابل قطعة/ملحق · مخصّص لكارلوس',
    'stockCatAudit.backToIntegrations': 'تكاملات الأدمن',
    'stockCatAudit.magasin': 'المحل',
    'stockCatAudit.allStores': 'الكل',
    'stockCatAudit.issuesOnly': 'بس الصفوف يلي فيها مشاكل',
    'stockCatAudit.runAnalysis': 'شغّل التحليل',
    'stockCatAudit.statTotal': 'الإجمالي',
    'stockCatAudit.statWithIssues': 'فيها مشاكل',
    'stockCatAudit.statFalseImei': 'IMEI غلط',
    'stockCatAudit.statNeedsImei': 'IMEI مطلوب',
    'stockCatAudit.statCategorieMismatch': 'فئة مختلفة',
    'stockCatAudit.statCategorieMissing': 'فئة فاضية',
    'stockCatAudit.statAmbiguous': 'غامض',
    'stockCatAudit.currentCategories': 'الفئات الحالية',
    'stockCatAudit.suggestedCategories': 'الفئات المقترحة',
    'stockCatAudit.searchPlaceholder': 'المرجع، التسمية، الفئة…',
    'stockCatAudit.allFilters': 'كل الفلاتر',
    'stockCatAudit.applySuggested': 'طبّق الفئة المقترحة ({{count}})',
    'stockCatAudit.colRef': 'المرجع',
    'stockCatAudit.colDesignation': 'التسمية',
    'stockCatAudit.colMag': 'المحل',
    'stockCatAudit.colCurrentCat': 'الفئة الحالية',
    'stockCatAudit.colSuggestedCat': 'الفئة المقترحة',
    'stockCatAudit.colType': 'النوع',
    'stockCatAudit.colIssues': 'المشاكل',
    'stockCatAudit.typePhone': 'موبايل',
    'stockCatAudit.typePiece': 'قطعة',
    'stockCatAudit.analyzing': 'عم يحلّل…',
    'stockCatAudit.emptyRows': 'ما في صفوف — شغّل التحليل أو وسّع الفلاتر.',
    'stockCatAudit.hint': 'مثلاً: «حامل الموبايل» صار مصنّف كملحق (بدون IMEI). أما الموبايلات الكاملة الحقيقية فبتضل لازمها IMEI وقت الجرد.',
    'stockCatAudit.errorAnalyze': 'ما ضبط التحليل',
    'stockCatAudit.errorApply': 'فشل التطبيق',
    'stockCatAudit.confirmApply': 'بدّك نطبّق الفئة المقترحة على {{count}} عنصر؟',
    'stockCatAudit.issueFalsePhoneImei': 'موبايل غلط (IMEI بالغلط)',
    'stockCatAudit.issueNeedsImei': 'موبايل — IMEI مطلوب',
    'stockCatAudit.issueCategorieMismatch': 'فئة مختلفة',
    'stockCatAudit.issueCategorieMissing': 'فئة ناقصة',
    'stockCatAudit.issueAmbiguous': 'غامض',
    'stockHist.periodToday': 'اليوم',
    'stockHist.periodYesterday': 'مبارح',
    'stockHist.periodWeek': 'هالأسبوع',
    'stockHist.periodMonth': 'هالشهر',
    'stockHist.title': 'سجل المخزون',
    'stockHist.subtitle': 'حركات المحل والمستودع',
    'stockHist.statMovements': 'الحركات',
    'stockHist.statPieces': 'قطع',
    'stockHist.locationShop': 'المحل',
    'stockHist.locationWarehouse': 'المستودع',
    'stockHist.empty': 'ما في إضافات لهالفترة',
    'stockHist.colDateTime': 'التاريخ / الوقت',
    'stockHist.colDesignation': 'الصنف',
    'stockHist.colStore': 'الفرع',
    'stockHist.colLocation': 'المكان',
    'stockHist.colQty': 'الكمية',
    'stockHist.colSalePrice': 'سعر البيع',
    'stockHist.colBy': 'بواسطة',
    'stockHist.statusNew': 'جديد',
    'stockHist.statusRestock': 'إضافة',
    'stockHist.selectedOne': 'محدد',
    'stockHist.selectedMany': 'محددين',
    'stockHist.labelOne': 'ملصق',
    'stockHist.labelMany': 'ملصقات',
    'stockHist.printCount': 'طباعة ({{count}})',
    'partsOrders.statusPending': 'قيد الانتظار',
    'partsOrders.statusPartial': 'جزئية',
    'partsOrders.statusReceived': 'مستلمة',
    'partsOrders.statusCancelled': 'ملغاة',
    'partsOrders.filterAll': 'الكل',
    'partsOrders.filterReceived': 'المستلمة',
    'partsOrders.filterCancelled': 'الملغاة',
    'partsOrders.partTypeStandard': 'قياسي',
    'partsOrders.partTypeSpare': 'قطعة غيار',
    'partsOrders.partTypeSerialized': 'مُسلسَل (الرقم التسلسلي/IMEI)',
    'partsOrders.createTitle': 'طلب مورّد جديد',
    'partsOrders.supplier': 'المورّد',
    'partsOrders.supplierPlaceholder': 'اسم المورّد',
    'partsOrders.line': 'السطر {{num}}',
    'partsOrders.designationPlaceholder': 'التسمية *',
    'partsOrders.referencePlaceholder': 'المرجع (اختياري)',
    'partsOrders.type': 'النوع',
    'partsOrders.qty': 'الكمية',
    'partsOrders.purchasePriceUnit': 'سعر الشراء للوحدة',
    'partsOrders.expectedSalePrice': 'سعر البيع المتوقع',
    'partsOrders.category': 'الفئة',
    'partsOrders.categoryPlaceholder': 'مثال: شاشة، بطارية',
    'partsOrders.location': 'المكان',
    'partsOrders.locationShop': 'المحل',
    'partsOrders.locationWarehouse': 'المستودع',
    'partsOrders.addLine': 'إضافة سطر',
    'partsOrders.notes': 'ملاحظات',
    'partsOrders.errorNeedLine': 'ضيف سطر واحد عالأقل مع تسمية.',
    'partsOrders.errorCreate': 'صار خطأ وقت الإنشاء.',
    'partsOrders.cancel': 'إلغاء',
    'partsOrders.creating': 'عم يتم الإنشاء…',
    'partsOrders.create': 'إنشاء الطلب',
    'partsOrders.receiveTitle': 'استلام — {{ref}}',
    'partsOrders.allReceived': 'كل السطور انستلمت من قبل.',
    'partsOrders.remaining': 'الباقي {{count}}',
    'partsOrders.receivedQty': 'الكمية المستلمة',
    'partsOrders.serialsLabel': 'الرقم التسلسلي / IMEI (واحد بكل سطر أو مفصولين بفواصل)',
    'partsOrders.errorNeedQty': 'حُط كمية مستلمة وحدة عالأقل.',
    'partsOrders.errorReceive': 'صار خطأ وقت الاستلام.',
    'partsOrders.close': 'إغلاق',
    'partsOrders.validating': 'عم يتم التأكيد…',
    'partsOrders.validateReceive': 'تأكيد الاستلام',
    'partsOrders.linkTitle': 'تخصيص لإصلاح',
    'partsOrders.linkDescription': 'رح تندرج القطعة «{{designation}}» بسعر الإصلاح بدون ما تتخصم من المخزون (لسا ما انستلمت).',
    'partsOrders.linkRefPlaceholder': 'مرجع الإصلاح (مثال: REP-000123)',
    'partsOrders.errorNeedRef': 'حُط مرجع الإصلاح.',
    'partsOrders.errorRepairNotFound': 'خطأ: الإصلاح مو موجود؟',
    'partsOrders.assign': 'تخصيص',
    'partsOrders.confirmCancel': 'تلغي هالطلب؟ رح ينفصلوا القطع المربوطين بالإصلاحات.',
    'partsOrders.errorCancel': 'خطأ بالإلغاء.',
    'partsOrders.errorGeneric': 'خطأ.',
    'partsOrders.supplierUnknown': 'المورّد؟',
    'partsOrders.linesCount': '{{count}} سطر',
    'partsOrders.receivedCount': '{{received}}/{{total}} مستلم',
    'partsOrders.purchaseCost': 'تكلفة الشراء',
    'partsOrders.colDesignation': 'التسمية',
    'partsOrders.colReceivedQty': 'المستلم/الكمية',
    'partsOrders.colPurchaseUnit': 'شراء للوحدة',
    'partsOrders.colSalePlanned': 'البيع المتوقع',
    'partsOrders.colRepair': 'الإصلاح',
    'partsOrders.colAction': 'إجراء',
    'partsOrders.typeSerialized': 'مُسلسَل',
    'partsOrders.typeSpareShort': 'قطعة',
    'partsOrders.typeStandardShort': 'قياسي',
    'partsOrders.detach': 'فصل',
    'partsOrders.receive': 'استلام',
    'partsOrders.pageTitle': 'طلبات القطع',
    'partsOrders.pageSubtitle': 'التوريد من المورّدين — التخصيص المسبق للإصلاح والاستلام',
    'partsOrders.filterAllStores': 'الكل',
    'partsOrders.refresh': 'تحديث',
    'partsOrders.newOrder': 'طلب جديد',
    'partsOrders.kpiOpenOrders': 'الطلبات المفتوحة',
    'partsOrders.kpiAssignedParts': 'قطع مخصصة للإصلاح',
    'partsOrders.kpiCostToReceive': 'التكلفة يلي بعدها مستلمة',
    'partsOrders.loading': 'عم يتم التحميل…',
    'partsOrders.empty': 'ما في طلبات قطع.',
    'stockForm.editTitle': 'تعديل الصنف',
    'stockForm.addTitle': 'إضافة صنف',
    'stockForm.productSheet': 'بطاقة المنتج',
    'stockForm.newStockProduct': 'منتج مخزون جديد',
    'stockForm.analyzePhoto': 'تحليل الصورة',
    'stockForm.scan': 'مسح',
    'stockForm.supplierSearch': 'بحث عن مورّد',
    'stockForm.supplierSearchPlaceholder': 'المرجع أو EAN أو اسم القطعة…',
    'stockForm.refShort': 'المرجع:',
    'stockForm.priceLabel': 'السعر:',
    'stockForm.sectionArticle': 'قسم الصنف',
    'stockForm.reference': 'المرجع',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'الباركود',
    'stockForm.category': 'الفئة',
    'stockForm.categoryPlaceholder': 'شاشات، بطاريات…',
    'stockForm.designation': 'الوصف',
    'stockForm.supplier': 'المورّد',
    'stockForm.sectionStock': 'قسم المخزون',
    'stockForm.location': 'الموقع',
    'stockForm.shop': 'المحل',
    'stockForm.depot': 'المستودع',
    'stockForm.both': 'الاثنين',
    'stockForm.qtyShop': 'كمية المحل',
    'stockForm.qtyDepot': 'كمية المستودع',
    'stockForm.alertThreshold': 'حد التنبيه',
    'stockForm.sectionPricing': 'قسم الأسعار',
    'stockForm.purchasePrice': 'سعر الشراء (بدون ضريبة)',
    'stockForm.salePrice': 'سعر البيع (€)',
    'stockForm.margin': 'الهامش',
    'stockForm.sectionShop': 'قسم المتجر',
    'stockForm.visibleOnline': 'ظاهر بالمتجر الإلكتروني',
    'stockForm.visibleOnlineHint': 'رح يقدروا الزبائن يشتروا هالصنف',
    'stockForm.cancel': 'إلغاء',
    'stockForm.saving': 'عم يحفظ…',
    'stockForm.edit': 'تعديل',
    'stockForm.addToStock': 'إضافة عالمخزون',
    'stockForm.save': 'حفظ',
    'stockForm.reviewTitle': 'التحقق من الصنف',
    'stockForm.newArticle': 'صنف جديد',
    'stockForm.existingBanner': 'موجود — {{designation}} (محل:{{qb}} مستودع:{{qd}}). تمّت إضافة الكمية عالمخزون.',
    'stockForm.imeiRequired': 'رقم IMEI إلزامي لتسجيل موبايل بالمخزون.',
    'stockForm.imeiInvalid': 'رقم IMEI غير صالح (من 14 لـ 20 رقم).',
    'stockForm.articleNotFound': 'الصنف غير موجود',
    'stockForm.imeiNotRegistered': 'ما انسجّل رقم IMEI — تأكد من الرقم أو المخزون المتقدم > IMEI.',
    'stockForm.imeiFirstRegistered': 'انسجّل أول رقم IMEI. باقي {{count}} جهاز — كمّل أرقام IMEI بالمخزون المتقدم > تبويب IMEI (المرجع {{ref}}).',
    'stockForm.saveError': 'صار خطأ وقت الحفظ',
    'clientChat.typeBoutiqueOrder': 'طلب من المحل',
    'clientChat.typeRepair': 'تصليح',
    'clientChat.typeClient': 'محادثة الزبون',
    'clientChat.title': 'محادثة الزبائن',
    'clientChat.convCount': '{{count}} محادثة',
    'clientChat.convCountPlural': '{{count}} محادثات',
    'clientChat.searchPlaceholder': 'دوّر على زبون...',
    'clientChat.noConversations': 'ما في محادثات مع الزبائن',
    'clientChat.clientFallback': 'الزبون',
    'clientChat.startConversation': 'ابدأ المحادثة',
    'clientChat.writePlaceholder': 'اكتب للزبون...',
    'clientChat.selectConversation': 'اختار محادثة',
    'stockInvImport.errorAiAnalysis': 'خطأ بتحليل الذكاء الاصطناعي — تأكّد من Admin > تكاملات API ‏(OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} سطر هواتف بدون رقم IMEI كامل.\n\nبدّك تكمّل الاستيراد؟ فيك تكمّلو بالمخزون المتقدّم > IMEI.',
    'stockInvImport.errorImport': 'خطأ بالاستيراد',
    'stockInvImport.locationDepot': 'المستودع',
    'stockInvImport.locationBoutique': 'المحل',
    'stockInvImport.pageTitle': 'استيراد الفاتورة بالذكاء الاصطناعي',
    'stockInvImport.pageSubtitle': 'تحليل PDF · حسابات متوافقة مع /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · تقريب الأسعار متل وحدة حساب الهامش',
    'stockInvImport.invoiceLabel': 'الفاتورة (PDF أو صورة)',
    'stockInvImport.fileSize': '{{size}} كيلوبايت',
    'stockInvImport.clickToChoose': 'اضغط لتختار ملف',
    'stockInvImport.shippingTotalLabel': 'إجمالي كلفة الشحن (EUR)',
    'stockInvImport.autoIfEmpty': '— تلقائي إذا كان فاضي',
    'stockInvImport.shippingPlaceholder': 'مثلاً: 29.90',
    'stockInvImport.customsPct': 'الجمارك %',
    'stockInvImport.marginPct': 'الهامش %',
    'stockInvImport.analyzing': 'عم يتحلّل… (15–30 ثانية)',
    'stockInvImport.analyzeInvoice': 'حلّل الفاتورة',
    'stockInvImport.kpiProducts': 'المنتجات',
    'stockInvImport.kpiSupplier': 'المورّد',
    'stockInvImport.kpiShippingTotal': 'إجمالي الشحن',
    'stockInvImport.kpiShippingPerUnit': 'الشحن / وحدة',
    'stockInvImport.recalc': 'عم يعيد الحساب…',
    'stockInvImport.phonesCompleteImei': '{{count}} هاتف — كمّل رقم IMEI تحت (بينستخرج تلقائياً من الفاتورة إذا موجود).',
    'stockInvImport.colRef': 'المرجع',
    'stockInvImport.colDesignation': 'الوصف',
    'stockInvImport.colQty': 'الكمية',
    'stockInvImport.colPurchase': 'الشراء',
    'stockInvImport.colPlusShipping': '+الشحن',
    'stockInvImport.colPlusCustoms': '+{{pct}}% جمارك',
    'stockInvImport.colPlusMargin': '+{{pct}}% هامش',
    'stockInvImport.colLabor': 'أجور',
    'stockInvImport.colFinalPrice': 'السعر النهائي',
    'stockInvImport.remove': 'شيل',
    'stockInvImport.generateEan': 'توليد EAN',
    'stockInvImport.imeiDevicePlaceholder': 'IMEI الجهاز {{n}}',
    'stockInvImport.back': 'رجوع',
    'stockInvImport.importing': 'عم يستورد…',
    'stockInvImport.confirm': 'تأكيد',
    'stockInvImport.importDone': 'خلص الاستيراد',
    'stockInvImport.created': 'تم إنشاؤها',
    'stockInvImport.updated': 'تم تحديثها',
    'stockInvImport.imeiRegistered': 'أرقام IMEI المسجّلة',
    'stockInvImport.errors': 'الأخطاء',
    'stockInvImport.imeiMissingTitle': 'أرقام IMEI ناقصة — كمّلها بالمخزون المتقدّم',
    'stockInvImport.missingOfTotal': '{{missing}} ناقص / {{total}}',
    'stockInvImport.newImport': 'استيراد جديد',
    'stockInvImport.backToStock': 'رجوع للمخزون',
    'clientPwd.pinGenerated': 'انعمل رمز PIN لـ {{nom}}: {{pin}}',
    'clientPwd.error': 'خطأ',
    'clientPwd.errorSendEmail': 'خطأ بإرسال الإيميل',
    'clientPwd.errorSendBulk': 'خطأ بالإرسال الجماعي',
    'clientPwd.bulkResult': 'انبعت {{sent}} إيميل، {{errors}} أخطاء',
    'clientPwd.totalClients': '{{total}} زبون بالمجموع',
    'clientPwd.sending': 'عم يُبعت...',
    'clientPwd.sendToClients': 'إرسال لـ {{count}} زبون',
    'clientPwd.searchPlaceholder': 'دوّر بالاسم أو الهاتف أو الإيميل...',
    'clientPwd.filterAll': 'الكل',
    'clientPwd.filterSent': 'كلمة السر مبعوتة',
    'clientPwd.filterNotSent': 'كلمة السر ما انبعتت',
    'clientPwd.colName': 'الاسم',
    'clientPwd.colPhone': 'الهاتف',
    'clientPwd.colEmail': 'الإيميل',
    'clientPwd.colPin': 'رمز PIN',
    'clientPwd.colStatus': 'الحالة',
    'clientPwd.colActions': 'إجراءات',
    'clientPwd.loading': 'عم يحمّل...',
    'clientPwd.noEmail': 'ما في إيميل',
    'clientPwd.statusSent': 'مبعوت',
    'clientPwd.statusPending': 'قيد الانتظار',
    'clientPwd.statusNotGenerated': 'ما انعمل',
    'clientPwd.genPinTitle': 'إنشاء رمز PIN',
    'clientPwd.resend': 'إعادة الإرسال',
    'clientPwd.pageOf': 'صفحة {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'اختار أول شي متجر لهالجرد.',
    'stockInv.error.analyzeFailed': 'ما قدرنا نحلّل — تأكّد من مفتاح OpenAI أو جرّب مرة تانية.',
    'stockInv.error.server': 'خطأ بالخادم',
    'stockInv.dropdown.refLabel': 'المرجع:',
    'stockInv.short.boutique': 'م',
    'stockInv.short.depot': 'خ',
    'stockInv.summary.title': 'ملخّص الجرد',
    'stockInv.summary.subtitle': '{{count}} عنصر متحفّظ',
    'stockInv.summary.statusNew': 'جديد',
    'stockInv.summary.statusUpdated': 'مُحدّث',
    'stockInv.summary.errorsTitle': 'أخطاء',
    'stockInv.summary.created': '{{count}} تعمل',
    'stockInv.summary.updated': '{{count}} تحدّث',
    'stockInv.summary.pieces': '{{count}} قطعة',
    'stockInv.btn.printLabels': 'طباعة الملصقات',
    'stockInv.btn.newInventory': 'جرد جديد',
    'stockInv.btn.printCount': 'طباعة ({{count}})',
    'stockInv.btn.addRow': 'سطر',
    'stockInv.btn.scan': 'مسح',
    'stockInv.btn.csvImport': 'استيراد CSV',
    'stockInv.btn.csvExport': 'تصدير',
    'stockInv.btn.saving': 'عم يتحفّظ…',
    'stockInv.btn.saveAll': 'حفظ الكل ({{count}})',
    'stockInv.col.status': 'الحالة',
    'stockInv.col.reference': 'المرجع',
    'stockInv.col.designation': 'الوصف',
    'stockInv.col.pAchat': 'سعر الشرا',
    'stockInv.col.pVente': 'سعر البيع',
    'stockInv.col.lieu': 'المكان',
    'stockInv.col.qteAjoutee': 'الكمية المضافة',
    'stockInv.col.stockTotal': 'إجمالي المخزون',
    'stockInv.col.magasin': 'المتجر',
    'stockInv.col.prixAchat': 'سعر الشرا (€)',
    'stockInv.col.prixVente': 'سعر البيع (€)',
    'stockInv.col.emplacement': 'الموقع',
    'stockInv.col.qte': 'الكمية',
    'stockInv.col.fournisseur': 'المورّد',
    'stockInv.location.boutique': 'المحل',
    'stockInv.location.depot': 'المستودع',
    'stockInv.header.title': 'جرد المخزون',
    'stockInv.header.subtitleMagasin': 'إدخال سريع · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'إدخال سريع · اختار متجر',
    'stockInv.warn.pickMagasin': 'اختار متجر قبل ما تحفظ الجرد.',
    'stockInv.cross.title': '{{count}} مرجع موجود من قبل بمتجر تاني',
    'stockInv.cross.explain': 'إنت عملت سطر جديد بمتجرك الهدف. إذا كان مقصود (مخزون مخصّص لكل متجر)، تجاهل هالرسالة. إذا بدّك تحوّل، روح على',
    'stockInv.cross.explainTransfer': '→ تحويل.',
    'stockInv.cross.createdIn': 'انعمل بـ {{magasin}}',
    'stockInv.cross.existedIn': 'كان موجود بـ',
    'stockInv.cross.noMagasin': '— بدون متجر —',
    'stockInv.cross.qty': 'الكمية',
    'stockInv.badge.existing': 'موجود',
    'stockInv.badge.new': 'جديد',
    'stockInv.placeholder.refEan': 'المرجع / EAN',
    'stockInv.placeholder.ean13': 'رمز EAN13',
    'stockInv.placeholder.productName': 'اسم المنتج',
    'stockInv.placeholder.fournisseur': 'المورّد',
    'stockInv.footer.rows': 'سطر',
    'stockInv.footer.toSave': 'للحفظ',
    'stockInv.footer.existingCount': '({{count}} موجود)',
    'stockInv.footer.newCount': '({{count}} جديد)',
    'stockInv.footer.piecesAndValue': '{{count}} قطعة · {{value}} شرا',
    'stockInv.hint.enterBefore': 'اضغط',
    'stockInv.hint.enterKey': 'Enter',
    'stockInv.hint.enterAfter': 'لتنتقل للسطر اللي بعده',
    'stockInv.review.title': 'تحليل أولي للجرد',
    'stockInv.review.subtitle': '{{count}} سطر · متجر {{magasin}}',
    'staffChat.statusOnline': 'أونلاين',
    'staffChat.statusBusy': 'مشغول',
    'staffChat.statusAway': 'غايب',
    'staffChat.statusOffline': 'أوفلاين',
    'staffChat.colorYellow': 'أصفر',
    'staffChat.colorBlue': 'أزرق',
    'staffChat.colorGreen': 'أخضر',
    'staffChat.colorOrange': 'برتقالي',
    'staffChat.colorPurple': 'بنفسجي',
    'staffChat.colorCyan': 'سماوي',
    'staffChat.colorRed': 'أحمر',
    'staffChat.quickRepliesTitle': 'ردود سريعة',
    'staffChat.quickRepliesSubtitle': 'عدّل ردود الشات',
    'staffChat.qrLabelPlaceholder': 'التسمية (مثال: جاهز!)',
    'staffChat.qrTextPlaceholder': 'نص الرسالة...',
    'staffChat.qrSaveEdit': 'حفظ',
    'staffChat.cancel': 'إلغاء',
    'staffChat.add': 'إضافة',
    'staffChat.filterAll': 'الكل',
    'staffChat.filterTeam': 'الفريق',
    'staffChat.filterClients': 'الزباين',
    'staffChat.filterTickets': 'التذاكر',
    'staffChat.filterQuick': 'سريعة',
    'staffChat.messaging': 'المراسلة',
    'staffChat.newConversation': 'محادثة جديدة',
    'staffChat.searchPlaceholder': 'دوّر على محادثة...',
    'staffChat.noStaffAvailable': 'ما في عضو متاح',
    'staffChat.labelTeam': 'الفريق',
    'staffChat.labelOrder': 'طلب',
    'staffChat.labelRepair': 'تصليح',
    'staffChat.labelClient': 'زبون',
    'staffChat.priorityUrgent': 'عاجل',
    'staffChat.priorityMedium': 'متوسط',
    'staffChat.priorityNormal': 'عادي',
    'staffChat.ticketsNone': 'ما في تذكرة منتظرة',
    'staffChat.ticketsAllHandled': 'انعالجت كل الرسائل',
    'staffChat.timeAgoLessThanHour': 'من أقل من ساعة',
    'staffChat.timeAgoHours': 'من {{h}} ساعة',
    'staffChat.viewConversation': 'شوف المحادثة',
    'staffChat.close': 'إغلاق',
    'staffChat.recentlyClosed': 'مسكّرة مؤخرًا',
    'staffChat.closedBy': 'من {{name}}',
    'staffChat.noConversations': 'ما في محادثة',
    'staffChat.conversation': 'محادثة',
    'staffChat.startConversation': 'ابدأ المحادثة',
    'staffChat.endToEndEncrypted': 'الرسائل مشفّرة من طرف لطرف',
    'staffChat.aiAssistant': 'المساعد الذكي',
    'staffChat.autoBadge': 'تلقائي',
    'staffChat.nudgeTitle': 'ابعت تنبيه!',
    'staffChat.sending': 'عم يبعت...',
    'staffChat.messagePlaceholder': 'اكتب رسالة...',
    'staffChat.selectConversation': 'اختر محادثة',
    'staffChat.chooseFromList': 'اختر من اللستة على اليمين',
    'warnDuplicateReference': 'موجود بالمخزون — +1 عند الحفظ',
    'warnDuplicateEan': 'رمز EAN موجود بالمخزون — +1 عند الحفظ',
    'warnCrossMagasin': 'المرجع موجود بمحل تاني',
    'warnLowVision': 'قراءة الصورة مو أكيدة',
    'warnPrixAchatManual': 'سعر الشرا لازم تدخلو يدوي',
    'warnLlmUnavailable': 'رؤية الذكاء الاصطناعي مو متاحة (مفاتيح API)',
    'alertAddPhotoOrText': 'ضيف صورة أو الصق نص الملصق.',
    'errAnalyzePhoto': 'خطأ بتحليل الصورة',
    'alertEnterPrixAchat': 'دخّل سعر الشرا لنعيد حساب سعر البيع.',
    'errCalcPrice': 'خطأ بحساب السعر',
    'alertRefDesignationRequired': 'المرجع والتسمية لازمين.',
    'alertPrixVenteRequired': 'سعر البيع لازم.',
    'noticeAddedToList': '+{{qty}} عالقائمة: {{designation}} (المجموع +{{total}})',
    'noticeStockUpdate': 'تحديث المخزون: {{designation}} (+{{qty}})',
    'noticeAdded': 'تنضاف: {{designation}} (×{{qty}})',
    'errServer': 'خطأ بالسيرفر',
    'alertChooseMagasin': 'اختار محل.',
    'errAnalyzeImpossible': 'ما قدرنا نحلّل',
    'summaryTitle': 'العناصر المسجّلة',
    'summarySubtitle': '{{created}} منشأ · {{updated}} متحدّث · {{labels}} ملصق للطباعة',
    'printLabels': 'طباعة الملصقات ({{count}})',
    'newSession': 'جلسة جديدة',
    'colStatut': 'الحالة',
    'colReference': 'المرجع',
    'colDesignation': 'التسمية',
    'colPrixAchat': 'سعر الشرا',
    'colPrixVente': 'سعر البيع',
    'colQtyAdded': 'الكمية المضافة',
    'badgeNew': 'جديد',
    'badgeAddStock': '+مخزون',
    'pageTitle': 'تحليل منتج',
    'pageSubtitle': 'امسح كذا عنصر · دقّق كل سطر · احفظ الكل دفعة وحدة',
    'pendingList': 'قائمة الانتظار — {{count}} عنصر · {{pieces}} قطعة',
    'saveAll': 'حفظ الكل ({{count}})',
    'badgeUpdate': 'تحديث',
    'depot': 'المستودع',
    'boutique': 'المحل',
    'stockAbbrev': 'مخزون م:{{boutique}} خ:{{depot}}',
    'remove': 'شيل',
    'photoSectionTitle': 'صورة المنتج',
    'productAlt': 'المنتج',
    'photoHint': 'المعرض أو الكاميرا — العلبة أو الملصق (رمز EAN باين)',
    'gallery': 'المعرض',
    'camera': 'الكاميرا',
    'analyzing': 'عم يحلّل…',
    'analyze': 'تحليل',
    'aiVisionOption': 'رؤية الذكاء الاصطناعي إذا الملصق مو مقروء (OpenAI / Gemini)',
    'labelTextLabel': 'نص الملصق (اختياري — إذا الباركود مو مقروء)',
    'labelTextPlaceholder': 'شاشة iPhone 8 OLED\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'ابدأ التحليل لتعبئة بطاقة المخزون.',
    'analyzingHint': 'عم نقرا الملصق وندوّر عالمورّد…',
    'alreadyInStockPrefix': 'موجود بالمخزون ({{magasin}}) — الحفظ =',
    'alreadyInStockSuffix': '(المحل {{boutique}} · المستودع {{depot}})',
    'alreadyInListPrefix': 'موجود بالقائمة (×{{qty}}) — القبول =',
    'alreadyInListSuffix': 'عالقائمة',
    'currentStockBoutique': '(المخزون الحالي للمحل: {{qty}})',
    'resultTitle': 'نتيجة التحليل',
    'readConfidence': 'ثقة القراءة: {{pct}}%',
    'aiVision': 'رؤية الذكاء الاصطناعي',
    'matchLabel': 'تطابق',
    'fieldDesignation': 'التسمية *',
    'fieldReference': 'المرجع *',
    'fieldCategorie': 'الفئة',
    'fieldFournisseur': 'المورّد',
    'otherSupplierParts': 'قطع تانية من المورّد',
    'tarifsTitle': 'الأسعار',
    'fieldPrixAchat': 'سعر الشرا (€)',
    'autoSupplierCache': 'ذاكرة المورّد التلقائية',
    'fieldPrixVente': 'سعر البيع (€)',
    'recalcVente': 'إعادة حساب البيع',
    'laborLabel': 'اليد العاملة: {{amount}}',
    'detailTitle': 'تفاصيل حساب العرض التلقائي',
    'detailAchat': 'الشرا:',
    'detailPort': 'الشحن:',
    'detailDouane': 'الجمارك:',
    'detailCoutPiece': 'تكلفة القطعة:',
    'detailFinal': 'النهائي:',
    'qtyLocationTitle': 'الكمية والموقع',
    'quantite': 'الكمية',
    'quit': 'خروج',
    'acceptPlusOne': 'قبول (+1)',
    'acceptLine': 'قبول السطر',
    'acceptHelp': 'تكرار بالقائمة أو المخزون = +1 تلقائي · وبعدها «حفظ الكل» · الملصقات بالآخر.',
    'reviewTitleAccept': 'هالسطر صحيح؟',
    'reviewTitleBulk': 'التحقق قبل الحفظ',
    'reviewSubtitleAccept': 'أكّد لتضيفو عالقائمة، وبعدها امسح العنصر اللي بعدو',
    'reviewBulkSubtitle': '{{count}} عنصر للحفظ بالمخزون',
    'avoirs.title': 'الأرصدة الدائنة',
    'avoirs.subtitle': 'رصيد دائن للزبون ناتج عن إيصال أو فاتورة — بينفع يتستخدم بنقطة البيع',
    'avoirs.refresh': 'تحديث',
    'avoirs.errorLoad': 'خطأ بتحميل الأرصدة الدائنة',
    'avoirs.searchPlaceholder': 'مرجع الرصيد، الزبون، الإيصال الأصلي…',
    'avoirs.allStatuses': 'كل الحالات',
    'avoirs.empty': 'ما في ولا رصيد دائن',
    'avoirs.colRef': 'المرجع',
    'avoirs.colClient': 'الزبون',
    'avoirs.colOrigin': 'المصدر',
    'avoirs.colInitial': 'المبلغ الأولي',
    'avoirs.colSolde': 'الرصيد',
    'avoirs.colStatut': 'الحالة',
    'avoirs.colDate': 'التاريخ',
    'avoirs.createdBy': 'أنشأه',
    'avoirs.originLabel': 'المصدر:',
    'avoirs.motifLabel': 'السبب:',
    'avoirs.clientLabel': 'الزبون:',
    'avoirs.printTicket': 'طباعة إيصال الرصيد',
    'avoirs.downloadPdf': 'تنزيل PDF',
    'avoirs.historyTitle': 'سجل الحركات',
    'avoirs.cancelRemaining': 'إلغاء الرصيد المتبقي',
    'avoirs.confirmCancel': 'بدك تلغي الرصيد المتبقي لـ {{ref}}؟',
    'avoirs.close': 'إغلاق',
    'avoirs.statutDisponible': 'متاح',
    'avoirs.statutPartiel': 'مستخدم جزئيًا',
    'avoirs.statutUtilise': 'مستخدم',
    'avoirs.statutAnnule': 'ملغي',
    'stockMov.tab.dashboard': 'لوحة التحكم',
    'stockMov.tab.movements': 'الحركات',
    'stockMov.tab.imei': 'IMEI / الأرقام التسلسلية',
    'stockMov.tab.inventory': 'الجرد',
    'stockMov.header.title': 'المخزون المتقدم',
    'stockMov.header.subtitle': 'الحركات · IMEI · جلسات الجرد · لوحة التحكم',
    'stockMov.cancel': 'إلغاء',
    'stockMov.save': 'حفظ',
    'stockMov.saving': 'عم يحفظ...',
    'stockMov.loadError': 'خطأ بالتحميل',
    'stockMov.error': 'خطأ: {{detail}}',
    'stockMov.loading': 'عم يحمّل…',
    'stockMov.pageOf': 'صفحة {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'إجمالي الأصناف',
    'stockMov.kpi.qteBoutique': 'كمية المحل',
    'stockMov.kpi.qteDepot': 'كمية المستودع',
    'stockMov.kpi.ruptures': 'النفاد',
    'stockMov.kpi.imeiEnStock': 'IMEI بالمخزون',
    'stockMov.boutique': 'المحل',
    'stockMov.depot': 'المستودع',
    'stockMov.total': 'الإجمالي',
    'stockMov.valeurAchat': 'قيمة الشراء',
    'stockMov.valeurVente': 'قيمة البيع',
    'stockMov.marge': 'الهامش',
    'stockMov.margeTotale': 'إجمالي الهامش',
    'stockMov.stocksNegatifs': 'المخزون السالب ({{count}})',
    'stockMov.aucunStockNegatif': 'ما في مخزون سالب',
    'stockMov.articlesSousSeuil': 'أصناف تحت الحد ({{count}})',
    'stockMov.tousAuDessusSeuil': 'كل الأصناف فوق حد التنبيه تبعها',
    'stockMov.filter.all': 'الكل',
    'stockMov.filter.entrees': 'الإدخالات',
    'stockMov.filter.sorties': 'الإخراجات',
    'stockMov.magasinLabel': 'المحل:',
    'stockMov.nouveauMouvement': 'حركة جديدة',
    'stockMov.col.date': 'التاريخ',
    'stockMov.col.type': 'النوع',
    'stockMov.col.motif': 'السبب',
    'stockMov.col.article': 'الصنف',
    'stockMov.col.magasin': 'المحل',
    'stockMov.col.qte': 'الكمية',
    'stockMov.col.stockAvant': 'المخزون قبل',
    'stockMov.col.stockApres': 'المخزون بعد',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'بواسطة',
    'stockMov.aucunMouvement': 'ما في حركات مسجّلة',
    'stockMov.type.transfert': 'نقل',
    'stockMov.type.entree': 'إدخال',
    'stockMov.type.sortie': 'إخراج',
    'stockMov.modalNewMovement': 'حركة مخزون جديدة',
    'stockMov.field.motif': 'السبب',
    'stockMov.field.article': 'الصنف',
    'stockMov.searchArticlePlaceholder': 'دوّر على صنف...',
    'stockMov.refStock': '({{ref}}) المخزون: {{qty}}',
    'stockMov.refShort': 'المرجع: {{ref}}',
    'stockMov.field.quantite': 'الكمية',
    'stockMov.field.prixUnitaire': 'سعر الوحدة',
    'stockMov.field.imeiOptional': 'IMEI / الرقم التسلسلي (اختياري)',
    'stockMov.imeiPlaceholder': 'مثال: 353012345678901',
    'stockMov.field.noteOptional': 'ملاحظة (اختياري)',
    'stockMov.commentPlaceholder': 'تعليق...',
    'stockMov.imeiRefRequired': 'الرقم IMEI والمرجع مطلوبين',
    'stockMov.refQtyRequired': 'المرجع والكمية مطلوبين',
    'stockMov.registreTitle': 'سجل IMEI — تتبّع الهواتف',
    'stockMov.registreDesc': 'لازم يكون لكل جهاز بالمخزون رقم IMEI فريد. بيخليك تتبّع السجل (الشراء، البيع عبر نقطة البيع، التصليح).',
    'stockMov.nouveauTelephone': 'تلفون جديد',
    'stockMov.searchImeiPlaceholder': 'دوّر على IMEI أو صنف...',
    'stockMov.tousLesStatuts': 'كل الحالات',
    'stockMov.enregistrerImei': 'تسجيل IMEI',
    'stockMov.col.imeiSerie': 'IMEI / الرقم التسلسلي',
    'stockMov.col.refDot': 'المرجع',
    'stockMov.col.magShort': 'المحل',
    'stockMov.col.etat': 'الحالة',
    'stockMov.col.statut': 'الوضع',
    'stockMov.col.origine': 'المصدر',
    'stockMov.aucunImei': 'ما في IMEI — ضيف تلفون عالمخزون وبعدين سجّل رقمه هون.',
    'stockMov.historique': 'السجل',
    'stockMov.historiqueImei': 'السجل · {{imei}}',
    'stockMov.byUser': 'بواسطة {{user}}',
    'stockMov.aucunMouvementImei': 'ما في حركات مرتبطة بهالـ IMEI.',
    'stockMov.modalRegisterImei': 'تسجيل رقم IMEI / رقم تسلسلي',
    'stockMov.field.articleStockRef': 'صنف المخزون (المرجع)',
    'stockMov.searchPlaceholder': 'دوّر...',
    'stockMov.field.etat': 'الحالة',
    'stockMov.field.origine': 'المصدر',
    'stockMov.origine.achat': 'شراء',
    'stockMov.origine.reprise_client': 'استبدال من الزبون',
    'stockMov.origine.transfert': 'نقل',
    'stockMov.etat.neuf': 'جديد',
    'stockMov.etat.occasion': 'مستعمل',
    'stockMov.etat.reconditionne': 'مُجدَّد',
    'stockMov.etat.hs': 'خربان',
    'stockMov.statut.en_stock': 'بالمخزون',
    'stockMov.statut.vendu': 'مْباع',
    'stockMov.statut.reserve': 'محجوز',
    'stockMov.statut.en_reparation': 'عم يتصلّح',
    'stockMov.motif.achat_fournisseur': 'شراء من المورّد',
    'stockMov.motif.retour_client': 'إرجاع من الزبون',
    'stockMov.motif.correction_inventaire': 'تصحيح الجرد',
    'stockMov.motif.transfert_entrant': 'نقل وارد',
    'stockMov.motif.reception_commande': 'استلام طلب',
    'stockMov.motif.reintegration_reparation': 'إعادة إدخال بعد التصليح',
    'stockMov.motif.vente_pos': 'بيع عبر نقطة البيع',
    'stockMov.motif.consommation_reparation': 'استهلاك بالتصليح',
    'stockMov.motif.perte_casse': 'فقدان / كسر',
    'stockMov.motif.retour_fournisseur': 'إرجاع للمورّد',
    'stockMov.motif.transfert_sortant': 'نقل صادر',
    'stockMov.motif.ajustement_inventaire': 'تسوية الجرد',
    'stockMov.sessionsInventaire': 'جلسات الجرد',
    'stockMov.nouvelInventaire': 'جرد جديد',
    'stockMov.aucuneSession': 'ما في جلسات جرد',
    'stockMov.parUser': 'بواسطة {{user}}',
    'stockMov.articlesEcarts': '{{articles}} صنف، {{ecarts}} فرق',
    'stockMov.status.enCours': 'قيد التنفيذ',
    'stockMov.status.valide': 'مُعتمَد',
    'stockMov.retourSessions': 'رجوع للجلسات',
    'stockMov.statutColon': 'الحالة:',
    'stockMov.validePar': 'اعتمده {{user}}',
    'stockMov.validerSansCorrection': 'اعتماد بدون تصحيح',
    'stockMov.validerCorriger': 'اعتماد + تصحيح المخزون',
    'stockMov.comptagePhysique': 'الجرد الفعلي',
    'stockMov.searchArticleShort': 'دوّر على صنف...',
    'stockMov.inv.bdShort': 'محل:{{b}} مستودع:{{d}}',
    'stockMov.stockSelectionne': 'المخزون المحدد:',
    'stockMov.dotBoutique': '· المحل {{q}}',
    'stockMov.dotDepot': '· المستودع {{q}}',
    'stockMov.qteComptee': 'الكمية المعدودة',
    'stockMov.col.stockTheorique': 'المخزون النظري',
    'stockMov.col.comptagePhysique': 'الجرد الفعلي',
    'stockMov.col.ecart': 'الفرق',
    'stockMov.col.comptePar': 'عدّه',
    'stockMov.aucunArticleCompte': 'ما انعدّ ولا صنف. ابدأ العدّ لفوق.',
    'stockMov.modalNewSession': 'جلسة جرد جديدة',
    'stockMov.field.titreOptional': 'العنوان (اختياري)',
    'stockMov.titrePlaceholder': 'مثال: الجرد الشهري آذار 2026',
    'stockMov.creating': 'عم يُنشأ...',
    'stockMov.creer': 'إنشاء',
    'stockMov.confirmValidateApply': 'اعتماد وتطبيق تصحيحات المخزون؟',
    'stockMov.confirmValidateNoApply': 'اعتماد بدون تطبيق التصحيحات؟',
    'stockMov.sessionValidee': 'تم اعتماد الجلسة!',
    'stockMov.countSaved': 'انحفظ العدّ: المخزون النظري {{theorique}}، الفعلي {{physique}}، الفرق {{ecart}}',
    'stock.err.templateDownload': 'صار خطأ وقت تنزيل القالب',
    'stock.err.missingId': 'خطأ: معرّف المادة ناقص',
    'stock.deleteSuccess': 'انحذفت المادة بنجاح',
    'stock.err.delete': 'صار خطأ وقت الحذف',
    'stock.confirmDeleteMany': 'تنحذف {{count}} مادة؟',
    'stock.err.update': 'صار خطأ وقت التحديث',
    'stock.err.transfer': 'خطأ بالنقل',
    'stock.err.bulkTransfer': 'خطأ بالنقل الجماعي',
    'stock.depotOnlyM1': 'المستودع متوفّر هلّق بس على M1.',
    'stock.sameSourceDest': 'المصدر والوجهة نفس الشي.',
    'stock.noLineToTransfer': 'ما في ولا سطر للنقل (كميات صفر أو المتجر المصدر = الوجهة).',
    'stock.confirmBulkPublish': 'تنعرض {{count}} مادة للبيع أونلاين؟',
    'stock.confirmBulkUnpublish': 'تنشال {{count}} مادة من البيع أونلاين؟',
    'stock.confirmPublishOne': 'تنعرض «{{name}}» للبيع أونلاين؟',
    'stock.confirmUnpublishOne': 'تنشال «{{name}}» من البيع أونلاين؟',
    'stock.importDone': 'خلص الاستيراد',
    'stock.importCreated': 'تنعملوا',
    'stock.importUpdated': 'تحدّثوا',
    'stock.importSkipped': 'تتخطّوا',
    'stock.importErrors': 'أخطاء',
    'stock.importRetryHint': 'في {{count}} مادة موجودة من قبل — عيد التشغيل بوضع «تحديث».',
    'stock.importRetryBtn': 'عيد التشغيل بالتحديث',
    'stock.importViewErrors': 'شوف الأخطاء ({{count}})',
    'stock.transferTitle': 'نقل المخزون',
    'stock.boutique': 'المحل',
    'stock.depot': 'المستودع',
    'stock.sourceStore': 'المتجر المصدر',
    'stock.sourceLocation': 'الموقع المصدر',
    'stock.destStore': 'المتجر الوجهة',
    'stock.destLocation': 'الموقع الوجهة',
    'stock.quantity': 'الكمية',
    'stock.availableAtSource': 'المتوفّر بالمصدر: {{count}}',
    'stock.cancel': 'إلغاء',
    'stock.transferring': 'عم ينقل…',
    'stock.transfer': 'نقل',
    'stock.bulkTransferTitle': 'تغيير متجر {{count}} مادة',
    'stock.location': 'الموقع',
    'stock.bulkTransferR1Note': 'النقل بيتبع القاعدة R1: المستند المصدر بيضلّ كميته 0 إذا تفرّغ، وبينعمل مستند جديد بالمتجر الوجهة.',
    'stock.colArticle': 'المادة',
    'stock.colCurrentStore': 'المتجر الحالي',
    'stock.colStock': 'المخزون',
    'stock.colQtyToTransfer': 'الكمية يلّي بدنا ننقلها',
    'stock.runTransfer': 'ابدأ النقل',
    'stock.resultSucceeded': 'ناجحة',
    'stock.resultFailed': 'فاشلة',
    'stock.resultUnitsTransferred': 'وحدات منقولة',
    'stock.failuresLabel': 'الإخفاقات:',
    'stock.done': 'خلص',
    'stock.storeN': 'المتجر {{n}}',
    'stock.tab.view': 'عرض',
    'stock.tab.inventory': 'الجرد',
    'stock.tab.analyze': 'تحليل المنتج',
    'stock.tab.history': 'السجل',
    'stock.tab.supplierOrders': 'تموين المورّد',
    'stock.tab.invoiceImport': 'استيراد الفاتورة بالذكاء الاصطناعي',
    'stock.tab.labels': 'الملصقات',
    'stock.tab.advanced': 'المخزون المتقدّم',
    'stock.tab.reconciliation': 'التسوية',
    'stock.tab.config': 'الإعدادات',
    'posV2.remisePlafonneeMsg': 'الخصم محدود بنسبة {{pct}}٪. إذا أكتر من هيك، لازم موافقة الإدارة.',
    'posV2.venteNonEnregRemiseRamenee': 'البيع ما انسجّل — الخصم رجع للحد الأقصى؛ دقّق بالإجمالي وبعدين حصّل مرة تانية.',
    'posV2.remiseRameneeVerif': 'الخصم رجع للحد الأقصى — دقّق بالإجمالي وبعدين حصّل.',
    'posV2.catalogUnavailable': 'الكتالوج مش متاح',
    'posV2.paymentRefusedTpe': 'الدفع انرفض أو انلغى على جهاز الدفع — جرّب مرة تانية.',
    'posV2.caisseClosedOpenFirst': 'الصندوق {{mag}} مسكّر — افتحه قبل ما تحصّل',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} سطر',
    'posV2.sumupTerminalNotConnected': 'جهاز SumUp مش متصل',
    'posV2.sumupSaleNotSaved': '{{msg}}. البيع ما انسجّل (المخزون ما تغيّر). تأكّد إنو جهاز الدفع شغّال ومتصل.',
    'posV2.cartEmpty': 'السلة فاضية',
    'posV2.lookupValidAvoir': 'دوّر على إشعار دائن صالح قبل ما تحصّل',
    'posV2.printError': 'خطأ بالطباعة',
    'posV2.caisseClosedBanner': 'الصندوق {{mag}} مسكّر.',
    'posV2.open': 'افتح',
    'posV2.oneEncaissementMultiStock': 'تحصيل واحد {{mag}} · مخزون من كذا متجر',
    'posV2.catalog': 'الكتالوج',
    'posV2.ficheButtonHint': 'زر البطاقة → معرض الصور',
    'posV2.all': 'الكل',
    'posV2.stockMag': 'مخزون {{mag}}',
    'posV2.catalogPlaceholder': 'الكتالوج…',
    'posV2.go': 'بحث',
    'posV2.catalogMeta': '{{total}} مرجع · {{scope}} · ص.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'دخّل مرجع إشعار دائن أو اسم زبون',
    'posV2.avoirNotFound': 'الإشعار الدائن مش موجود',
    'posV2.productSheet': 'بطاقة المنتج',
    'posV2.productSheetSub': 'معرض · مخزون · ضيف عالسلة',
    'posV2.ticketCenter': 'مركز الإيصالات',
    'posV2.ticketCenterSub': 'إيصالات حديثة · إعادة طباعة',
    'posV2.savStation': 'مركز خدمة ما بعد البيع والتصليح',
    'posV2.savStationSub': 'دوّر على ملف · حصّل الباقي · دفعة مقدمة · السلة',
    'posV2.horsStock': 'خارج المخزون',
    'posV2.horsStockSub': 'بيع غرض عَرَضي · شارة خارج المخزون · تحصيل مباشر',
    'posV2.clientCenter': 'مركز الزبائن',
    'posV2.clientCenterSub': 'السجل · الولاء · اربطه بعملية التحصيل',
    'posV2.orders': 'الطلبات',
    'posV2.ordersSub': 'طلب الزبون · طلبية · دفعة مقدمة · السلة',
    'openCaisse.denomBill': 'ورقة نقدية',
    'openCaisse.denomCoin': 'قطعة معدنية',
    'openCaisse.cardTotal': 'المجموع',
    'openCaisse.successOpen': 'تم فتح الصندوق {{magasin}} بنجاح.',
    'openCaisse.errorOpen': 'صار خطأ وقت فتح الصندوق',
    'openCaisse.backToDashboard': 'رجوع إلى لوحة التحكم',
    'openCaisse.title': 'فتح الصندوق {{magasin}}',
    'openCaisse.titleForce': 'فتح قسري للصندوق {{magasin}}',
    'openCaisse.openingFund': 'رصيد الافتتاح',
    'openCaisse.openingFundHint': 'دخّل الأوراق النقدية والقطع المعدنية لصندوق {{magasin}}.',
    'openCaisse.totalOpening': 'إجمالي الافتتاح',
    'openCaisse.forceWarning': 'هالإجراء رح يسكّر الصندوق المفتوح تبع المتجر المستهدف وبعدين ينشئ صندوق جديد بهالمبلغ.',
    'openCaisse.cancel': 'إلغاء',
    'openCaisse.opening': 'عم يفتح...',
    'openCaisse.validateOpening': 'تأكيد الفتح',
    'calcul.title': 'أداة حساب السعر / عرض السعر',
    'calcul.subtitle': 'واجهة متل حاسبة PHP + إنشاء ملفات PDF قياس 80مم وA4.',
    'calcul.clientSection': 'معلومات الزبون',
    'calcul.clientName': 'اسم الزبون',
    'calcul.phone': 'التلفون',
    'calcul.email': 'الإيميل',
    'calcul.saveClient': 'حفظ الزبون',
    'calcul.deviceSection': 'اختيار الجهاز',
    'calcul.brand': 'الماركة',
    'calcul.model': 'الموديل',
    'calcul.itemsSection': 'العناصر',
    'calcul.itemDescription': 'القطعة / الوصف',
    'calcul.itemReference': 'مرجع القطعة',
    'calcul.itemPurchasePrice': 'سعر الشرا',
    'calcul.addLine': 'إضافة سطر',
    'calcul.paramsSection': 'الإعدادات',
    'calcul.quantity': 'الكمية',
    'calcul.labor': 'أجرة الشغل (€)',
    'calcul.partReference': 'مرجع القطعة',
    'calcul.supplier': 'المورّد',
    'calcul.docType': 'نوع المستند',
    'calcul.docTypeDevis': 'عرض سعر',
    'calcul.docTypeFacture': 'فاتورة',
    'calcul.docTypeProforma': 'فاتورة مبدئية',
    'calcul.acceptOnlinePayment': 'قبول الدفع أونلاين (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'رح يقدر الزبون يطلب رابط دفع SumUp',
    'calcul.saveTicket': '✅ حفظ الإيصال',
    'calcul.saving': 'عم يتحفظ...',
    'calcul.preview': '👁️ معاينة',
    'calcul.previewSection': 'المعاينة',
    'calcul.previewIframeTitle': 'معاينة الإيصال',
    'calcul.previewEmpty': 'شغّل عملية حساب لتطلّع الإيصال.',
    'calcul.printTicket': 'طباعة الإيصال',
    'calcul.transformA4': 'التحويل إلى عرض سعر A4',
    'calcul.totalArticles': 'إجمالي العناصر',
    'calcul.totalPurchase': 'إجمالي الشرا',
    'calcul.shippingFees': 'رسوم الشحن',
    'calcul.customsFees': 'الرسوم الجمركية',
    'calcul.costPerPiece': 'التكلفة للقطعة',
    'calcul.finalPrice': 'السعر النهائي',
    'calcul.alertAllowPopups': 'لو سمحت اسمح بالنوافذ المنبثقة حتى تطبع.',
    'calcul.alertAddItem': 'ضيف عالأقل عنصر واحد مع سعر شرا.',
    'calcul.ticketSaved': '✅ تم حفظ الإيصال.',
    'calcul.errorGenerateTicket': 'صار خطأ وقت إنشاء الإيصال',
    'calcul.errorPrintTicket': 'خطأ بطباعة الإيصال',
    'calcul.errorGenerateA4': 'صار خطأ وقت إنشاء عرض السعر A4',
    'caisseHist.errPrint': 'خطأ بطباعة الصندوق',
    'caisseHist.errPrintGeneric': 'خطأ بالطباعة',
    'caisseHist.errLoadMonthly': 'خطأ بتحميل السجل الشهري',
    'caisseHist.errExport': 'خطأ بتصدير المحاسبة',
    'caisseHist.confirmForceClose': 'بدّك تعمل إغلاق إجباري لصندوق يوم {{date}}؟ هالإجراء ما في رجعة عنه.',
    'caisseHist.errForceClose': 'صار خطأ وقت الإغلاق الإجباري',
    'caisseHist.title': 'سجل فتح / إغلاق الصندوق',
    'caisseHist.month': 'الشهر',
    'caisseHist.store': 'المحل',
    'caisseHist.allStores': 'كل المحلات',
    'caisseHist.exportAccounting': 'تصدير محاسبي',
    'caisseHist.totalSales': 'إجمالي المبيعات',
    'caisseHist.totalCash': 'إجمالي الكاش',
    'caisseHist.totalCard': 'إجمالي البطاقة',
    'caisseHist.withdrawals': 'السحوبات',
    'caisseHist.totalTheoretical': 'الإجمالي النظري',
    'caisseHist.totalAccounting': 'الإجمالي المحاسبي',
    'caisseHist.discrepancy': 'الفرق',
    'caisseHist.validatedBy': 'تم التأكيد من',
    'caisseHist.validationDate': 'تاريخ التأكيد',
    'caisseHist.noValidatedCaisse': 'ما في صندوق متأكد منه.',
    'caisseHist.opening': 'الفتح',
    'caisseHist.closing': 'الإغلاق',
    'caisseHist.caisse': 'الصندوق',
    'caisseHist.daySales': 'مبيعات اليوم',
    'caisseHist.dateStart': 'تاريخ البداية',
    'caisseHist.dateEnd': 'تاريخ النهاية',
    'caisseHist.reset': 'إعادة تعيين',
    'caisseHist.cashFloat': 'رصيد الصندوق',
    'caisseHist.openedBy': 'مفتوح من',
    'caisseHist.closedBy': 'مسكّر من',
    'caisseHist.noHistory': 'ما في سجل متاح',
    'caisseHist.closingProgress': 'عم يسكّر...',
    'caisseHist.forceClose': 'تسكير (إجباري)',
    'caisseHist.forced': 'إجباري',
    'caisseHist.showMore': 'عرض المزيد ({{count}} عمليات فتح سابقة)',
    'caisseHist.showLess': 'عرض أقل',
    'repairDetail.popupBlocked': 'سامح بالنوافذ المنبثقة حتى تطبع.',
    'repairDetail.downloadError': 'خطأ وقت التنزيل',
    'repairDetail.statusUpdateError': 'خطأ وقت التحديث',
    'repairDetail.invalidAmount': 'مبلغ غير صالح',
    'repairDetail.genericError': 'خطأ',
    'repairDetail.filesAttached': '{{count}} ملف(ات) مرفقة',
    'repairDetail.uploadProgress': 'عم يترفع {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'صار خطأ وقت إضافة الملاحظة',
    'repairDetail.confirmDeleteNote': 'تحذف هالملاحظة؟',
    'repairDetail.notFound': 'ما انلقى التصليح',
    'repairDetail.backToRepairs': 'رجوع للتصليحات',
    'repairDetail.photosTitle': 'الصور ({{count}})',
    'repairDetail.photoAlt': 'صورة {{index}}',
    'repairDetail.notesTitle': 'الملاحظات ({{count}})',
    'repairDetail.notePlaceholder': 'ضيف ملاحظة...',
    'repairDetail.visibilityPublic': 'عام',
    'repairDetail.visibilityInternal': 'داخلي',
    'repairDetail.filesBtn': 'ملفات',
    'repairDetail.sending': 'عم يبعت...',
    'repairDetail.add': 'إضافة',
    'repairDetail.noNotes': 'ما في ملاحظات',
    'repairDetail.staffDefault': 'الموظف',
    'repairDetail.printAcompteError': 'خطأ بطباعة إيصال العربون',
    'repairDetail.printAvoirError': 'خطأ بطباعة إيصال الرصيد',
    'repairDetail.downloadPdfError': 'خطأ بتنزيل ملف PDF',
    'repairDetail.changeStatus': 'تغيير الحالة',
    'repairDetail.noStatusChange': 'ما في تغيير مسموح',
    'repairDetail.addDeposit': 'إضافة عربون',
    'repairDetail.amountLabel': 'المبلغ (€)',
    'repairDetail.paymentMode': 'طريقة الدفع',
    'repairDetail.paymentCash': 'كاش',
    'repairDetail.paymentCard': 'بطاقة',
    'repairDetail.paymentTransfer': 'تحويل',
    'repairDetail.paymentCheck': 'شيك',
    'repairDetail.cancel': 'إلغاء',
    'repairDetail.statusRecu': 'مستلَم',
    'repairDetail.statusEnCours': 'قيد التصليح',
    'repairDetail.statusAttentePieces': 'بانتظار القطع',
    'repairDetail.statusPieceArrivee': 'وصلت القطعة',
    'repairDetail.statusNonReparable': 'ما بينصلح',
    'repairDetail.statusTermine': 'خلص',
    'repairDetail.statusLivre': 'تسلّم',
    'repairDetail.statusAttenteDepot': 'بانتظار تسليم الجهاز',
    'closeCaisse.denomBillet': 'ورقة نقدية',
    'closeCaisse.denomPiece': 'قطعة معدنية',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'المجموع',
    'closeCaisse.errLoad': 'خطأ أثناء تحميل الصندوق',
    'closeCaisse.errPdf': 'خطأ أثناء إنشاء ملف PDF',
    'closeCaisse.errConfirmCb': 'لازم تأكّد دفعات البطاقة قبل ما تسكّر الصندوق',
    'closeCaisse.confirmEcart': 'انتبه: في فرق قدره {{ecart}}.\n\nالإجمالي النظري: {{theorique}}\nالإجمالي المعدود: {{compte}}\n\nبدك تكمّل؟',
    'closeCaisse.closeSuccess': 'تم تسكير الصندوق {{magasin}} بنجاح.',
    'closeCaisse.errClose': 'خطأ أثناء تسكير الصندوق',
    'closeCaisse.backToDashboard': 'رجوع للوحة التحكم',
    'closeCaisse.journee': 'يوم {{date}}',
    'closeCaisse.openedBy': 'مفتوح من {{name}}',
    'closeCaisse.refresh': 'تحديث',
    'closeCaisse.summaryTitle': 'ملخص الصندوق',
    'closeCaisse.activitySummary': 'نشاط المحل {{magasin}} — {{ops}} عملية ({{pos}} مبيعات نقطة البيع، {{acomptes}} دفعات مقدمة).',
    'closeCaisse.fondOuverture': 'رصيد الافتتاح',
    'closeCaisse.ventesEspeces': 'المبيعات النقدية',
    'closeCaisse.ventesCb': 'مبيعات البطاقة',
    'closeCaisse.paiementsStripe': 'مدفوعات Stripe',
    'closeCaisse.acomptes': 'الدفعات المقدمة',
    'closeCaisse.retraits': 'السحوبات',
    'closeCaisse.totalTheorique': 'الإجمالي النظري',
    'closeCaisse.totalVentes': 'إجمالي المبيعات: {{montant}}',
    'closeCaisse.activiteVendeur': 'النشاط حسب البائع',
    'closeCaisse.colVendeur': 'البائع',
    'closeCaisse.colOps': 'عمليات',
    'closeCaisse.colEspeces': 'كاش',
    'closeCaisse.colCb': 'بطاقة',
    'closeCaisse.comptageEspeces': 'عدّ الكاش',
    'closeCaisse.comptageSubtitle': 'الأوراق والقطع النقدية مع تفصيل مرئي للتسكير.',
    'closeCaisse.totalCompte': 'الإجمالي المعدود',
    'closeCaisse.ecart': 'الفرق',
    'closeCaisse.ecartImportant': 'في فرق كبير',
    'closeCaisse.infosComplementaires': 'معلومات إضافية',
    'closeCaisse.montantCoffreLabel': 'المبلغ المودع بالخزنة (EUR)',
    'closeCaisse.montantCoffreHint': 'المبلغ النقدي المودع بالخزنة.',
    'closeCaisse.cbConfirmLabel': 'أكّدت دفعات البطاقة',
    'closeCaisse.cbConfirmHint': 'تأكّد إنو كل دفعات البطاقة انحصّلت عالجهاز.',
    'closeCaisse.imprimerRapport': 'طباعة التقرير',
    'closeCaisse.validerCaisse': 'اعتماد الصندوق',
    'closeCaisse.onlyAdmin': 'بس المسؤول فيه يعتمد تسكير الصندوق',
    'paiements.title': 'الدفعات أونلاين',
    'paiements.proofsToValidate': '{{count}} إثبات بانتظار التأكيد',
    'paiements.pendingCount': '{{count}} بالانتظار',
    'paiements.tabSumup': 'دفعات SumUp ({{count}})',
    'paiements.tabProofs': 'إثباتات الدفع ({{count}})',
    'paiements.noProof': 'ما في إثبات دفع',
    'paiements.orderDefault': 'طلب',
    'paiements.proofValidated': 'تأكّد',
    'paiements.proofPendingValidation': 'بانتظار التأكيد',
    'paiements.totalLabel': 'المجموع: ',
    'paiements.sentLabel': 'انبعتت: ',
    'paiements.byLabel': 'من: ',
    'paiements.validatedByLabel': 'تأكّد من: ',
    'paiements.viewCapture': 'شوف الصورة',
    'paiements.validatePayment': 'أكّد الدفع',
    'paiements.reject': 'رفض',
    'paiements.confirmOrder': 'أكّد الطلب',
    'paiements.filterAll': 'الكل',
    'paiements.filterPending': 'بالانتظار',
    'paiements.filterConfirmed': 'مأكّدة',
    'paiements.filterCancelled': 'ملغية',
    'paiements.noPayment': 'ما في دفعات',
    'paiements.amountLabel': 'المبلغ: ',
    'paiements.refLabel': 'المرجع: ',
    'paiements.dateLabel': 'التاريخ: ',
    'paiements.ticketPdf': 'إيصال PDF',
    'paiements.validate': 'أكّد',
    'paiements.cancel': 'إلغاء',
    'paiements.statusPaidApplied': 'مأكّد',
    'paiements.statusPaidPending': 'بالانتظار',
    'paiements.statusPending': 'عم يتعالج',
    'paiements.statusCancelled': 'ملغي',
    'paiements.orderRepair': 'تصليح {{ref}}',
    'paiements.orderBoutique': 'طلب من المتجر',
    'paiements.alertConfirmed': 'تأكد الدفع وانطبّق!',
    'paiements.errorConfirm': 'صار خطأ وقت التأكيد',
    'paiements.confirmCancel': 'تلغي هالدفعة؟',
    'paiements.error': 'خطأ',
    'paiements.errorTicket': 'صار خطأ وقت تنزيل الإيصال',
    'paiements.confirmValidateProof': 'تأكّد إثبات الدفع هاد؟',
    'paiements.alertProofValidated': 'تأكد الدفع!',
    'paiements.confirmRejectProof': 'ترفض إثبات الدفع هاد؟',
    'paiements.confirmConfirmOrder': 'تأكّد هالطلب؟',
    'paiements.alertOrderConfirmed': 'تأكد الطلب!',
    'repairForm.deviceNotFound': 'الجهاز مو موجود',
    'repairForm.selectMagasinFirst': 'اختار أول شي المحل يلي رح ياخد هالتصليح.',
    'repairForm.saveError': 'صار خطأ وقت الحفظ',
    'repairForm.conversionFromCommande': 'تحويل من طلبية',
    'repairForm.prefillNotice': 'معلومات معبّاية من قبل · العربون ({{amount}}) بينحوّل وقت الإنهاء.',
    'repairForm.sectionMagasin': 'المحل',
    'repairForm.magasinLabel': 'المحل يلي رح ياخد الجهاز *',
    'repairForm.selectMagasinOption': '— اختار محل —',
    'repairForm.sectionForcedEntry': 'تسجيل إجباري',
    'repairForm.forcedEntryHint': 'لإيداع اننسي: سجّل التصليح بتاريخ الإيداع الحقيقي (مو تاريخ اليوم).',
    'repairForm.useBackdateLabel': 'استخدم تاريخ إيداع أقدم',
    'repairForm.realDepotDateTime': 'تاريخ ووقت الإيداع الحقيقي',
    'repairForm.sectionClient': 'الزبون',
    'repairForm.clientName': 'اسم الزبون *',
    'repairForm.phone': 'التلفون *',
    'repairForm.email': 'الإيميل',
    'repairForm.address': 'العنوان',
    'repairForm.sectionDevice': 'الجهاز',
    'repairForm.brand': 'الماركة *',
    'repairForm.model': 'الموديل *',
    'repairForm.problem': 'المشكلة',
    'repairForm.technician': 'الفني',
    'repairForm.selectOption': '— اختار —',
    'repairForm.imeiSerial': 'IMEI / الرقم التسلسلي',
    'repairForm.deviceLock': 'رمز القفل',
    'repairForm.sectionParts': 'القطع',
    'repairForm.defectivePartsHint': 'القطع يلي مو شغّالة وقت الاستلام',
    'repairForm.phoneDoesntTurnOn': 'التلفون ما بيفتح',
    'repairForm.sectionStockParts': 'قطع من المخزون (اختياري)',
    'repairForm.stockPartsHint': 'إذا القطعة موجودة بمخزون المحل، رح تنخصم وقت الإنشاء ويتعاد حساب سعر التصليح حسب أسعار الكتالوج. وإلا، حُطّ سعر يدوي تحت (عرض سعر تقديري).',
    'repairForm.stockPartsTotal': 'مجموع قطع المخزون: {{amount}} — بينطبّق وقت الإنشاء إذا متوفّر.',
    'repairForm.sectionPricing': 'الأسعار',
    'repairForm.priceRepair': 'سعر التصليح (€)',
    'repairForm.theoreticalQuote': '— عرض سعر تقديري',
    'repairForm.priceDiagnostic': 'سعر التشخيص (€)',
    'repairForm.receptionNotes': 'ملاحظات الاستلام',
    'repairForm.sectionPhotos': 'الصور',
    'repairForm.addPhoto': 'ضيف',
    'repairForm.cancel': 'إلغاء',
    'repairForm.save': 'حفظ',
    'repairForm.createRepair': 'إنشاء التصليح',
    'repairForm.parts.speaker': 'السماعة الخارجية',
    'repairForm.parts.lcd': 'الشاشة',
    'repairForm.parts.front_cam': 'الكاميرا الأمامية',
    'repairForm.parts.back_cam': 'الكاميرا الخلفية',
    'repairForm.parts.microphone': 'المايك',
    'repairForm.parts.fingerprint': 'بصمة الإصبع',
    'repairForm.parts.home_button': 'زر الهوم',
    'repairForm.parts.volume_button': 'زر الصوت',
    'repairForm.parts.power_button': 'زر التشغيل',
    'repairForm.parts.signal_carrier': 'الإشارة',
    'repairForm.parts.battery': 'البطارية',
    'repairForm.parts.wifi_bt': 'واي فاي/بلوتوث',
    'repairForm.parts.ear_speaker': 'سماعة الأذن',
    'repairForm.parts.charging_port': 'مدخل الشحن',
    'labels.barcodeAuto': 'رح ينعمل EAN13 تلقائيًا',
    'labels.allowPopups': 'لازم تسمح بالنوافذ المنبثقة حتى تطبع.',
    'labels.selectAtLeastOne': 'اختار منتج واحد ع الأقل',
    'labels.errorGenerate': 'خطأ بإنشاء الملصقات',
    'labels.infoNoEan': 'معلومة: {{count}} منتج بدون EAN — انعمل EAN13 داخلي تلقائيًا. المجموع: {{total}} ملصق.',
    'labels.jobCreated': 'انعملت مهمة طباعة ({{count}} ملصق).\nالمعرّف: {{id}}...\nوكيل Bixolon رح ياخد هالدفعة.',
    'labels.jobNoEan': '\nملاحظة: {{count}} بدون EAN (انعمل تلقائيًا).',
    'labels.errorBatch': 'خطأ بالطباعة بالدفعات',
    'labels.generating': 'عم يتعمل...',
    'labels.generatePdf': 'إنشاء PDF ({{count}})',
    'labels.previewPdf': 'معاينة PDF ({{count}})',
    'labels.printBixolon': 'طباعة Bixolon ({{count}})',
    'labels.clear': 'تفريغ',
    'labels.format': 'التنسيق',
    'labels.formatBixolon': 'Bixolon 50 × 30 مم (حرارية)',
    'labels.formatA4': 'ورقة A4 (قديمة)',
    'labels.pageTitle': 'ملصقات المنتجات',
    'labels.pageSubtitle': 'ملصقات منتجات قابلة للتخصيص',
    'labels.config': 'إعدادات',
    'labels.searchPlaceholder': 'دوّر ع منتج...',
    'labels.boutique': 'المحل',
    'labels.depot': 'المستودع',
    'labels.deselectAll': 'إلغاء تحديد الكل',
    'labels.colProduct': 'المنتج',
    'labels.colPrice': 'السعر',
    'labels.colBoutiqueShort': 'المحل',
    'labels.colQtyToPrint': 'الكمية للطباعة',
    'labels.noProduct': 'ما في منتج',
    'labels.autoShort': 'تلقائي',
    'labels.previewTitle': 'معاينة الملصق',
    'labels.refLabel': 'المرجع:',
    'labels.selectedProducts': 'المنتجات المحددة',
    'labels.totalLabels': 'مجموع الملصقات',
    'labels.autoGenAtPdf': 'بينعمل تلقائيًا بملف PDF',
    'labels.selectToPreview': 'اختار منتج حتى تعاين',
    'labels.batchVeryLarge': 'دفعة كبيرة كتير',
    'labels.batchConfirmTitle': 'أكّد الدفعة الكبيرة',
    'labels.confirmBodyPrefix': 'رح تعمل',
    'labels.confirmBodySuffix': 'ملصق.',
    'labels.estRoll': '≈ {{meters}} م من اللفة (50×30مم)',
    'labels.estTime': '≈ {{minutes}} دقيقة طباعة (~1.5 ثانية/ملصق)',
    'labels.cancel': 'إلغاء',
    'labels.confirmAnyway': 'أكّد ع كل حال',
    'labels.continue': 'متابعة',
    'rep.status.awaitingDeposit': 'بانتظار إحضار الجهاز',
    'rep.status.received': 'مستلم',
    'rep.status.inProgress': 'عم يتصلّح',
    'rep.status.awaitingParts': 'بانتظار القطع',
    'rep.status.completed': 'خلص',
    'rep.status.notRepairable': 'ما بينصلّح',
    'rep.status.delivered': 'تسلّم',
    'rep.status.refused': 'مرفوض',
    'rep.payCash': 'كاش',
    'rep.payCard': 'بطاقة',
    'rep.payTransfer': 'حوالة',
    'rep.payCheck': 'شيك',
    'rep.accept': 'قبول',
    'rep.addError': 'صار خطأ وقت الإضافة',
    'rep.adminOnlyStatus': 'بس المدير فيه يغيّر هالحالة.',
    'rep.allowPopups': 'لازم تسمح بالنوافذ المنبثقة حتى تطبع.',
    'rep.chatTitle': 'محادثة التصليح {{ref}}',
    'rep.confirmArrivalAsk': 'بدك تأكّد استلام الجهاز {{ref}} بالمحل؟',
    'rep.confirmArrivalDone': 'تأكّد الجهاز! التصليح هلّق فعّال.',
    'rep.confirmArrivalError': 'صار خطأ وقت التأكيد',
    'rep.created': 'انعمل',
    'rep.currentStatus': 'الحالة الحالية:',
    'rep.deleteError': 'صار خطأ وقت الحذف',
    'rep.deleteRecordAsk': 'بدك تحذف هالسجل؟',
    'rep.deleteStatusAsk': 'بدك تحذف الحالة «{{name}}»؟',
    'rep.depositAmountEuro': 'مبلغ العربون (€)',
    'rep.diagnosticPaid': 'التشخيص مدفوع',
    'rep.diagnosticRemaining': 'التشخيص: باقي {{amount}}',
    'rep.downloadError': 'صار خطأ وقت التنزيل',
    'rep.error': 'خطأ',
    'rep.invalidAmount': 'مبلغ غلط',
    'rep.newStatus': 'حالة جديدة',
    'rep.noDeposits': 'ما في عربون مدفوع',
    'rep.noOnlineRequests': 'ما في طلبات أونلاين منتظرة',
    'rep.onlineRequests': 'الطلبات أونلاين ({{count}})',
    'rep.or': 'أو',
    'rep.pointAtTicketQr': 'وجّه الكاميرا عالـ QR يلي عالتذكرة',
    'rep.printAcompteError': 'خطأ بطباعة إيصال العربون',
    'rep.qrPrintHint': 'امسح الرمز حتى تتابع تصليحك',
    'rep.qrSearchPlaceholder': 'مثال: REM0094',
    'rep.qrTrackingHint': 'الزبون بيمسح رمز QR هاد حتى يتابع تصليحه لحظة بلحظة',
    'rep.qrTrackingTitle': 'رمز QR للمتابعة',
    'rep.reference': 'المرجع:',
    'rep.repair': 'التصليح',
    'rep.scanOrEnterRef': 'امسح رمز QR أو اكتب المرجع',
    'rep.scanWithCamera': 'امسح بالكاميرا',
    'rep.searchRepair': 'دوّر على تصليح',
    'rep.statusManagement': 'إدارة الحالات',
    'rep.ticket': 'إيصال',
    'rep.updateError': 'صار خطأ وقت التحديث',
    'rep.bulkNoteSentSingular': 'انبعتت الملاحظة لـ {{count}} ملف{{skip}}.',
    'rep.bulkNoteSentPlural': 'انبعتت الملاحظة لـ {{count}} ملفات{{skip}}.',
    'rep.bulkNoteSkippedSingular': '(تم تجاهل {{count}})',
    'rep.bulkNoteSkippedPlural': '(تم تجاهل {{count}})',
    'devisDepl.title': 'عروض أسعار الزيارة عالبيت',
    'devisDepl.subtitle': 'إدارة عروض الأسعار لتصليحات البيت',
    'devisDepl.newDevis': 'عرض سعر جديد',
    'devisDepl.exportCsv': 'تصدير CSV',
    'devisDepl.remindBtn': 'تذكير ({{count}})',
    'devisDepl.sending': 'عم يرسل...',
    'devisDepl.send': 'إرسال',
    'devisDepl.cancel': 'إلغاء',
    'devisDepl.errGeneric': 'خطأ',
    'devisDepl.confirmSendReminders': 'نبعت تذكير لـ {{count}} زبون عندن عروض أسعار معلّقة من أكتر من 3 أيام؟',
    'devisDepl.remindersSent': 'انبعت {{count}} تذكير!',
    'devisDepl.sentByEmail': 'انبعت عرض السعر عالإيميل!',
    'devisDepl.errSend': 'خطأ بالإرسال',
    'devisDepl.confirmDelete': 'تنحذف عرض السعر هاد؟',
    'devisDepl.searchPlaceholder': 'دوّر بالمرجع أو الاسم أو الإيميل...',
    'devisDepl.noResults': 'ما في نتائج',
    'devisDepl.empty': 'ما تعمل ولا عرض سعر',
    'devisDepl.travelFeeLabel': 'أجرة المشوار',
    'devisDepl.invalidAmount': 'مبلغ غير صالح',
    'devisDepl.errPayment': 'خطأ بالدفع',
    'devisDepl.confirmStaffAccept': 'تعتمد عرض السعر هاد؟ رح ينعمل أمر شراء وفاتورة.',
    'devisDepl.errValidation': 'خطأ بالاعتماد',
    'devisDepl.reminderSent': 'انبعت التذكير',
    'devisDepl.errSendReminder': 'خطأ بإرسال التذكير',
    'devisDepl.confirmValidateBon': 'تعتمد أمر الشراء؟',
    'devisDepl.errSendFacture': 'خطأ بإرسال الفاتورة',
    'devisDepl.confirmDetach': 'تفصل عرض السعر هاد عن التصليح {{ref}}؟',
    'devisDepl.status.pending': 'قيد الانتظار',
    'devisDepl.status.accepted': 'مقبول',
    'devisDepl.status.refused': 'مرفوض',
    'devisDepl.status.depositPaid': 'تم دفع العربون',
    'devisDepl.status.paid': 'مدفوع',
    'devisDepl.stats.total': 'الإجمالي',
    'devisDepl.stats.pending': 'قيد الانتظار',
    'devisDepl.stats.accepted': 'مقبولة',
    'devisDepl.stats.refused': 'مرفوضة',
    'devisDepl.stats.revenue': 'المداخيل',
    'devisDepl.filter.all': 'كل الحالات',
    'devisDepl.requests.title': 'طلبات عروض الأسعار الجايي',
    'devisDepl.requests.newCountSingular': '{{count}} جديد',
    'devisDepl.requests.newCountPlural': '{{count}} جديدة',
    'devisDepl.requests.defaultTitle': 'طلب عرض سعر',
    'devisDepl.requests.statusNew': 'جديد',
    'devisDepl.requests.statusInProgress': 'عم تتعالج',
    'devisDepl.requests.statusRefused': 'مرفوض',
    'devisDepl.requests.statusTreated': 'تمت المعالجة',
    'devisDepl.requests.client': 'زبون',
    'devisDepl.requests.addressLabel': 'العنوان',
    'devisDepl.requests.createDevis': 'إنشاء عرض سعر',
    'devisDepl.requests.markTreated': 'تمت المعالجة',
    'devisDepl.requests.refuse': 'رفض',
    'devisDepl.requests.refuseMotifLabel': 'سبب الرفض',
    'devisDepl.requests.refuseMotifPlaceholder': 'سبب الرفض (اختياري)...',
    'devisDepl.requests.confirmRefuse': 'تأكيد الرفض',
    'devisDepl.requests.refuseMotifShownLabel': 'سبب الرفض:',
    'devisDepl.sumup.title': 'طلبات رابط SumUp',
    'devisDepl.sumup.pendingCount': '{{count}} قيد الانتظار',
    'devisDepl.sumup.enterLinkAlert': 'فوت رابط SumUp',
    'devisDepl.sumup.linkSentAlert': 'انبعت رابط SumUp للزبون عالإيميل!',
    'devisDepl.sumup.linkPlaceholder': 'لصّق رابط SumUp هون...',
    'devisDepl.chart.title': 'النشاط بآخر 30 يوم',
    'devisDepl.chart.accepted': 'مقبولة',
    'devisDepl.chart.pending': 'قيد الانتظار',
    'devisDepl.chart.refused': 'مرفوضة',
    'devisDepl.chart.noData': 'ما في بيانات لهالفترة',
    'devisDepl.form.editTitle': 'تعديل عرض السعر',
    'devisDepl.form.newTitle': 'عرض سعر جديد',
    'devisDepl.form.clientName': 'اسم الزبون *',
    'devisDepl.form.searchPlaceholder': 'اكتب لتدوّر...',
    'devisDepl.form.phone': 'التلفون',
    'devisDepl.form.email': 'الإيميل *',
    'devisDepl.form.emailPlaceholder': 'email@example.com',
    'devisDepl.form.address': 'العنوان',
    'devisDepl.form.addressPlaceholder': 'عنوان الزبون',
    'devisDepl.form.descriptionLabel': 'وصف التصليح',
    'devisDepl.form.descriptionPlaceholder': 'وصف الشغل المطلوب...',
    'devisDepl.form.lines': 'بنود عرض السعر',
    'devisDepl.form.addLine': 'إضافة',
    'devisDepl.form.designation': 'البيان',
    'devisDepl.form.price': 'السعر',
    'devisDepl.form.travelFee': 'أجرة المشوار ({{amount}})',
    'devisDepl.form.acceptOnline': 'قبول الدفع أونلاين (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'الزبون رح يقدر يطلب رابط دفع SumUp',
    'devisDepl.form.total': 'الإجمالي',
    'devisDepl.form.submitEdit': 'تحديث',
    'devisDepl.form.submitCreate': 'إنشاء عرض السعر',
    'devisDepl.form.nameEmailRequired': 'اسم الزبون والإيميل ضروريين',
    'devisDepl.form.atLeastOneLine': 'ضيف بند واحد عالأقل مع البيان والسعر',
    'devisDepl.detail.phone': 'التلفون:',
    'devisDepl.detail.address': 'العنوان:',
    'devisDepl.detail.purchaseOrder': 'أمر الشراء:',
    'devisDepl.detail.invoice': 'الفاتورة:',
    'devisDepl.detail.emailSentOn': 'انبعت الإيميل بـ {{date}}',
    'devisDepl.detail.reminderSentOn': 'انبعت التذكير بـ {{date}}',
    'devisDepl.table.designation': 'البيان',
    'devisDepl.table.qty': 'الكمية',
    'devisDepl.table.price': 'السعر',
    'devisDepl.table.total': 'الإجمالي',
    'devisDepl.actions.validateDevis': 'اعتماد عرض السعر',
    'devisDepl.actions.sendByEmail': 'إرسال عرض السعر عالإيميل',
    'devisDepl.actions.remindAcceptance': 'تذكير بالقبول',
    'devisDepl.actions.edit': 'تعديل',
    'devisDepl.actions.validateBon': 'اعتماد أمر الشراء',
    'devisDepl.actions.bonValidated': 'تم اعتماد الأمر',
    'devisDepl.actions.remindPayment': 'تذكير بالدفع',
    'devisDepl.actions.pdfDevis': 'PDF عرض السعر',
    'devisDepl.actions.pdfBon': 'PDF أمر الشراء',
    'devisDepl.actions.pdfFacture': 'PDF الفاتورة',
    'devisDepl.actions.sendFactureEmail': 'إرسال الفاتورة عالإيميل',
    'devisDepl.actions.registerPayment': 'تسجيل الدفع',
    'devisDepl.actions.delete': 'حذف',
    'devisDepl.actions.linkedTo': 'مربوط بـ {{ref}}',
    'devisDepl.actions.attachToRepair': 'ربط بتصليح',
    'devisDepl.payment.title': 'تسجيل دفعة',
    'devisDepl.payment.devisLabel': 'عرض السعر:',
    'devisDepl.payment.totalLabel': 'الإجمالي:',
    'devisDepl.payment.methodLabel': 'طريقة الدفع',
    'devisDepl.payment.cash': 'كاش',
    'devisDepl.payment.card': 'بطاقة',
    'devisDepl.payment.transfer': 'حوالة',
    'devisDepl.payment.mixed': 'مختلط',
    'devisDepl.payment.amount': 'المبلغ',
    'devisDepl.payment.noteLabel': 'ملاحظة (اختياري)',
    'devisDepl.payment.notePlaceholder': 'مثلاً: عربون، الباقي...',
    'devisDepl.payment.submit': 'تأكيد الدفع',
    'reviews.ratingFallback': 'زباينّا بيقيّمونا على Google',
    'reviews.subtitle': 'شوف آراء زباينّا على Google وشاركنا تجربتك.',
    'reviews.readCta': 'اقرا تقييماتنا على Google',
    'reviews.writeCta': 'اترك تقييم',
    'acompteStart.title': 'عربون عرض السعر تبعك',
    'acompteStart.subtitle': 'Resurrection Mobile · دفع آمن عبر SumUp',
    'acompteStart.loading': 'عم نحضّر الدفع…',
    'acompteStart.redirecting': 'عم نحوّلك لصفحة الدفع',
    'acompteStart.clickHere': 'اضغط هون إذا ما صار شي.',
    'acompteStart.paid': 'هالعربون اندفع من قبل. شكراً إلك! طلبك عم يتجهّز.',
    'acompteStart.orderRef': 'الطلب {{ref}}',
    'acompteStart.errTitle': 'الدفع أونلاين مش متاح هلّق مؤقتاً',
    'acompteStart.retry': 'جرّب مرة تانية',
    'acompteStart.whatsappPay': 'ادفع عبر واتساب / تواصل معنا',
    'acompteStart.inStore': 'فيك تدفع العربون مباشرةً بالمحل كمان.',
    'acompteStart.footer': 'بعد الدفع، طلب القطعة بينسجّل أوتوماتيكياً وبيوصلك إيصال عالإيميل.',
    'acompteStart.backToSite': 'الرجوع للموقع',
    'acompteStart.errLinkUnavailable': 'رابط الدفع مش متاح.',
    'acompteStart.errOnlineUnavailable': 'الدفع أونلاين مش متاح هلّق مؤقتاً.',
    'acompteStart.waMessage': 'مرحبا، بدّي ادفع عربون عرض السعر تبعي ({{id}}).',
    'emailVerif.loadingTitle': 'عم نتحقق...',
    'emailVerif.loadingSub': 'استنّى شوي من فضلك',
    'emailVerif.successTitle': 'تفعّل الحساب!',
    'emailVerif.successDefault': 'تأكّد الإيميل بنجاح!',
    'emailVerif.login': 'تسجيل الدخول',
    'emailVerif.errorTitle': 'خطأ بالتحقق',
    'emailVerif.errorDefault': 'خطأ بالتحقق',
    'emailVerif.invalidLink': 'رابط التحقق مو صالح.',
    'emailVerif.backLogin': 'رجوع لتسجيل الدخول',
    'emailVerif.expiredTitle': 'خلصت صلاحية الرابط',
    'emailVerif.expiredDefault': 'هالرابط خلصت صلاحيته.',
    'emailVerif.backLoginResend': 'رجوع لتسجيل الدخول (عيد إرسال الإيميل)',
    'paySuccess.noPaymentToVerify': 'ما في دفعة لنتأكد منها',
    'paySuccess.statusCheckFailed': 'ما قدرنا نتأكد من الحالة. رح تنعالج الدفعة تلقائيًا.',
    'paySuccess.verificationError': 'صار خطأ وقت التأكد من الدفعة',
    'paySuccess.completedTitle': 'تمت الدفعة بنجاح!',
    'paySuccess.completedDesc': 'تأكدت دفعتك وانطبقت على ملفك.',
    'paySuccess.failedTitle': 'فشلت الدفعة',
    'paySuccess.failedDesc': 'ما قدرنا نعالج الدفعة. جرّب مرة تانية.',
    'paySuccess.pendingTitle': 'عم تتعالج الدفعة',
    'paySuccess.pendingDesc': 'عم نتأكد من دفعتك. رح تنطبق تلقائيًا.',
    'paySuccess.verifying': 'عم نتأكد من الدفعة...',
    'paySuccess.errorTitle': 'خطأ',
    'paySuccess.amountLabel': 'المبلغ:',
    'paySuccess.repairLabel': 'التصليح:',
    'paySuccess.orderLabel': 'الطلبية:',
    'paySuccess.referenceLabel': 'المرجع:',
    'paySuccess.noInfo': 'ما في معلومات دفع متوفرة.',
    'paySuccess.backToSpace': 'رجوع لمساحتي',
    'devisChat.errStart': 'ما قدرنا نبلّش المحادثة. جرّب مرة تانية.',
    'devisChat.errSend': 'خطأ بالإرسال',
    'devisChat.errNetwork': 'خطأ بالشبكة',
    'devisChat.hint': 'اطلب عرض سعرك عالإيميل',
    'devisChat.fabAria': 'طلب عرض سعر',
    'devisChat.fabLabel': 'عرض سعر مجاني',
    'devisChat.panelTitle': 'عرض سعر R.E.Mobiles',
    'devisChat.panelSubtitle': 'بينبعت عالإيميل بعد الموافقة',
    'devisChat.close': 'إغلاق',
    'devisChat.connecting': 'عم نتّصل…',
    'devisChat.inputPlaceholder': 'مثال: شاشة iPhone 13…',
    'register.emailRequired': 'الإيميل لازم لإنشاء حساب.',
    'register.passwordMinLength': 'لازم كلمة السر تكون 4 أحرف عالأقل.',
    'register.passwordMismatch': 'كلمتين السر مو متطابقتين.',
    'register.registerError': 'صار خطأ وقت التسجيل',
    'register.verifyEmailTitle': 'شوف إيميلك!',
    'register.confirmationSentTo': 'انبعت إيميل تأكيد لـ:',
    'register.activateHint': 'دوس عالرابط اللي بالإيميل لتفعّل حسابك. وإذا ما لقيته شوف السبام كمان.',
    'register.goToLogin': 'روح لتسجيل الدخول',
    'register.clientSubtitle': 'تابع إصلاحاتك',
    'register.namePlaceholder': 'محمد أحمد',
    'register.emailPlaceholder': 'email@example.com',
    'register.emailHint': 'رح ينبعتلك إيميل تأكيد لتفعّل حسابك',
    'register.addressPlaceholder': '123 شارع المثال',
    'register.password': 'كلمة السر',
    'register.confirmPassword': 'أكّد كلمة السر',
    'register.referralCode': 'كود الإحالة (اختياري)',
    'register.referredBy': 'بتوصية من {{nom}}',
    'register.invalidReferral': 'كود الإحالة غلط',
    'register.termsNotice': 'لما تعمل حساب، يعني وافقت على شروط الاستخدام تبعنا',
    'login.googleDisabled': 'تم تعطيل تسجيل الدخول عبر Google. استخدم اسم المستخدم وكلمة السر تبعك.',
    'login.invalid2FA': 'رمز التحقق الثنائي غير صحيح',
    'login.tabStaff': 'الفريق',
    'login.tabClient': 'الزبون',
    'login.tabBusiness': 'شركة',
    'login.frenchGuiana': 'غويانا الفرنسية',
    'login.emailNotVerifiedTitle': 'الإيميل مو متأكد منه',
    'login.emailNotVerifiedDesc': 'لازم تأكد إيميلك قبل ما تسجّل دخول.',
    'login.emailResent': 'انبعت الإيميل من جديد! شوف صندوق الوارد تبعك.',
    'login.sending': 'عم ينبعت...',
    'login.resendVerification': 'إعادة إرسال إيميل التأكيد',
    'login.back': 'رجوع',
    'login.twoFATitle': 'التحقق بخطوتين',
    'login.twoFASubtitle': 'حط الرمز من تطبيقك',
    'login.verifying': 'عم يتحقق...',
    'login.verify': 'تحقّق',
    'login.passwordPlaceholder': 'كلمة السر تبعك',
    'login.allRightsReserved': 'جميع الحقوق محفوظة.',
    'acompteSuccess.errorIncompleteLink': 'رابط الدفع ناقص.',
    'acompteSuccess.errorCannotConfirm': 'ما قدرنا نأكّد الدفع هلّق.',
    'acompteSuccess.whatsappMessage': 'مرحبا، دفعت العربون تبع عرض السعر (المرجع {{ref}}). بتقدروا تأكّدوا طلبي؟',
    'acompteSuccess.whatsappDefault': 'راسلنا عالواتساب',
    'acompteSuccess.errorHint': 'إذا انخصم مبلغ الدفع فعلًا، رح ينسجّل طلبك تلقائيًا خلال شوية دقايق ورح يوصلك إيميل تأكيد.',
    'acompteSuccess.appliedTitle': 'وصل العربون',
    'acompteSuccess.orderRegisteredLead': 'شكرًا إلك. طلب القطعة تبعك',
    'acompteSuccess.orderRegisteredTail': 'انسجّل. بعتنالك إيصال عالإيميل؛ ورح يوصلك رقم التتبّع أول ما ينشحن.',
    'acompteSuccess.staffPendingTitle': 'وصل الدفع',
    'acompteSuccess.staffPendingBody': 'عربونك انسجّل منيح عند SumUp. فريقنا عم يخلّص طلبك يدويًا ورح يأكّدلك ياه عالإيميل عن قريب.',
    'acompteSuccess.whatsappQuestion': 'عندك سؤال؟ واتساب',
    'acompteSuccess.sumupFailedTitle': 'الدفع ما كمّل',
    'acompteSuccess.sumupFailedBody': 'SumUp ما أكّدت الدفع ({{status}}). فيك تعيد المحاولة من الرابط يلي بإيميل عرض السعر، أو تتواصل معنا.',
    'acompteSuccess.timedOutTitle': 'التأكيد عم يتعالج',
    'acompteSuccess.timedOutBody': 'SumUp لسا ما أكّدت دفعتك. لا تقلق: إذا انخصم المبلغ، رح ينعمل طلبك تلقائيًا خلال شوية دقايق ورح يوصلك إيميل تأكيد. فيك تسكّر هالصفحة.',
    'acompteSuccess.recheckNow': 'إعادة التحقق هلّق',
    'acompteSuccess.whatsappProof': 'ابعت إثبات الدفع عالواتساب',
    'acompteSuccess.verifyingTitle': 'عم نتحقق من الدفع…',
    'acompteSuccess.verifyingBody': 'استنى كم ثانية لو سمحت.',
    'acompteSuccess.backHome': 'رجوع للصفحة الرئيسية',
    'b2bDashboard.acceptRefuse': 'قبول / رفض',
    'b2bDashboard.actions': 'إجراءات',
    'b2bDashboard.addNotePlaceholder': 'ضيف ملاحظة عن هالتصليح...',
    'b2bDashboard.addPhoto': '+ إضافة',
    'b2bDashboard.additionalInfoPlaceholder': 'معلومات إضافية...',
    'b2bDashboard.additionalNotes': 'ملاحظات إضافية',
    'b2bDashboard.addressOptional': 'العنوان (اختياري)',
    'b2bDashboard.addressPlaceholder': 'العنوان للتنقّل إذا لزم',
    'b2bDashboard.alertDescribeRequest': 'رجاءً وصّف طلبك',
    'b2bDashboard.amount': 'المبلغ',
    'b2bDashboard.awaitingReceptionStore': 'عم ننتظر الاستلام بالمحل',
    'b2bDashboard.back': 'رجوع',
    'b2bDashboard.backGlass': 'الجام الخلفي',
    'b2bDashboard.backGlassBroken': 'الجام الخلفي مكسور',
    'b2bDashboard.backGlassIntact': 'الجام الخلفي سليم',
    'b2bDashboard.brandModelRequired': 'الماركة والموديل ضروريين',
    'b2bDashboard.broken': 'مكسور',
    'b2bDashboard.changePassword': 'تغيير كلمة السر',
    'b2bDashboard.chat': 'محادثة',
    'b2bDashboard.clear': 'مسح',
    'b2bDashboard.clickNewRequestHint': 'اضغط على «طلب جديد» لتعمل واحد',
    'b2bDashboard.clickToAddPhotos': 'اضغط لإضافة صور',
    'b2bDashboard.code': 'رمز',
    'b2bDashboard.code6Digits': 'رمز من 6 أرقام',
    'b2bDashboard.codeDigitsLetters': 'رمز (أرقام/أحرف)',
    'b2bDashboard.codeValidatedSuccess': 'تم تأكيد الرمز بنجاح!',
    'b2bDashboard.confirmOrderEmailPre': 'انبعت أمر شراء مع رمز تأكيد لبريدك الإلكتروني. دخّل هالرمز بقسم ',
    'b2bDashboard.confirmOrderEmailPost': ' لتأكيد طلبك.',
    'b2bDashboard.createdOn': 'انعملت بـ',
    'b2bDashboard.customerProvidesPart': 'أنا بجيب القطعة',
    'b2bDashboard.date': 'التاريخ',
    'b2bDashboard.delivery': 'التسليم',
    'b2bDashboard.delivery.pickup': 'الاستلام',
    'b2bDashboard.delivery.postal': 'إرسال بالبريد',
    'b2bDashboard.delivery.store': 'بالمحل',
    'b2bDashboard.describeProblemPlaceholder': 'وصّف المشكلة...',
    'b2bDashboard.designation': 'البيان',
    'b2bDashboard.device': 'الجهاز',
    'b2bDashboard.devisStatus.accepted': 'مقبول',
    'b2bDashboard.devisStatus.depositPaid': 'تم دفع العربون',
    'b2bDashboard.devisStatus.paid': 'مدفوع',
    'b2bDashboard.devisStatus.pending': 'قيد الانتظار',
    'b2bDashboard.devisStatus.refused': 'مرفوض',
    'b2bDashboard.diagRef': 'مرجع التشخيص:',
    'b2bDashboard.documentsWord': 'المستندات',
    'b2bDashboard.downloadError': 'صار خطأ وقت التنزيل',
    'b2bDashboard.downloadPdf': 'تنزيل PDF',
    'b2bDashboard.enter6DigitCode': 'دخّل الرمز المكوّن من 6 أرقام',
    'b2bDashboard.enterCodePerOrder': 'دخّل الرمز يلّي وصلك عالإيميل لتأكيد كل أمر شراء.',
    'b2bDashboard.enterCodeToValidate': 'دخّل الرمز يلّي وصلك عالإيميل لتأكيد طلبك.',
    'b2bDashboard.enterPinPlaceholder': 'دخّل رمز PIN، كلمة السر...',
    'b2bDashboard.enterValidationCode': 'رجاءً دخّل رمز التحقق',
    'b2bDashboard.error': 'خطأ',
    'b2bDashboard.filter.all': 'الكل',
    'b2bDashboard.history': 'السجل',
    'b2bDashboard.imeiSerial': 'IMEI / الرقم التسلسلي',
    'b2bDashboard.imeiSerialShort': 'IMEI / التسلسلي',
    'b2bDashboard.incorrectCode': 'الرمز غلط',
    'b2bDashboard.invoiceLabel': 'الفاتورة:',
    'b2bDashboard.invoiceType.combined': 'مجمّعة',
    'b2bDashboard.invoiceType.diag': 'تشخيص',
    'b2bDashboard.invoiceType.repair': 'تصليح',
    'b2bDashboard.invoices': 'الفواتير',
    'b2bDashboard.invoicesAppearWhenPriced': 'بتبيّن الفواتير أول ما R.E.Mobiles يحدّد السعر',
    'b2bDashboard.latePayment': 'تأخير بالدفع - {{days}} يوم',
    'b2bDashboard.lock': 'القفل',
    'b2bDashboard.lockCode': 'رمز القفل',
    'b2bDashboard.mostRecent': 'الأحدث',
    'b2bDashboard.nav.documents': 'عروض الأسعار / الفواتير',
    'b2bDashboard.nav.quoteRequest': 'طلب عرض سعر',
    'b2bDashboard.newQuoteRequest': 'طلب عرض سعر جديد',
    'b2bDashboard.newRequest': 'طلب جديد',
    'b2bDashboard.noInvoiceAvailable': 'ما في فاتورة متاحة',
    'b2bDashboard.noPhoto': 'ما في صورة',
    'b2bDashboard.noPosInvoice': 'ما في فاتورة شراء',
    'b2bDashboard.noQuoteRequest': 'ما في طلبات عروض أسعار',
    'b2bDashboard.noTravelQuote': 'ما في عروض أسعار للتنقّل',
    'b2bDashboard.nonFunctionalParts': 'قطع ما عم تشتغل',
    'b2bDashboard.noteSaveError': 'صار خطأ وقت حفظ الملاحظة',
    'b2bDashboard.notes': 'ملاحظات',
    'b2bDashboard.oldest': 'الأقدم',
    'b2bDashboard.optional': 'اختياري',
    'b2bDashboard.orderValidated': 'تم تأكيد أمر الشراء',
    'b2bDashboard.orderValidatedSuccess': 'تم تأكيد أمر الشراء!',
    'b2bDashboard.orderValidationCode': 'رمز تأكيد أمر الشراء',
    'b2bDashboard.paid': 'مدفوعة',
    'b2bDashboard.paidLabel': 'المدفوع',
    'b2bDashboard.partProvidedByStore': 'R.E.Mobiles رح تجيب القطعة',
    'b2bDashboard.parts.backCam': 'الكاميرا الخلفية',
    'b2bDashboard.parts.backGlass': 'الجام الخلفي',
    'b2bDashboard.parts.battery': 'البطارية',
    'b2bDashboard.parts.chargingPort': 'مدخل الشحن',
    'b2bDashboard.parts.earSpeaker': 'سماعة الأذن',
    'b2bDashboard.parts.fingerprint': 'البصمة',
    'b2bDashboard.parts.frontCam': 'الكاميرا الأمامية',
    'b2bDashboard.parts.homeButton': 'زر الهوم',
    'b2bDashboard.parts.lcd': 'الشاشة',
    'b2bDashboard.parts.microphone': 'المايك',
    'b2bDashboard.parts.powerButton': 'زر التشغيل',
    'b2bDashboard.parts.signal': 'الإشارة',
    'b2bDashboard.parts.speaker': 'مكبّر الصوت',
    'b2bDashboard.parts.volumeButton': 'زر الصوت',
    'b2bDashboard.parts.wifiBt': 'واي فاي/بلوتوث',
    'b2bDashboard.pattern': 'الشكل',
    'b2bDashboard.pay': 'ادفع',
    'b2bDashboard.payRemaining': 'ادفع الباقي ({{amount}})',
    'b2bDashboard.paymentCreateError': 'صار خطأ وقت إنشاء الدفعة',
    'b2bDashboard.paymentLinkUnavailable': 'رابط الدفع مش متاح. تواصل مع R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'صار خطأ وقت تنزيل الـPDF',
    'b2bDashboard.pdfInvoice': 'PDF الفاتورة',
    'b2bDashboard.pdfPurchaseOrder': 'PDF أمر الشراء',
    'b2bDashboard.pdfQuote': 'PDF عرض السعر',
    'b2bDashboard.penaltiesLine': 'غرامات: {{penalty}} + تعويض: {{indemnity}}',
    'b2bDashboard.photos': 'الصور',
    'b2bDashboard.pickupAddress': 'عنوان الاستلام',
    'b2bDashboard.pickupAddressPlaceholder': 'العنوان الكامل لاستلام الموبايل...',
    'b2bDashboard.pickupAddressRequired': 'رجاءً دخّل عنوان الاستلام',
    'b2bDashboard.pickupRequested': 'تم طلب الاستلام - رح نجي ناخد الجهاز',
    'b2bDashboard.posInvoices': 'فواتير الشراء (POS)',
    'b2bDashboard.price': 'السعر',
    'b2bDashboard.priceCol': 'السعر',
    'b2bDashboard.priceDiagnostic': 'سعر التشخيص',
    'b2bDashboard.pricePending': 'قيد الانتظار - رح يتحدّد من R.E.Mobiles',
    'b2bDashboard.priceRepair': 'سعر التصليح',
    'b2bDashboard.problem': 'المشكلة',
    'b2bDashboard.problemDescription': 'المشكلة / الوصف',
    'b2bDashboard.purchaseOrderLabel': 'أمر الشراء:',
    'b2bDashboard.quoteRequestTitle': 'طلب عرض سعر',
    'b2bDashboard.refusalReason': 'سبب الرفض:',
    'b2bDashboard.remaining': 'الباقي',
    'b2bDashboard.repairAcceptedByStaff': 'الفريق قبل التصليح',
    'b2bDashboard.repairRefusedByStaff': 'الفريق رفض التصليح',
    'b2bDashboard.repairTitle': 'تصليح {{ref}}',
    'b2bDashboard.requestDescription': 'وصف طلبك',
    'b2bDashboard.requestDescriptionPlaceholder': 'وصّف شو بدّك: نوع التصليح، الكمية، المشاكل، إلخ.',
    'b2bDashboard.requestStatus.inProgress': 'قيد المعالجة',
    'b2bDashboard.requestStatus.new': 'جديد',
    'b2bDashboard.requestStatus.processed': 'تمت المعالجة',
    'b2bDashboard.requestStatus.refused': 'مرفوض',
    'b2bDashboard.retentionInvoices': 'بتنحفظ الفواتير عسيرفراتنا لمدة 18 شهر.',
    'b2bDashboard.retentionQuotes': 'بتنحفظ عروض الأسعار عسيرفراتنا لمدة شهر واحد.',
    'b2bDashboard.saveNote': 'حفظ الملاحظة',
    'b2bDashboard.saving': 'عم يحفظ...',
    'b2bDashboard.searchPlaceholder': 'بحث...',
    'b2bDashboard.sendRequest': 'إرسال طلبي',
    'b2bDashboard.sending': 'عم يبعت...',
    'b2bDashboard.status.awaitingParts': 'بانتظار القطع',
    'b2bDashboard.status.awaitingPickup': 'بانتظار الأخذ',
    'b2bDashboard.status.awaitingReception': 'بانتظار الاستلام',
    'b2bDashboard.status.completed': 'خلص',
    'b2bDashboard.status.delivered': 'تم التسليم',
    'b2bDashboard.status.inProgress': 'قيد التنفيذ',
    'b2bDashboard.status.received': 'تم الاستلام',
    'b2bDashboard.status.refused': 'مرفوض',
    'b2bDashboard.statusCol': 'الحالة',
    'b2bDashboard.submitError': 'صار خطأ وقت الإرسال',
    'b2bDashboard.teamResponse': 'رد الفريق:',
    'b2bDashboard.titleOptional': 'العنوان (اختياري)',
    'b2bDashboard.titlePlaceholder': 'مثال: تصليح دفعة شاشات Samsung',
    'b2bDashboard.total': 'الإجمالي',
    'b2bDashboard.totalDue': 'الإجمالي المستحق: {{amount}}',
    'b2bDashboard.trackingBadge': 'التتبّع:',
    'b2bDashboard.trackingNumber': 'رقم التتبّع',
    'b2bDashboard.trackingPlaceholder': 'مثال: 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'رجاءً دخّل رقم التتبّع للإرسال بالبريد',
    'b2bDashboard.trackingShort': 'رقم التتبّع',
    'b2bDashboard.travelFee': 'رسوم التنقّل',
    'b2bDashboard.travelQuotes': 'عروض أسعار التنقّل',
    'b2bDashboard.uploadError': 'صار خطأ وقت الرفع',
    'b2bDashboard.uploading': 'عم يرفع...',
    'b2bDashboard.validate': 'تأكيد',
    'b2bDashboard.validationCodeConfirmed': 'تم تأكيد رمز التحقق',
    'client.mySpace': 'مساحتي',
    'client.invoiceDownloadError': 'صار خطأ وقت تنزيل الفاتورة',
    'client.invoiceViewError': 'صار خطأ وقت عرض الفاتورة',
    'client.invoicePrintError': 'صار خطأ وقت طباعة الفاتورة',
    'client.pinMustBe4': 'لازم يكون رمز PIN من 4 أرقام',
    'client.pinMismatch': 'رمزي PIN مش متطابقين',
    'client.pinChanged': 'تم تغيير رمز PIN بنجاح!',
    'client.pinChangeError': 'صار خطأ وقت تغيير رمز PIN',
    'client.describeRequest': 'منرجو تشرح طلبك',
    'client.error': 'خطأ',
    'client.enterValidationCode': 'منرجو تدخّل رمز التحقق',
    'client.codeValidated': 'تم التحقق من الرمز بنجاح!',
    'client.codeIncorrect': 'الرمز غلط',
    'client.sumupUrlUnavailable': 'خطأ: رابط الدفع عبر SumUp مش متاح',
    'client.sumupCreateError': 'صار خطأ وقت إنشاء عملية الدفع عبر SumUp',
    'client.fillRequired': 'منرجو تعبّي كل الحقول الإلزامية',
    'client.invalidEmail': 'عنوان الإيميل مش صحيح',
    'client.requestError': 'صار خطأ وقت الطلب',
    'client.trackingSaved': 'تم حفظ رقم التتبع!',
    'client.statusText.recu': 'انستلم الجهاز بالورشة',
    'client.statusText.enCours': 'التصليح عم يتم',
    'client.statusText.attentePieces': 'عم نستنى قطع الغيار',
    'client.statusText.termine': 'خلص التصليح - جاهز للاستلام',
    'client.statusText.livre': 'انستلم الجهاز',
    'client.statusText.demandeEnLigne': 'عم نستنى يوصل الجهاز',
    'client.statusText.nonReparable': 'الجهاز ما بينصلّح',
    'client.statusLabel.recu': 'مستلَم',
    'client.statusLabel.enCours': 'عم يتم',
    'client.statusLabel.attentePieces': 'عم نستنى القطع',
    'client.statusLabel.termine': 'خلص',
    'client.statusLabel.livre': 'انسلّم',
    'client.statusLabel.recupere': 'انستلم',
    'client.statusLabel.demandeEnLigne': 'طلب أونلاين',
    'client.statusLabel.nonReparable': 'ما بينصلّح',
    'client.created': 'انعمل',
    'client.technicianNotes': 'ملاحظات الفني',
    'client.noNotes': 'ما في ملاحظات لهلّق',
    'client.file': 'ملف',
    'client.files': 'ملفات',
    'client.navigation': 'التنقّل',
    'client.devisFactures': 'عروض الأسعار / الفواتير',
    'client.myAddresses': 'عناويني',
    'client.myAccount': 'حسابي',
    'client.needHelp': 'بدّك مساعدة؟',
    'client.helpHours': 'فريقنا بخدمتك من الإثنين للسبت من الساعة 9 الصبح للساعة 7 المسا.',
    'client.contactUs': 'تواصل معنا',
    'client.contactSupport': 'تواصل مع الدعم',
    'client.guideMe': 'أرشدني',
    'client.logout': 'تسجيل الخروج',
    'client.changePassword': 'تغيير كلمة السر',
    'client.addresses': 'العناوين',
    'client.requestRepair': 'اطلب تصليح',
    'client.showDelivered': 'فرجيني المُسلَّمة',
    'client.hideDelivered': 'خبّي المُسلَّمة',
    'client.noRepairsInProgress': 'ما في تصليحات عم تتم',
    'client.onlineRepairRequest': 'طلب تصليح أونلاين',
    'client.diagFeeFormPre': 'عبّي النموذج تحت. رسوم التشخيص يلي قيمتها',
    'client.diagFeeFormPost': 'لازم تندفع أونلاين.',
    'client.repairReason': 'سبب التصليح',
    'client.repairReasonPlaceholder': 'مثلًا: شاشة مكسورة، بطارية...',
    'client.fullName': 'الاسم الكامل',
    'client.fullNamePlaceholder': 'اسمك الكامل',
    'client.postalAddress': 'العنوان البريدي',
    'client.addressPlaceholder': 'عنوانك',
    'client.emailAddress': 'الإيميل',
    'client.emailPlaceholder': 'email@example.com',
    'client.describeIssue': 'اشرح العطل بالتفصيل',
    'client.describeIssuePlaceholder': 'خبّرنا كيف تعطّل الموبايل/التابلت وشو الأعراض يلي لاحظتها...',
    'client.devicePhotos': 'صور الجهاز',
    'client.addPhotos': 'ضيف صور',
    'client.cancel': 'إلغاء',
    'client.sending': 'عم ينبعت...',
    'client.sendRequest': 'ابعت الطلب',
    'client.requestSaved': 'انسجّل الطلب: {{ref}}',
    'client.redirecting': 'عم يعيد التوجيه...',
    'client.payDiagnosticSumup': 'ادفع {{amount}} عبر SumUp (تشخيص)',
    'client.diagFeePending': 'طلبك قيد الانتظار. لتبدأ التشخيص، منرجو تدفع رسوم قيمتها',
    'client.depositOrSend': 'سلّم جهازك بالمحل أو ابعتو بالبريد مع إشعار استلام:',
    'client.trackingPlaceholder': 'رقم التتبع البريدي',
    'client.save': 'حفظ',
    'client.postalDelayNotice': 'إذا بعتت بالبريد: المهلة بتصير 20 يوم قبل ما ينتهي الطلب (40 يوم قبل الحذف)',
    'client.close': 'سكّر',
    'client.progress': 'التقدّم',
    'client.deposits': 'الدفعات المقدمة',
    'client.rest': 'الباقي',
    'client.payWithSumup': 'ادفع {{amount}} عبر SumUp',
    'client.detailedTracking': 'تتبّع مفصّل',
    'client.chatRepair': 'محادثة التصليح {{ref}}',
    'client.contact': 'تواصل',
    'client.photosCount': 'الصور ({{count}})',
    'client.level': 'المستوى {{name}}',
    'client.tierOr': 'ذهبي',
    'client.tierArgent': 'فضّي',
    'client.tierBronze': 'برونزي',
    'client.totalPurchases': '{{count}} عملية شراء إجمالًا',
    'client.nextLevel': 'المستوى الجاي:',
    'client.purchasesToNext': 'باقي {{count}} عملية شراء',
    'client.rewardAvailable': 'في مكافأة متاحة!',
    'client.reward10Reached': 'مبروك، وصلت لـ {{count}} عمليات شراء',
    'client.rewardPosDesc': 'على مشترياتك الجاية بالمحل',
    'client.rewardRepairDesc': 'على تصليحك الجاي',
    'client.loyaltyPoints': 'نقاط الولاء',
    'client.purchasesUntilReward': 'باقي {{count}} عملية شراء للمكافأة',
    'client.rewardReached': 'وصلت للمكافأة!',
    'client.rewardsHistory': 'سجل المكافآت',
    'client.reward15Pos': '-15% بالمحل',
    'client.reward10Repair': '-10% تصليح',
    'client.referralProgram': 'برنامج الإحالة',
    'client.referralSubtitle': 'شارك رمزك واكسب نقاط إضافية',
    'client.yourReferralCode': 'رمز الإحالة تبعك',
    'client.copied': 'اننسخ!',
    'client.copy': 'نسخ',
    'client.referralShare1': 'شارك هالرمز مع أصحابك. لمّا يسجّلوا فيه، بتكسب',
    'client.referralBonusPoints': '+2 نقطة',
    'client.referralShare2': 'من نقاط الولاء!',
    'client.copyReferralLink': 'انسخ رابط التسجيل',
    'client.referrals': 'المُحالين',
    'client.bonusPoints': 'نقاط إضافية',
    'client.yourReferrals': 'المُحالين من عندك',
    'client.referralFallback': 'مُحال',
    'client.myDevis': 'عروض أسعاري',
    'client.newRequest': 'طلب جديد',
    'client.newDevisRequest': 'طلب عرض سعر جديد',
    'client.titleOptional': 'العنوان (اختياري)',
    'client.devisTitlePlaceholder': 'مثلًا: تصليح شاشة iPhone 15',
    'client.requestDescription': 'وصف طلبك',
    'client.devisDescPlaceholder': 'اشرح شو بدّك: نوع التصليح، المشكلة، إلخ.',
    'client.addressOptional': 'العنوان (اختياري، للزيارة)',
    'client.devisAddressPlaceholder': 'عنوانك إذا بدّك زيارة',
    'client.sendMyRequest': 'ابعت طلبي',
    'client.myDevisRequests': 'طلبات عروض الأسعار تبعي',
    'client.devisRequestTitle': 'طلب عرض سعر',
    'client.devisReqNouveau': 'جديد',
    'client.devisReqEnCours': 'عم يتم',
    'client.devisReqRefuse': 'مرفوض',
    'client.devisReqTraite': 'انعالج',
    'client.teamResponse': 'رد الفريق:',
    'client.refusalReason': 'سبب الرفض:',
    'client.clickNewRequest': 'دوس على «طلب جديد» لتعمل وحدة',
    'client.designation': 'البند',
    'client.price': 'السعر',
    'client.travelFees': 'رسوم التنقّل',
    'client.totalUpper': 'الإجمالي',
    'client.paid': 'مدفوع',
    'client.purchaseOrder': 'أمر الشراء',
    'client.invoice': 'الفاتورة',
    'client.latePayment': 'تأخير بالدفع - {{days}} يوم',
    'client.latePenaltyLabel': 'غرامات التأخير ({{rate}}% بالسنة)',
    'client.recoveryIndemnity': 'تعويض مقطوع للتحصيل',
    'client.totalWithPenalties': 'الإجمالي المستحق مع الغرامات',
    'client.validationCodeTitle': 'رمز التحقق لأمر الشراء',
    'client.validationCodeDesc': 'دخّل الرمز يلي وصلك عالإيميل لتأكّد طلبك.',
    'client.code6digits': 'رمز من 6 أرقام',
    'client.validate': 'تأكيد',
    'client.codeConfirmed': 'تأكّد رمز التحقق',
    'client.pdfDevis': 'PDF عرض السعر',
    'client.pdfPurchaseOrder': 'PDF أمر الشراء',
    'client.pdfInvoice': 'PDF الفاتورة',
    'client.payRest': 'ادفع الباقي ({{amount}})',
    'client.deposit50': 'دفعة مقدّمة 50%',
    'client.fullPayment': 'دفع كامل',
    'client.myInvoices': 'فواتيري',
    'client.mostRecent': 'الأحدث',
    'client.oldest': 'الأقدم',
    'client.noInvoices': 'ما في فواتير متاحة',
    'client.view': 'شوف',
    'client.print': 'طباعة',
    'client.seeLess': 'شوف أقل',
    'client.seeMoreInvoices': 'شوف أكتر ({{count}} فاتورة)',
    'client.invoiceRetention': 'الفواتير بتنحفظ على سيرفراتنا لمدة 18 شهر.',
    'client.devisRetention': 'عروض الأسعار بتنحفظ على سيرفراتنا لمدة شهر واحد.',
    'client.createCaricature': 'اعمل كاريكاتوري',
    'client.copyrightBy': 'حقوق النشر لـ',
    'client.notifications': 'الإشعارات',
    'client.markAllRead': 'علّم الكل كمقروء',
    'client.noNotifications': 'ما في إشعارات',
    'client.pinChangeTitle': 'تغيير رمز PIN',
    'client.pinChangeDesc': 'لأمانك، منرجو تختار رمز PIN جديد من 4 أرقام.',
    'client.newPin': 'رمز PIN الجديد',
    'client.confirmPin': 'تأكيد رمز PIN',
    'client.modifying': 'عم يتعدّل...',
    'client.changePin': 'غيّر رمز PIN تبعي',
    'client.proofSent': 'انبعت إثبات الدفع! الفريق رح يراجعو.',
    'client.sendError': 'صار خطأ وقت الإرسال',
    'client.orderStatusEnAttente': 'قيد الانتظار',
    'client.orderStatusPayee': 'مدفوعة',
    'client.orderStatusProofUploaded': 'انبعت الإثبات',
    'client.orderStatusConfirmee': 'مؤكَّدة',
    'client.orderStatusPreparee': 'جاهزة',
    'client.orderStatusExpediee': 'انشحنت',
    'client.orderStatusLivree': 'انسلّمت',
    'client.orderStatusAnnulee': 'ملغاة',
    'client.trackingNumber': 'رقم التتبع:',
    'client.trackingHint': 'استخدم هالرقم لتتبّع طردك',
    'client.stepCommande': 'الطلب',
    'client.proofSentLabel': 'انبعت إثبات الدفع',
    'client.sentOn': 'انبعتت بـ',
    'client.validatedByStaff': 'انتأكّد من الفريق',
    'client.payWithSumupPlain': 'ادفع عبر SumUp',
    'client.sendProof': 'ابعت إثبات الدفع (سكرين شوت)',
    'client.history': 'السجل',
    'client.chatOrder': 'محادثة الطلب {{ref}}',
    'client.homeLabel': 'البيت',
    'client.enterFullAddress': 'منرجو تدخّل عنوانك الكامل.',
    'client.saveError': 'صار خطأ وقت الحفظ',
    'client.addressLabelField': 'التسمية',
    'client.labelPlaceholder': 'البيت، المكتب...',
    'client.phone': 'التلفون',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'المستلِم',
    'client.recipientPlaceholder': 'اسم المستلِم',
    'client.deliveryAddress': 'عنوان التسليم',
    'client.addressInputPlaceholder': 'دخّل عنوانك الكامل',
    'client.freeAddressHint': 'إدخال حر: اختار اقتراح إذا طلع، وإلا اكتب عنوانك عادي.',
    'client.searching': 'عم يدوّر...',
    'client.addressValidated': 'انتأكّد العنوان',
    'client.saving': 'عم يحفظ...',
    'client.confirmDeleteAddress': 'بدّك تحذف هالعنوان؟',
    'client.manageAddressesSubtitle': 'دبّر عناوين التسليم تبعك',
    'client.addAddress': 'ضيف عنوان',
    'client.newAddress': 'عنوان جديد',
    'client.editAddress': 'عدّل العنوان',
    'client.default': 'افتراضي',
    'client.edit': 'عدّل',
    'client.delete': 'احذف',
    'client.setDefault': 'حطّو افتراضي',
    'client.selectAddress': 'منرجو تختار أو تضيف عنوان تسليم.',
    'client.orderSuccess': 'انعمل الطلب بنجاح!',
    'client.orderError': 'صار خطأ وقت الطلب',
    'client.ourAccessories': 'إكسسواراتنا',
    'client.expertSelection': 'تشكيلة مجرّبة من خبرائنا',
    'client.allCategories': 'كل الفئات',
    'client.cart': 'السلة',
    'client.noArticles': 'ما في منتجات متاحة',
    'client.inStock': 'متوفّر',
    'client.unavailable': 'مش متوفّر',
    'client.add': 'ضيف',
    'client.myCart': 'سلّتي',
    'client.articleSingular': 'منتج',
    'client.articlesPlural': 'منتجات',
    'client.cartEmpty': 'سلّتك فاضية',
    'client.manage': 'دبّر',
    'client.processing': 'عم يتعالج...',
    'client.payOnDelivery': 'الدفع عند التسليم',
    'publicShop.status.en_attente': 'قيد الانتظار',
    'publicShop.status.en_cours': 'عم نشتغل عليها',
    'publicShop.status.termine': 'خلصت',
    'publicShop.status.pret': 'جاهز',
    'publicShop.status.livre': 'تسلّم',
    'publicShop.status.annule': 'ملغي',
    'publicShop.repairNotFound': 'ما لقينا التصليح',
    'publicShop.shopNotFound': 'ما لقينا المحل',
    'publicShop.trackTitle': 'تتبّع تصليحي',
    'publicShop.trackSubtitle': 'دخّل الرقم التسلسلي أو كود التتبّع',
    'publicShop.trackPlaceholder': 'الرقم التسلسلي أو كود التتبّع...',
    'publicShop.trackButton': 'تتبّع',
    'publicShop.labelDateEntree': 'تاريخ الاستلام:',
    'publicShop.labelSortiePrevue': 'موعد التسليم المتوقّع:',
    'publicShop.labelProbleme': 'المشكلة:',
    'publicShop.labelRemarques': 'ملاحظات:',
    'publicShop.poweredBy': 'مشغّل من {{brand}}',
    'invoiceRequest.subtitle': 'طلب فاتورة',
    'invoiceRequest.search.title': 'دوّر على مشترياتك',
    'invoiceRequest.search.hint': 'حطّ المبلغ بالضبط والوقت التقريبي.',
    'invoiceRequest.search.amountLabel': 'المبلغ المدفوع (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'مثال: 25.00',
    'invoiceRequest.search.timeLabel': 'الوقت',
    'invoiceRequest.search.dateLabel': 'التاريخ',
    'invoiceRequest.search.loading': 'عم يدوّر…',
    'invoiceRequest.search.submit': 'بحث',
    'invoiceRequest.results.title': 'اختار مشترياتك',
    'invoiceRequest.results.paidLabel': 'المدفوع:',
    'invoiceRequest.itemsCount': '{{count}} غرض',
    'invoiceRequest.back': 'رجوع',
    'invoiceRequest.form.title': 'معلوماتك',
    'invoiceRequest.form.purchase': 'الشراء',
    'invoiceRequest.form.alreadyPaid': 'المدفوع من قبل',
    'invoiceRequest.form.payment': 'الدفع',
    'invoiceRequest.form.remaining': 'الباقي',
    'invoiceRequest.form.nameLabel': 'الاسم الكامل',
    'invoiceRequest.form.namePlaceholder': 'محمد أحمد',
    'invoiceRequest.form.emailLabel': 'البريد الإلكتروني',
    'invoiceRequest.form.emailPlaceholder': 'mohammed@example.com',
    'invoiceRequest.form.phoneLabel': 'رقم الموبايل',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'عم ينبعت…',
    'invoiceRequest.form.submit': 'إرسال الفاتورة',
    'invoiceRequest.pending.title': 'الطلب قيد الانتظار',
    'invoiceRequest.pending.desc': 'هالفاتورة انبعتت من قبل لعنوان تاني.',
    'invoiceRequest.pending.validationRequired': 'لازم موافقة',
    'invoiceRequest.pending.info': 'طلبك راح لفريقنا. رح توصلك الفاتورة على {{email}} بعد ما تتم الموافقة.',
    'invoiceRequest.newRequest': 'طلب جديد',
    'invoiceRequest.success.title': 'انبعتت الفاتورة!',
    'invoiceRequest.success.desc': 'انبعتت فاتورتك على {{email}}.',
    'invoiceRequest.success.accountCreated': 'تم إنشاء حساب الزبون!',
    'invoiceRequest.success.newAccountDesc': 'انبعتت بيانات الدخول على {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'عم ينبعت…',
    'invoiceRequest.success.resendCredentials': 'استلام بيانات الدخول عالإيميل',
    'invoiceRequest.success.credentialsSent': 'انبعتت بيانات الدخول على {{email}}',
    'invoiceRequest.success.trackRepairs': 'متابعة تصليحاتي',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'خطأ بالبحث',
    'invoiceRequest.errors.notFound': 'ما في ولا عملية بيع بهالمبلغ وهالوقت. تأكد من المعلومات.',
    'invoiceRequest.errors.send': 'صار خطأ وقت الإرسال',
    'invoiceRequest.errors.generic': 'خطأ',
    'storefront.notfound.title': 'الشركة مو موجودة',
    'storefront.notfound.desc': 'هالشركة مو موجودة أو ما عادت شغّالة.',
    'storefront.notfound.back': 'رجوع للصفحة الرئيسية',
    'storefront.tab.track': 'تابع تصليحي',
    'storefront.tab.login': 'مساحة الزبون',
    'storefront.track.title': 'متابعة التصليح',
    'storefront.track.subtitle': 'حطّ رقم المرجع تبعك لتتابع وين صار تصليحك',
    'storefront.track.format': 'شكل المرجع:',
    'storefront.track.submit': 'تابع',
    'storefront.track.not_found': 'التصليح مو موجود',
    'storefront.track.ref': 'المرجع',
    'storefront.track.device': 'الجهاز',
    'storefront.track.problem': 'المشكلة',
    'storefront.track.date_in': 'تاريخ الاستلام',
    'storefront.track.date_out': 'تاريخ التسليم المتوقّع',
    'storefront.status.waiting': 'عم ننتظر',
    'storefront.status.in_progress': 'عم نشتغل عليه',
    'storefront.status.done': 'خلص',
    'storefront.status.delivered': 'تسلّم',
    'storefront.status.cancelled': 'ملغي',
    'storefront.status.unknown': 'مو معروف',
    'storefront.login.title': 'دخول الزبون',
    'storefront.login.subtitle': 'فوت على مساحة الزبون تبعك عند {{name}}',
    'storefront.login.phone': 'الموبايل',
    'storefront.login.pin': 'رمز PIN',
    'storefront.login.error_fields': 'حطّ رقم موبايلك ورمز PIN (4 أو 6 أرقام)',
    'storefront.login.error_invalid': 'بيانات الدخول غلط',
    'storefront.login.loading': 'عم يسجّل الدخول...',
    'storefront.login.submit': 'سجّل دخول',
    'storefront.login.create_account': 'لسا ما عندك حساب؟ اعمل حساب',
    'storefront.register.title': 'اعمل حساب',
    'storefront.register.subtitle': 'سجّل عند {{name}}',
    'storefront.register.name': 'الاسم الكامل',
    'storefront.register.name_ph': 'محمد أحمد',
    'storefront.register.phone': 'الموبايل',
    'storefront.register.email': 'الإيميل (اختياري)',
    'storefront.register.email_ph': 'email@example.com',
    'storefront.register.pin': 'رمز PIN',
    'storefront.register.pin_confirm': 'أكّد رمز PIN',
    'storefront.register.error_required': 'الاسم والموبايل لازمين',
    'storefront.register.error_pin_short': 'لازم رمز PIN يكون على الأقل 4 أرقام',
    'storefront.register.error_pin_mismatch': 'رمزي PIN مو متطابقين',
    'storefront.register.error_generic': 'صار خطأ وقت إنشاء الحساب',
    'storefront.register.loading': 'عم ينعمل...',
    'storefront.register.submit': 'اعمل حسابي',
    'storefront.register.back_to_login': 'عندك حساب من قبل؟ سجّل دخول',
    'landing.svcScreenTitle': 'شاشة مكسورة',
    'landing.svcScreenDesc': 'تبديل شاشة آيفون وسامسونج وهواوي',
    'landing.svcBatteryTitle': 'البطارية',
    'landing.svcBatteryDesc': 'تبديل البطارية لكل الماركات',
    'landing.svcConnectorTitle': 'الموصل',
    'landing.svcConnectorDesc': 'موصل الشحن ومدخل الصوت',
    'landing.svcCameraTitle': 'الكاميرا',
    'landing.svcCameraDesc': 'الكاميرا الأمامية والخلفية',
    'landing.svcOxidationTitle': 'إزالة الأكسدة',
    'landing.svcOxidationDesc': 'تلفون وقع بالمي',
    'landing.svcDiagTitle': 'التشخيص',
    'landing.svcDiagDesc': 'من 35 لـ 80 € حسب الجهاز · تقدير مجاني',
    'landing.tip1': '**مرحبا!** فيني تابع تصليحك أو عطيك تقدير.',
    'landing.tip2': '**ضمان 6 أشهر** على كل تصليحاتنا والقطع واليد العاملة.',
    'landing.tip3': '**التشخيص** من 35 لـ 80 € حسب الجهاز، منقلّك ياه قبل ما نبلّش.',
    'landing.tip4': 'وقع بالمي؟ **طفّيه** وتعا بسرعة: منشيل الأكسدة بالورشة.',
    'landing.tip5': 'تابع تصليحك مباشرة برقمك المرجعي **REM0001**.',
    'landing.tip6': '**لحام دقيق** واسترجاع البيانات، حتى لو الجهاز ما عاد يشتغل.',
    'landing.tip7': 'فاتح **الإثنين–الجمعة 9ص–7م** و**السبت 9ص–2م**، التسليم بلا موعد.',
    'landing.tip8': '**تقدير مجاني** أونلاين، منبعتلك ياه عالإيميل بعد التأكيد.',
    'landing.tip9': 'للمحترفين: **مساحة الشركات** مخصصة (بوابة B2B).',
    'landing.tip10': 'آيفون وسامسونج وهواوي وشاومي والتابلت و**أجهزة الألعاب**: منصلّح كل شي.',
    'landing.tipFromPrice': 'من {{price}} — السعر منأكّدو بالمحل.',
    'landing.guideMe': 'دلّني',
    'landing.flashUntil': 'لحد {{date}}',
    'landing.cadbotTitle': 'CADBOT، مساعدك',
    'landing.cadbotDesc': 'متابعة التصليح، تقدير عروض الأسعار، أوقات الدوام — بيجاوبك مباشرة عالموقع. السعر النهائي دايماً منأكّدو بالمحل.',
    'landing.servicesTitle': 'خدمات التصليح عنا',
    'landing.servicesDesc': 'تصليح سريع للموبايلات والتابلت بكايين، غويانا الفرنسية',
    'landing.seeAllPrices': 'شوف كل أسعارنا',
    'landing.readBlog': 'اقرأ مدوّنتنا',
    'landing.diagTitle': 'التشخيص بالمحل',
    'landing.diagDesc': 'من 35 لـ 80 € حسب الجهاز. منقلّك السعر قبل ما نبلّش. التقدير أونلاين بيضل مجاني.',
    'landing.tierFrom': 'من',
    'landing.tierUpTo': 'لحد',
    'landing.tierEntryTitle': 'الفئة الاقتصادية والمتوسطة',
    'landing.tierEntryDesc': 'عطل بسيط ومعروف',
    'landing.tierRecentTitle': 'الموبايلات الحديثة',
    'landing.tierRecentDesc': 'كم عارض لازم نفحصهن',
    'landing.tierComplexTitle': 'الحالات المعقّدة',
    'landing.tierComplexDesc': 'أضرار المي، اللحام الدقيق، أجهزة الألعاب، التابلت',
    'landing.enlarge': 'تكبير',
    'landing.storePhotoAlt': 'محلنا Resurrection Mobile بكايين',
    'landing.storeTag': 'محلنا · كايين',
    'landing.enlargedPhoto': 'صورة مكبَّرة',
    'landing.close': 'سكّر',
    'landing.storePhotoAltSimple': 'محل Resurrection Mobile',
    'landing.freeQuote': 'تقدير مجاني',
    'privacy.title': 'سياسة الخصوصية',
    'privacy.last_updated': 'آخر تحديث: 19 آذار 2026',
    'privacy.intro.part1': 'توضح سياسة الخصوصية هي كيفية قيام ',
    'privacy.intro.part2': ' (« نحنا »، « تبعنا ») بجمع البيانات الشخصية للمستخدمين (« إنت »، « تبعك ») واستخدامها وحفظها وحمايتها حسب ',
    'privacy.intro.rgpd': 'اللائحة العامة لحماية البيانات (RGPD — الاتحاد الأوروبي 2016/679)',
    'privacy.intro.part3': ' المعمول فيه بفرنسا وغيانا الفرنسية.',
    'privacy.s1.title': 'المسؤول عن المعالجة',
    'privacy.s1.company_label': 'الشركة',
    'privacy.s1.status_label': 'الشكل القانوني',
    'privacy.s1.controller_note': 'المسؤول عن المعالجة هو الشخص أو الجهة اللي بتحدد أهداف ووسائل معالجة بياناتك الشخصية.',
    'privacy.s2.title': 'البيانات الشخصية يلي منجمعها',
    'privacy.s2.sub1_title': '2.1 بيانات التعريف',
    'privacy.s2.sub1_b1': 'الاسم والكنية',
    'privacy.s2.sub1_b2': 'العنوان البريدي',
    'privacy.s2.sub1_b3': 'رقم الموبايل',
    'privacy.s2.sub1_b4': 'عنوان الإيميل',
    'privacy.s2.sub1_b5': 'اسم الشركة (إذا كان الزبون مهني)',
    'privacy.s2.sub2_title': '2.2 البيانات المتعلقة بالخدمات',
    'privacy.s2.sub2_b1': 'معلومات عن الأجهزة يلي بتسلمونا ياها (الماركة، الموديل، IMEI، الرقم التسلسلي)',
    'privacy.s2.sub2_b2': 'سجل التصليحات',
    'privacy.s2.sub2_b3': 'الطلبات وعروض الأسعار والفواتير',
    'privacy.s2.sub2_b4': 'التواقيع الإلكترونية',
    'privacy.s2.sub3_title': '2.3 بيانات الدفع',
    'privacy.s2.sub3_b1': 'معلومات المعاملة',
    'privacy.s2.sub3_b2': 'وسيلة الدفع المستخدمة',
    'privacy.s2.payment_important_label': 'مهم:',
    'privacy.s2.payment_important_text': 'نحنا ما منخزّن أبداً بياناتك البنكية الكاملة. الدفعات بتتعالج عن طريق مزوّدين آمنين (Stripe).',
    'privacy.s2.sub4_title': '2.4 البيانات التقنية',
    'privacy.s2.sub4_b1': 'عنوان IP',
    'privacy.s2.sub4_b2': 'بيانات الاتصال',
    'privacy.s2.sub4_b3': 'ملفات تعريف الارتباط وأدوات التتبع',
    'privacy.s2.sub4_b4': 'بيانات التصفح',
    'privacy.s3.title': 'أغراض المعالجة',
    'privacy.s3.b1': 'تقديم خدمات التصليح والبيع تبعنا',
    'privacy.s3.b2': 'إدارة الطلبات وعروض الأسعار والفوترة',
    'privacy.s3.b3': 'تأمين متابعة الزبائن وخدمة ما بعد البيع',
    'privacy.s3.b4': 'التواصل معك (رسائل SMS، الإيميل، الهاتف)',
    'privacy.s3.b5': 'الالتزام بواجباتنا القانونية والمحاسبية',
    'privacy.s3.b6': 'تحسين خدماتنا والأمان',
    'privacy.s3.b7': 'منع الاحتيال',
    'privacy.s4.title': 'الأساس القانوني للمعالجة',
    'privacy.s4.intro': 'حسب اللائحة العامة لحماية البيانات، عمليات المعالجة بتستند لـ:',
    'privacy.s4.i1': 'تنفيذ عقد',
    'privacy.s4.i2': 'الالتزام بالواجبات القانونية',
    'privacy.s4.i3': 'موافقتك (متل: التسويق)',
    'privacy.s4.i4': 'مصلحتنا المشروعة (الأمان، التحسين)',
    'privacy.s5.title': 'الجهات يلي بتستقبل البيانات',
    'privacy.s5.b1': 'موظفينا المخوّلين',
    'privacy.s5.b2': 'مزوّدي الخدمات التقنية تبعنا (الاستضافة، الدفع، رسائل SMS، الإيميل)',
    'privacy.s5.b3': 'السلطات الإدارية أو القضائية إذا القانون طلب هيك',
    'privacy.s5.no_sale': 'ما منبيع أي بيانات شخصية لأطراف تالتة.',
    'privacy.s6.title': 'نقل البيانات خارج الاتحاد الأوروبي',
    'privacy.s6.text': 'إذا في بعض المزوّدين موجودين خارج الاتحاد الأوروبي، منتأكد إنهم بيوفّروا مستوى حماية مناسب بيتوافق مع اللائحة العامة لحماية البيانات (البنود التعاقدية النموذجية، قرارات الكفاية، إلخ).',
    'privacy.s7.title': 'مدة الاحتفاظ بالبيانات',
    'privacy.s7.r1_label': 'بيانات الزبائن',
    'privacy.s7.r1_value': '5 سنين بعد آخر علاقة تجارية',
    'privacy.s7.r2_label': 'بيانات الفوترة',
    'privacy.s7.r2_value': '10 سنين (التزام قانوني)',
    'privacy.s7.r3_label': 'بيانات التسويق',
    'privacy.s7.r3_value': 'لحتى يتم سحب الموافقة',
    'privacy.s7.r4_label': 'ملفات تعريف الارتباط',
    'privacy.s7.r4_value': '13 شهر كحد أقصى',
    'privacy.s8.title': 'أمن البيانات',
    'privacy.s8.intro': 'منطبّق تدابير تقنية وتنظيمية مناسبة:',
    'privacy.s8.b1': 'وصول محدود للبيانات',
    'privacy.s8.b2': 'استضافة آمنة',
    'privacy.s8.b3': 'التشفير وقت ما يلزم',
    'privacy.s8.b4': 'نسخ احتياطية منتظمة',
    'privacy.s8.b5': 'الحماية من الوصول غير المصرّح فيه',
    'privacy.s9.title': 'حقوقك',
    'privacy.s9.intro': 'حسب اللائحة العامة لحماية البيانات، إلك الحقوق التالية:',
    'privacy.s9.r1': 'الحق في الوصول',
    'privacy.s9.r2': 'الحق في التصحيح',
    'privacy.s9.r3': 'الحق في المحو (« الحق في النسيان »)',
    'privacy.s9.r4': 'الحق في تقييد المعالجة',
    'privacy.s9.r5': 'الحق في الاعتراض',
    'privacy.s9.r6': 'الحق في نقل البيانات',
    'privacy.s9.r7': 'الحق في سحب موافقتك',
    'privacy.s9.exercise': 'لممارسة حقوقك، تواصل معنا عبر:',
    'privacy.s9.complaint_before': 'فيك كمان تقدّم شكوى لـ ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'ملفات تعريف الارتباط',
    'privacy.s10.intro': 'ممكن موقعنا يستخدم ملفات تعريف الارتباط لـ:',
    'privacy.s10.b1': 'تأمين عمل الموقع',
    'privacy.s10.b2': 'قياس عدد الزوار',
    'privacy.s10.b3': 'تحسين تجربة المستخدم',
    'privacy.s10.manage': 'فيك تدير تفضيلاتك عن طريق متصفحك أو شريط ملفات تعريف الارتباط تبعنا.',
    'privacy.s11.title': 'بيانات القاصرين',
    'privacy.s11.text': 'خدماتنا مو مخصصة للقاصرين بدون إذن الأهل. إذا انجمعت بيانات قاصر بالغلط، رجاءً تواصل معنا لحتى ننحذفها.',
    'privacy.s12.title': 'تعديلات السياسة',
    'privacy.s12.text': 'فينا نعدّل هالسياسة بأي وقت لتعكس التطورات القانونية أو التقنية. النسخة المعمول فيها هي يلي منشورة على موقعنا.',
    'privacy.s13.title': 'التواصل',
    'privacy.s13.intro': 'لأي سؤال بخص هالسياسة أو بياناتك الشخصية:',
    'privacy.footer': 'باستخدامك لخدماتنا، إنت بتقرّ إنك اطّلعت على سياسة الخصوصية هي.',
    'track.title': 'تتبّع تصليحي',
    'track.label_ref': 'الرقم المرجعي',
    'track.label_device': 'الجهاز',
    'track.label_received': 'تاريخ الاستلام',
    'track.label_expected': 'موعد التسليم المتوقّع',
    'track.label_completed': 'تاريخ الانتهاء',
    'track.label_amount': 'المبلغ',
    'track.status_pending': 'قيد الانتظار',
    'track.see_full': 'عرض كل التفاصيل',
    'track.input_placeholder': 'أدخل رقمك المرجعي (مثال: REM0001)',
    'track.btn_track': 'تتبّع',
    'track.scan_qr': 'امسح رمز الـ QR الموجود على إيصالك',
    'track.err_invalid_ref': 'الرقم المرجعي غير صحيح. الصيغة المطلوبة: REM0001',
    'track.err_not_found': 'لم نعثر على التصليح',
    'chatWidget.statusStaffOnline': 'الفريق متواجد',
    'chatWidget.statusAiActive': 'الذكاء الاصطناعي شغّال — رد تلقائي',
    'chatWidget.statusOffline': 'مو متصل — اترك رسالة',
    'chatWidget.launcherLabel': 'دردشة ومساعدة',
    'chatWidget.tabStaff': 'دردشة الدعم',
    'chatWidget.tabAi': 'مساعدة الذكاء الاصطناعي',
    'chatWidget.newMessage': 'رسالة جديدة',
    'chatWidget.loading': 'عم يحمّل...',
    'chatWidget.noConversations': 'ما في محادثات',
    'chatWidget.emptyConvoHint': 'اضغط على «{{action}}» حتى تتواصل معنا',
    'chatWidget.conversationFallback': 'محادثة',
    'chatWidget.autoReplyTitle': 'وضع الرد التلقائي بالذكاء الاصطناعي شغّال',
    'chatWidget.autoReplyDesc': 'الفريق مو متصل. الذكاء الاصطناعي عم يرد بهالوقت.',
    'chatWidget.staffEmptyTitle': 'ابعت رسالة للفريق',
    'chatWidget.staffEmptyDesc': 'منردّ عليك بأسرع وقت',
    'chatWidget.aiAssistant': 'المساعد الذكي',
    'chatWidget.badgeAuto': 'تلقائي',
    'chatWidget.badgeQuoteIndicative': 'عرض سعر تقريبي',
    'chatWidget.badgeQuotePending': 'عرض السعر عم نجهّزو',
    'chatWidget.supportFallback': 'الدعم',
    'chatWidget.sending': 'عم ينبعت...',
    'chatWidget.staffInputPlaceholder': 'رسالتك...',
    'chatWidget.interactiveGuides': 'أدلة تفاعلية',
    'chatWidget.stepsCount': '{{count}} خطوات',
    'chatWidget.faqTitle': 'الأسئلة الشائعة',
    'chatWidget.back': 'رجوع',
    'chatWidget.stepProgress': 'الخطوة {{current}} / {{total}}',
    'chatWidget.previous': 'السابق',
    'chatWidget.next': 'التالي',
    'chatWidget.finish': 'إنهاء',
    'chatWidget.aiInputPlaceholder': 'اسأل سؤالك...',
    'chatWidget.aiError': 'آسفين، صار في خطأ.',
    'chatWidget.me': 'أنا',
    'chatWidget.newConversationSubject': 'محادثة جديدة',
    'hours.title': 'أوقات الدوام',
    'hours.rows.weekdays.label': 'الإثنين - الجمعة',
    'hours.rows.weekdays.hours': '9:00 - 19:00',
    'hours.rows.saturday.label': 'السبت',
    'hours.rows.saturday.hours': '9:00 - 14:00',
    'hours.rows.sunday.label': 'الأحد',
    'hours.closed': 'مسكّر',
    'hours.unit.hour': 'س',
    'hours.unit.minute': 'د',
    'hours.unit.second': 'ث',
    'hours.clock': 'هلّق الساعة {{time}} بكايين',
    'hours.ring.dayProgress': 'من اليوم',
    'hours.ring.untilReopen': 'لحتى ما نفتح من جديد',
    'hours.state.openNow': 'مفتوح هلّق',
    'hours.state.closingSoon': 'رح يسكّر قريبًا',
    'hours.state.closed': 'مسكّر',
    'hours.count.untilClose': 'لحتى ما نسكّر (الساعة {{hour}})',
    'hours.count.untilOpen': 'لحتى ما نفتح',
    'hours.sub.openSince': 'مفتوح من {{duration}}',
    'hours.sub.nextOpen': 'أول فتحة: {{when}} الساعة {{hour}}',
    'hours.when.today': 'اليوم',
    'hours.when.tomorrow': 'بكرا',
    'hours.mood.closingSoon': '⏳ آخر شي — لسا مستنيينك شوي!',
    'hours.mood.justOpened': '☕ لسا فتحنا — مرق عنا!',
    'hours.mood.open': '🟢 نحنا فاتحين، مرق عنا وقت ما بدك!',
    'hours.mood.opensSoon': '🚪 رح نفتح بأقل من ساعة — قربنا نرفع البريمة!',
    'hours.mood.sundayRest': '🌴 الأحد عطلتنا — منشوفك الإثنين الساعة 9!',
    'hours.mood.morning': '🌅 صباح الخير! منفتح الساعة {{hour}}، جهّز أجهزتك.',
    'hours.mood.evening': '🌙 مسكّرين هالليلة — منشوفك قريب!',
    'hours.dayName.0': 'الأحد',
    'hours.dayName.1': 'الإثنين',
    'hours.dayName.2': 'الثلاثا',
    'hours.dayName.3': 'الأربعا',
    'hours.dayName.4': 'الخميس',
    'hours.dayName.5': 'الجمعة',
    'hours.dayName.6': 'السبت',
    'cadbot.welcome': 'مرحبا، أنا **CADBOT**، مساعد Resurrection Mobile. اكتب رقمك المرجعي **REM0001** لتتابع تصليحك، أو وصّف العطل لنعطيك تقدير سعر.',
    'cadbot.chip.status': 'وين صار تصليحي؟',
    'cadbot.chip.screen': 'شاشة iPhone 11 مكسورة، قدّيش بتكلّف؟',
    'cadbot.chip.battery': 'بطارية Galaxy S21، قدّيش سعرها؟',
    'cadbot.chip.diagnostic': 'قدّيش بيكلّف الفحص؟',
    'cadbot.chip.hours': 'أوقات الدوام والعنوان؟',
    'cadbot.note': 'التقديرات تقريبية ومنأكّدها دايمًا بالمحل. عرض السعر المفصّل منبعتو عبر الإيميل بعد ما يوافق عليه فريقنا.',
    'cadbot.status.online': 'أونلاين',
    'cadbot.resume.label': 'كمّل محادثتي',
    'cadbot.resume.title': 'تطلّع عالمحادثة يلي بلّشت بهالتاب',
    'cadbot.reset.label': 'محادثة جديدة',
    'cadbot.reset.title': 'امسح هالمحادثة وابدا من جديد',
    'cadbot.input.label': 'رسالتك',
    'cadbot.input.placeholderIdentity': 'اسمك أو تلفونك أو إيميلك…',
    'cadbot.input.placeholderDefault': 'REM0001، شاشة iPhone 13، بطارية…',
    'cadbot.send.aria': 'إرسال',
    'cadbot.local.greeting': 'مرحبا! أنا **CADBOT**. فيني تابع تصليحك (الرقم المرجعي REM0001)، أو قدّرلك عرض سعر، أو خبّرك بأوقات دوامنا.',
    'cadbot.local.diagnostic': 'الفحص بالمحل بيتراوح بين {{min}} و{{max}} حسب الجهاز وصعوبة الشغل. منقلّك السعر قبل ما نبلّش. أما عرض السعر أونلاين فهو مجاني.',
    'cadbot.local.water': 'طفّيه وما تشحنو، وجيبو عالمحل بأسرع وقت. إزالة الأكسدة منحدّد سعرها بعرض بعد الفحص.',
    'cadbot.local.hoursLine': 'نحنا بـ **{{address}}**. أوقات الدوام: {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**مسكّر** — {{sub}}.',
    'cadbot.local.closedLower': 'مسكّر',
    'cadbot.local.warranty': 'كل تصليحاتنا مكفولة **6 أشهر**، القطع واليد العاملة.',
    'cadbot.local.accounts': 'روابط الدخول فوق مباشرة: **مساحة العميل** (متابعة تصليحاتك)، **مساحة الشركات** (بوابة B2B) و**مساحة الفريق**.',
    'cadbot.local.trackAsk': 'اكتب رقمك المرجعي بصيغة **REM0001** (موجود على إيصال التسليم) ولاقلّك وين صار.',
    'cadbot.local.quoteFollowup': 'عرض سعرك منبعتو عبر الإيميل أول ما يوافق عليه فريقنا (تفقّد مجلّد الـ spam). إذا ما وصلك خبر خلال 24 ساعة، راسلنا عواتساب عالرقم **{{phone}}**.',
    'cadbot.local.contact': 'فيك تتواصل معنا عالرقم **{{phone}}** (اتصال وواتساب).',
    'cadbot.track.here': 'هاي حالة متابعة **{{ref}}**:',
    'cadbot.track.notFound': 'ما عم لاقي التصليح **{{ref}}**. تأكّد من الرقم المرجعي على إيصال التسليم.',
    'cadbot.track.unavailable': 'خدمة المتابعة مش شغّالة هلّق، جرّب كمان شوي.',
    'cadbot.server.ackDefault': 'شكرًا، في فني بيردّ عليك قريب كتير.',
    'cadbot.error.rateLimit': 'طلبات كتير مرة وحدة — استنى {{wait}} وبعدين جرّب كمان مرة.',
    'cadbot.error.waitMinutes': '{{n}} دقيقة',
    'cadbot.error.waitFallback': 'دقيقة',
    'cadbot.error.server': 'ما عم قدر أوصل للسيرفر. راسلنا عواتساب عالرقم **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'الرئيسية',
    'tarifs.searchPlaceholder': 'دوّر على موديل أو نوع تصليح…',
    'tarifs.loading': 'عم نحمّل الأسعار…',
    'tarifs.updateTitle': 'عم نحدّث الأسعار',
    'tarifs.updateDesc': 'أسعارنا عم تتحدّث هلق. تواصل معنا لعرض سعر مجاني وعلى قياسك.',
    'tarifs.call': 'اتصل',
    'tarifs.callPrefix': 'اتصل: ',
    'tarifs.callNow': 'اتصل هلق',
    'tarifs.noResult': 'ما في نتائج',
    'tarifs.soon': 'الأسعار قريبًا',
    'tarifs.tryOther': 'جرّب كلمات تانية',
    'tarifs.contactFree': 'تواصل معنا لعرض سعر مجاني',
    'tarifs.repairBrand': 'تصليح {{brand}}',
    'tarifs.tariffsCount': '{{count}} سعر متوفّر',
    'tarifs.colModel': 'الموديل',
    'tarifs.colRepair': 'التصليح',
    'tarifs.colPrice': 'السعر',
    'tarifs.colDelay': 'المدة',
    'tarifs.allModels': 'كل الموديلات',
    'tarifs.whatsapp': 'واتساب',
    'tarifs.portal': 'بوابة الزبون',
    'tarifs.faqTitle': 'الأسئلة الشائعة',
    'tarifs.titleFallback': 'أسعار تصليح الموبايلات',
    'tarifs.subtitleFallback': 'شوف أسعار التصليح عنا لأجهزة iPhone وSamsung وHuawei وغيرها. تصليح سريع ومضمون بكايين، غيانا الفرنسية.',
    'tarifs.ctaTitleFallback': 'بدّك عرض سعر مخصّص؟',
    'tarifs.ctaDescFallback': 'كل تصليح إلو وضعو. تواصل معنا لتشخيص مجاني وعرض سعر مضبوط على قياس حالتك.',
    'nav.activityHub': 'مركز النشاط', 'nav.salesHistory': 'سجل المبيعات', 'nav.equipeMagasins': 'الفريق والمتاجر', 'nav.usersLegacy': 'المستخدمون (قديم)', // [i18n-P0 2026-09-12: a relire]
    _name: 'سوري',
    _flag: '🇸🇾',
    _rtl: true,
    'nav.dashboard': 'لوحة التحكم', 'nav.pos': 'نقطة البيع', 'nav.calcul': 'حساب السعر', 'nav.devis': 'عروض / فواتير', 'nav.devisDeplacement': 'عروض التنقل', 'nav.commandes': 'طلبات', 'nav.addDevice': 'إضافة جهاز', 'nav.reparations': 'تصليحات', 'nav.clients': 'زبائن', 'nav.stock': 'مخزون', 'nav.addStock': 'إضافة مخزون', 'nav.etiquettes': 'ملصقات', 'nav.users': 'مستخدمين', 'nav.logout': 'تسجيل خروج', 'nav.quit': 'خروج', 'nav.admin': 'إدارة', 'nav.navigation': 'تنقل',
    'common.save': 'حفظ', 'common.cancel': 'إلغاء', 'common.delete': 'حذف', 'common.edit': 'تعديل', 'common.search': 'بحث', 'common.add': 'إضافة', 'common.close': 'إغلاق', 'common.confirm': 'تأكيد', 'common.loading': 'جاري التحميل...', 'common.noData': 'ما في بيانات', 'common.status': 'الحالة', 'common.total': 'المجموع', 'common.yes': 'أي', 'common.no': 'لأ', 'common.validate': 'تأكيد', 'common.client': 'زبون', 'common.phone': 'تلفون', 'common.email': 'إيميل', 'common.price': 'سعر', 'common.send': 'إرسال', 'common.paid': 'مدفوع', 'common.pending': 'بالانتظار', 'common.accepted': 'مقبول', 'common.refused': 'مرفوض',
    'layout.panel': 'لوحة الإدارة',
    'pos.title': 'نقطة البيع', 'pos.emptyCart': 'السلة فاضية', 'pos.cash': 'كاش', 'pos.card': 'بطاقة', 'pos.confirmPayment': 'تأكيد الدفع',
    'devis.title': 'عروض وفواتير',
    'devDep.title': 'عروض التنقل', 'devDep.new': 'عرض جديد', 'devDep.travelFee': 'مصاريف التنقل', 'devDep.pending': 'بالانتظار', 'devDep.accepted': 'مقبول', 'devDep.refused': 'مرفوض', 'devDep.fullyPaid': 'مدفوع', 'devDep.noDevis': 'ما في عروض',
    'rep.title': 'تصليحات', 'cmd.title': 'طلبات', 'clients.title': 'زبائن', 'stock.title': 'إدارة المخزون', 'dash.title': 'لوحة التحكم',
    'login.title': 'تسجيل دخول', 'login.submit': 'دخول', 'lang.select': 'اللغة',
    'client.space': 'منطقة الزبون', 'client.devis': 'عروض', 'client.send': 'إرسال', 'client.noDevis': 'ما في عروض', 'client.pay': 'دفع',
      // Translated keys
    'adminB2b.actions': 'الإجراءات', 'adminB2b.address': 'العنوان', 'adminB2b.all': 'الكل', 'adminB2b.awaitingPayment': 'في انتظار الدفع', 'adminB2b.b2bRepairs': 'إصلاحات B2B', 'adminB2b.backGlassBroken': 'زجاج خلفي مكسور', 'adminB2b.bcValidated': 'أمر شراء مؤكد', 'adminB2b.brandModel': 'العلامة / الموديل', 'adminB2b.changeStatus': 'تغيير الحالة', 'adminB2b.clearFilter': 'مسح', 'adminB2b.clientPart': 'قطعة العميل', 'adminB2b.combined': 'مجمع', 'adminB2b.companies': 'الشركات', 'adminB2b.company': 'الشركة', 'adminB2b.confirmReception': 'تأكيد الاستلام', 'adminB2b.confirmRefuse': 'رفض هذه الشركة؟', 'adminB2b.confirmSuspend': 'تعليق هذه الشركة؟', 'adminB2b.confirmValidate': 'تأكيد هذه الشركة؟', 'adminB2b.delivery': 'التسليم', 'adminB2b.diagPrice': 'سعر التشخيص', 'adminB2b.diagnostic': 'تشخيص', 'adminB2b.downloadKbis': 'تحميل KBIS', 'adminB2b.existingInvoices': 'الفواتير الموجودة', 'adminB2b.filter': 'تصفية', 'adminB2b.filterCompany': 'الشركة', 'adminB2b.filterDateEnd': 'تاريخ النهاية', 'adminB2b.filterDateStart': 'تاريخ البداية', 'adminB2b.finalize': 'إنهاء الفوترة', 'adminB2b.home': 'الرئيسية', 'adminB2b.inStore': 'في المتجر', 'adminB2b.invoice': 'فاتورة', 'adminB2b.invoiceCancelled': 'فاتورة ملغاة', 'adminB2b.locked': 'مقفل (مدفوع)', 'adminB2b.markPaid': 'مدفوع', 'adminB2b.monthPrompt': 'الشهر (1-12)؟ اتركه فارغاً للشهر السابق:', 'adminB2b.monthlyRecap': 'ملخص شهري', 'adminB2b.noCompany': 'لم يتم العثور على شركات', 'adminB2b.noPayments': 'لا مدفوعات B2B', 'adminB2b.noRepairs': 'لا إصلاحات B2B', 'adminB2b.paidMethod': 'مدفوع', 'adminB2b.payHistoryTitle': 'سجل مدفوعات B2B', 'adminB2b.paymentHistory': 'سجل المدفوعات', 'adminB2b.paymentMethodPrompt': 'طريقة الدفع؟', 'adminB2b.payments': 'مدفوعات', 'adminB2b.pending': 'قيد الانتظار', 'adminB2b.pendingReception': 'في انتظار الاستلام', 'adminB2b.phone': 'الهاتف', 'adminB2b.pickup': 'استلام', 'adminB2b.postal': 'بريدي', 'adminB2b.price': 'السعر', 'adminB2b.problem': 'المشكلة', 'adminB2b.recapError': 'خطأ', 'adminB2b.recapSent': 'تم الإرسال', 'adminB2b.recapSkipped': 'لا إصلاحات', 'adminB2b.recapTitle': 'نتائج الملخص الشهري', 'adminB2b.ref': 'المرجع', 'adminB2b.refuse': 'رفض', 'adminB2b.refused': 'مرفوضة', 'adminB2b.registeredOn': 'مسجل في', 'adminB2b.repair': 'إصلاح', 'adminB2b.repairPrice': 'سعر الإصلاح', 'adminB2b.search': 'بحث...', 'adminB2b.sending': 'جاري الإرسال...', 'adminB2b.setPrice': 'تحديد السعر', 'adminB2b.siret': 'SIRET', 'adminB2b.status': 'الحالة', 'adminB2b.suspend': 'تعليق', 'adminB2b.suspended': 'معلقة', 'adminB2b.title': 'إدارة B2B', 'adminB2b.total': 'الإجمالي', 'adminB2b.totalCollected': 'إجمالي المحصّل', 'adminB2b.validate': 'تأكيد', 'adminB2b.validated': 'مؤكدة', 'adminB2b.validatedBy': 'مؤكد بواسطة', 'adminB2b.yearPrompt': 'السنة؟',
    'adminDb.accessDenied': 'الوصول مرفوض', 'adminDb.adminOnly': 'للمسؤولين فقط', 'adminDb.clients': 'العملاء', 'adminDb.exportBtn': 'تصدير كامل', 'adminDb.exportConfirm': 'تصدير قاعدة البيانات الكاملة؟', 'adminDb.exportDesc': 'تصدير جميع البيانات كملف JSON.', 'adminDb.exportError': 'خطأ في التصدير', 'adminDb.exportSuccess': 'تم التصدير بنجاح!', 'adminDb.exportTitle': 'تصدير قاعدة البيانات', 'adminDb.fileSelected': 'تم اختيار الملف', 'adminDb.importClientsBtn': 'استيراد العملاء', 'adminDb.importClientsConfirm': 'استيراد العملاء؟ سيتم إنشاء حسابات بالهاتف.', 'adminDb.importConfirm': 'تحذير: سيتم استبدال البيانات الموجودة. متابعة؟', 'adminDb.importDesc': 'استيراد ملف JSON لاستعادة أو نقل البيانات.', 'adminDb.importDone': 'اكتمل الاستيراد!', 'adminDb.importError': 'خطأ في الاستيراد', 'adminDb.importFullBtn': 'استيراد كامل', 'adminDb.importSuccess': 'تم الاستيراد بنجاح!', 'adminDb.importTitle': 'استيراد قاعدة البيانات', 'adminDb.importWarning': 'الاستيراد الكامل سيستبدل البيانات الموجودة', 'adminDb.logsTitle': 'سجل العمليات', 'adminDb.noLogs': 'لا توجد عمليات', 'adminDb.repairs': 'الإصلاحات', 'adminDb.selectFile': 'اختر ملفاً', 'adminDb.selectFileClients': 'اختر ملف JSON بالعملاء', 'adminDb.stockArticles': 'مواد المخزون', 'adminDb.subtitle': 'تصدير واستيراد وإدارة البيانات', 'adminDb.title': 'إدارة قاعدة البيانات', 'adminDb.uploading': 'جاري رفع الملف...', 'adminDb.users': 'المستخدمون',
    'adminSettings.accentColor': 'لون التمييز (hex)', 'adminSettings.addImage': 'إضافة صورة', 'adminSettings.bgImage': 'صورة الخلفية', 'adminSettings.capital': 'رأس المال', 'adminSettings.change': 'تغيير', 'adminSettings.companyInfo': 'معلومات الشركة', 'adminSettings.companyName': 'اسم الشركة', 'adminSettings.companyType': 'النوع (SAS, SARL...)', 'adminSettings.contactHours': 'الاتصال والمواعيد', 'adminSettings.email': 'البريد', 'adminSettings.error': 'خطأ', 'adminSettings.euid': 'EUID', 'adminSettings.gallery': 'معرض الصور', 'adminSettings.googleMaps': 'بحث Google Maps', 'adminSettings.headquarters': 'المقر الرئيسي', 'adminSettings.heroSection': 'العنوان الرئيسي', 'adminSettings.mainTitle': 'العنوان الرئيسي', 'adminSettings.phone': 'الهاتف', 'adminSettings.preview': 'معاينة', 'adminSettings.rcs': 'RCS', 'adminSettings.salesPoint': 'نقطة البيع', 'adminSettings.save': 'حفظ', 'adminSettings.saved': 'تم الحفظ!', 'adminSettings.saving': 'جاري الحفظ...', 'adminSettings.siret': 'SIRET', 'adminSettings.subtitle': 'العنوان الفرعي', 'adminSettings.title': 'الصفحة الرئيسية', 'adminSettings.whatsapp': 'واتساب',
    'b2b.actions': 'الإجراءات', 'b2b.addPhotos': 'انقر لإضافة صور', 'b2b.additionalNotes': 'ملاحظات إضافية', 'b2b.allStatus': 'الكل', 'b2b.amount': 'المبلغ', 'b2b.anotherRepair': 'إصلاح جديد', 'b2b.backGlass': 'الزجاج الخلفي', 'b2b.backGlassBroken': 'زجاج خلفي مكسور', 'b2b.backGlassOk': 'زجاج خلفي سليم', 'b2b.brand': 'العلامة', 'b2b.brandModelRequired': 'العلامة والموديل مطلوبان', 'b2b.brokenParts': 'الأجزاء المعطلة', 'b2b.clear': 'مسح', 'b2b.completed': 'مكتمل', 'b2b.createdOn': 'أُنشئ في', 'b2b.date': 'التاريخ', 'b2b.delivered': 'تم التسليم', 'b2b.deliveryMethod': 'طريقة التسليم', 'b2b.device': 'الجهاز', 'b2b.deviceInfo': 'معلومات الجهاز', 'b2b.devicePhotos': 'صور الجهاز', 'b2b.diagPrice': 'سعر التشخيص', 'b2b.documents': 'الوثائق والفواتير', 'b2b.documentsDesc': 'تحقق من الطلبات وحمّل الفواتير', 'b2b.enterCode': 'أدخل الرمز المستلم بالبريد للتحقق من كل طلب.', 'b2b.history': 'السجل', 'b2b.inProgress': 'قيد التنفيذ', 'b2b.inStore': 'في المتجر', 'b2b.inStoreDesc': 'تسليم في المتجر', 'b2b.invoices': 'الفواتير', 'b2b.lockCode': 'رمز القفل', 'b2b.lockTypeCode': 'رمز (أرقام/حروف)', 'b2b.lockTypeSchema': 'نمط', 'b2b.model': 'الموديل', 'b2b.myRepairs': 'إصلاحاتي', 'b2b.newRepair': 'إصلاح جديد', 'b2b.noInvoices': 'لا فواتير', 'b2b.noPhotos': 'لا صور', 'b2b.noRepairFound': 'لم يتم العثور على إصلاحات', 'b2b.noRepairs': 'لا إصلاحات', 'b2b.orderValidated': 'طلب مؤكد', 'b2b.paid': 'مدفوع', 'b2b.partByShop': 'قطعة من R.E.Mobiles', 'b2b.pendingValidation': 'طلبات بانتظار التحقق', 'b2b.pickup': 'استلام', 'b2b.pickupAddress': 'عنوان الاستلام', 'b2b.pickupDesc': 'نأتي لاستلامه', 'b2b.postal': 'بريدي', 'b2b.postalDesc': 'مع رقم التتبع', 'b2b.priceWaiting': 'قيد الانتظار - سيحدده R.E.Mobiles', 'b2b.problem': 'المشكلة / الوصف', 'b2b.providePart': 'أوفر القطعة', 'b2b.received': 'مُستلم', 'b2b.recentRepairs': 'الإصلاحات الأخيرة', 'b2b.reference': 'المرجع', 'b2b.registerDevice': 'تسجيل جهاز', 'b2b.repairAccepted': 'إصلاح مقبول', 'b2b.repairPrice': 'سعر الإصلاح', 'b2b.repairRefused': 'إصلاح مرفوض', 'b2b.repairRegistered': 'تم تسجيل الإصلاح', 'b2b.submitRepair': 'إرسال الإصلاح', 'b2b.submitting': 'جاري الإرسال...', 'b2b.thisMonth': 'هذا الشهر', 'b2b.trackingNumber': 'رقم التتبع', 'b2b.validate': 'تحقق', 'b2b.viewAll': 'عرض الكل', 'b2b.viewDetails': 'عرض التفاصيل', 'b2b.waitingParts': 'في انتظار القطع', 'b2b.waitingReception': 'في انتظار الاستلام', 'b2b.welcome': 'مرحباً',
    'b2bDevis.acceptFirst': 'اقبل العرض أولاً للتحقق.', 'b2bDevis.alreadyPaid': 'مدفوع مسبقاً', 'b2bDevis.codeHint': 'أدخل الرمز المكون من 6 أرقام المستلم بالبريد.', 'b2bDevis.invoiceDownload': 'تحميل الفاتورة', 'b2bDevis.noDevis': 'لا عروض أسعار', 'b2bDevis.noDevisDesc': 'ليس لديك عروض أسعار تنقل حالياً.', 'b2bDevis.orderDownload': 'تحميل أمر الشراء', 'b2bDevis.payDeposit': 'دفع مقدم 50%', 'b2bDevis.payFull': 'دفع كامل', 'b2bDevis.payRemaining': 'دفع المتبقي', 'b2bDevis.pending': 'قيد الانتظار', 'b2bDevis.quoteDownload': 'تحميل عرض السعر', 'b2bDevis.remaining': 'المتبقي', 'b2bDevis.title': 'عروض أسعار التنقل', 'b2bDevis.travelFee': 'رسوم التنقل', 'b2bDevis.validationCode': 'رمز التحقق',
    'b2bPay.noPayments': 'لا مدفوعات', 'b2bPay.title': 'مدفوعات B2B',
    'b2bRegister.address': 'العنوان', 'b2bRegister.alreadyAccount': 'مسجل بالفعل؟', 'b2bRegister.companyName': 'اسم الشركة', 'b2bRegister.confirmPassword': 'تأكيد كلمة المرور', 'b2bRegister.creating': 'جاري التسجيل...', 'b2bRegister.dropFile': 'انقر أو اسحب الملف هنا', 'b2bRegister.fillAll': 'أكمل جميع الحقول المطلوبة', 'b2bRegister.goLogin': 'الذهاب لتسجيل الدخول', 'b2bRegister.kbis': 'مستخرج KBIS (PDF)', 'b2bRegister.kbisDesc': 'ارفع مستخرج KBIS أو وثيقة إثبات (PDF)', 'b2bRegister.kbisRequired': 'ارفع مستخرج KBIS', 'b2bRegister.managerName': 'اسم المسؤول', 'b2bRegister.password': 'كلمة المرور', 'b2bRegister.phone': 'الهاتف', 'b2bRegister.proEmail': 'البريد المهني', 'b2bRegister.pwdMinLength': 'يجب أن تكون كلمة المرور 6 أحرف على الأقل', 'b2bRegister.pwdNoMatch': 'كلمات المرور غير متطابقة', 'b2bRegister.siret': 'SIRET', 'b2bRegister.siretError': 'يجب أن يحتوي SIRET على 14 رقماً', 'b2bRegister.submit': 'تسجيل', 'b2bRegister.subtitle': 'إنشاء حسابك المهني', 'b2bRegister.success': 'تم التسجيل بنجاح!', 'b2bRegister.successMsg': 'حسابك قيد المراجعة. ستتلقى تأكيداً بالبريد.', 'b2bRegister.title': 'تسجيل الشركة',
    'boutique.clientName': 'العميل', 'boutique.noOrders': 'لا طلبات', 'boutique.orderRef': 'مرجع الطلب', 'boutique.status': 'الحالة', 'boutique.title': 'طلبات المتجر', 'boutique.total': 'الإجمالي',
    'brands.addBrand': 'إضافة علامة', 'brands.addModel': 'إضافة موديل', 'brands.deleteConfirm': 'حذف هذه العلامة؟', 'brands.noBrands': 'لا علامات', 'brands.title': 'العلامات والموديلات',
    'caisse.closeDate': 'الإغلاق', 'caisse.closingAmount': 'مبلغ الإغلاق', 'caisse.noCaisse': 'لا صندوق', 'caisse.openDate': 'الافتتاح', 'caisse.openedBy': 'فُتح بواسطة', 'caisse.openingAmount': 'مبلغ الافتتاح', 'caisse.sales': 'المبيعات', 'caisse.title': 'سجل الصندوق',
    'calc.generateInvoice': 'إنشاء فاتورة', 'calc.generateQuote': 'إنشاء عرض سعر', 'calc.searchDevice': 'بحث عن جهاز...', 'calc.selectRepair': 'اختيار إصلاح', 'calc.title': 'حاسبة الأسعار',
    'chat.noConversations': 'لا محادثات', 'chat.title': 'الرسائل', 'chat.typeMessage': 'اكتب رسالتك...',
    'clientPwd.generatePin': 'إنشاء PIN', 'clientPwd.noClients': 'لا عملاء', 'clientPwd.search': 'بحث عن عميل...', 'clientPwd.sendByEmail': 'إرسال بالبريد', 'clientPwd.title': 'كلمات مرور العملاء',
    'clients.account': 'حساب', 'clients.activeAccount': 'نشط', 'clients.add': 'إضافة', 'clients.business': 'شركة', 'clients.clientType': 'نوع العميل', 'clients.company': 'شركة', 'clients.deleteConfirm': 'حذف هذا العميل؟', 'clients.discount': 'خصم', 'clients.discountPct': 'خصم (%)', 'clients.editClient': 'تعديل العميل', 'clients.individual': 'فرد', 'clients.manage': 'إدارة العملاء', 'clients.newClient': 'عميل جديد', 'clients.noClients': 'لم يتم العثور على عملاء', 'clients.noEmail': 'بدون بريد', 'clients.page': 'صفحة', 'clients.sent': 'مُرسل', 'clients.total': 'عملاء إجمالاً', 'clients.type': 'النوع',
    'closeCaisse.actualTotal': 'الإجمالي الفعلي', 'closeCaisse.close': 'إغلاق الصندوق', 'closeCaisse.closing': 'جاري الإغلاق...', 'closeCaisse.countCoins': 'عد النقود', 'closeCaisse.difference': 'الفرق', 'closeCaisse.theoreticalTotal': 'الإجمالي النظري', 'closeCaisse.title': 'إغلاق الصندوق',
    'cmd.addOrder': 'طلب جديد', 'cmd.allStatuses': 'جميع الحالات', 'cmd.cancelled': 'ملغي', 'cmd.deleteConfirm': 'حذف هذا الطلب؟', 'cmd.editOrder': 'تعديل الطلب', 'cmd.manage': 'إدارة الطلبات', 'cmd.noOrders': 'لا طلبات', 'cmd.ordered': 'طُلب', 'cmd.received': 'مُستلم', 'cmd.ref': 'المرجع', 'cmd.status': 'الحالة',
    'dash.activeRepairs': 'الإصلاحات النشطة', 'dash.addDevice': 'إضافة', 'dash.b2bPaymentsDesc': 'متابعة الفواتير والمدفوعات', 'dash.b2bPaymentsLabel': 'مدفوعات B2B', 'dash.brandsModelsDesc': 'إدارة كتالوج الأجهزة', 'dash.brandsModelsLabel': 'العلامات والموديلات', 'dash.caisseOpen': 'الصندوق مفتوح', 'dash.calculation': 'الآلة الحاسبة', 'dash.clients': 'العملاء', 'dash.closeCaisseReminder': 'لا تنسَ إغلاق الصندوق', 'dash.closeNormal': 'إغلاق عادي', 'dash.closing': 'جاري الإغلاق...', 'dash.completed': 'مكتملة', 'dash.contactAdmin': 'اتصل بمسؤول لإغلاقه.', 'dash.dontOpen': 'لا تفتح (متابعة)', 'dash.errorForceClose': 'خطأ في الإغلاق الإجباري', 'dash.errorOpenCaisse': 'خطأ في فتح الصندوق', 'dash.forceClose': 'إغلاق إجباري', 'dash.forceCloseConfirm': 'إغلاق إجباري للصندوق من', 'dash.hello': 'مرحباً', 'dash.inProgress': 'قيد التنفيذ', 'dash.loggedAs': 'مسجل الدخول كـ', 'dash.lowStock': 'منتجات بمخزون منخفض', 'dash.mustClose': 'يجب إغلاقه قبل المتابعة.', 'dash.noCaisse': 'لا يوجد صندوق مفتوح', 'dash.noCaisseToday': 'لا يوجد صندوق مفتوح اليوم.', 'dash.noClient': 'بدون عميل', 'dash.noResults': 'لا نتائج', 'dash.open': 'فتح', 'dash.openCaisseTitle': 'فتح الصندوق', 'dash.openQuestion': 'هل تريد فتح الصندوق الآن؟', 'dash.openTotal': 'مبلغ الافتتاح', 'dash.openedBy': 'فُتح بواسطة', 'dash.opening': 'جاري الفتح...', 'dash.outOfStock': 'نفدت من المخزون', 'dash.recentRepairs': 'الإصلاحات الأخيرة', 'dash.registeredMonth': 'مسجلة هذا الشهر', 'dash.repairs': 'الإصلاحات', 'dash.repairsSub': 'إصلاحات', 'dash.salesBlocked': 'المبيعات محظورة حتى فتح الصندوق.', 'dash.searchPlaceholder': 'بحث بالمرجع، العميل، الهاتف...', 'dash.statsDesc': 'الإيرادات، الإصلاحات، B2B، العملاء', 'dash.statsTitle': 'الإحصائيات والتحليلات', 'dash.stockAlerts': 'تنبيهات المخزون', 'dash.thisMonth': 'هذا الشهر', 'dash.today': 'اليوم', 'dash.todaySales': 'مبيعات اليوم', 'dash.unclosedNotClosed': 'لم يتم إغلاقه', 'dash.unclosedTitle': 'صندوق غير مغلق', 'dash.unknown': 'غير معروف', 'dash.waitingParts': 'بما في ذلك انتظار قطع الغيار',
    'devDep.remindConfirm': 'إرسال تذكير للعملاء بعروض أسعار تجاوزت 3 أيام؟',
    'devisAccept.accept': 'قبول العرض', 'devisAccept.accepted': 'تم قبول عرض السعر!', 'devisAccept.acceptedMsg': 'شكراً لقبول عرض السعر', 'devisAccept.alreadyAccepted': 'تم قبول هذا العرض مسبقاً.', 'devisAccept.alreadyRefused': 'تم رفض هذا العرض.', 'devisAccept.bonCommande': 'أمر شراء', 'devisAccept.confirmRefuse': 'هل أنت متأكد من رفض هذا العرض؟', 'devisAccept.deposit50': 'مقدم 50%', 'devisAccept.designation': 'الوصف', 'devisAccept.emailSent': 'تم إرسال بريد إلكتروني بالطلب ورمز التحقق وبيانات الدخول.', 'devisAccept.error': 'خطأ', 'devisAccept.facture': 'فاتورة', 'devisAccept.findBelow': 'تفاصيل عرض السعر أدناه:', 'devisAccept.fullPayment': 'دفع كامل', 'devisAccept.hello': 'مرحباً', 'devisAccept.homeRepairQuote': 'عرض سعر إصلاح منزلي', 'devisAccept.notFound': 'عرض السعر غير موجود', 'devisAccept.payDeposit': 'دفع مقدم 50%', 'devisAccept.paymentMsg': 'لإتمام طلبك، ادفع مقدم أو المبلغ الكامل:', 'devisAccept.proceedPayment': 'المتابعة للدفع', 'devisAccept.refuse': 'رفض', 'devisAccept.refused': 'عرض السعر مرفوض', 'devisAccept.refusedMsg': 'لقد رفضت عرض السعر', 'devisAccept.statusMsg': 'حالة العرض', 'devisAccept.thanks': 'شكراً لإبلاغنا.', 'devisAccept.travelFee': 'رسوم التنقل', 'devisAccept.tvaNote': 'ضريبة القيمة المضافة غير مطبقة. العرض صالح 30 يوماً.',
    'hist.amount': 'المبلغ', 'hist.articles': 'المواد', 'hist.client': 'العميل', 'hist.date': 'التاريخ', 'hist.noSales': 'لا مبيعات', 'hist.payment': 'الدفع', 'hist.ref': 'المرجع', 'hist.refund': 'استرداد', 'hist.refundConfirm': 'استرداد هذا البيع؟', 'hist.search': 'بحث عن بيع...', 'hist.title': 'سجل المبيعات',
    'labels.noLabels': 'لا ملصقات', 'labels.print': 'طباعة', 'labels.search': 'بحث...', 'labels.selectAll': 'تحديد الكل', 'labels.title': 'الملصقات',
    'landing.allRights': 'جميع الحقوق محفوظة', 'landing.heroSubtitle': 'متخصصكم في إصلاح الهواتف في غيانا', 'landing.mondayFriday': 'الاثنين - الجمعة', 'landing.saturday': 'السبت', 'landing.sunday': 'الأحد', 'landing.closed': 'مغلق', 'landing.companyType': 'شركة مساهمة مبسطة (SAS)', 'landing.openMaps': 'فتح في الخرائط', 'landing.rcs': 'السجل التجاري', 'landing.siret': 'رقم التسجيل', 'landing.euid': 'معرف الشركة الأوروبي', 'landing.shopAddress': 'عنوان المتجر', 'landing.businessDesc': 'بوابة B2B', 'landing.businessSpace': 'منطقة الأعمال', 'landing.callWhatsapp': 'اتصال وواتساب', 'landing.capital': 'برأس مال', 'landing.clientDesc': 'متابعة الإصلاحات', 'landing.clientSpace': 'منطقة العميل', 'landing.contact': 'اتصل بنا', 'landing.headquarters': 'المقر الرئيسي', 'landing.hours': 'ساعات العمل', 'landing.legal': 'معلومات قانونية', 'landing.mobileRepair': 'إصلاح الهواتف في غويانا الفرنسية', 'landing.staffDesc': 'وصول الفريق التقني', 'landing.staffSpace': 'المنطقة الشخصية', 'landing.writeUs': 'راسلنا مباشرة',
    'login.b2bPassword': 'كلمة المرور', 'login.b2bPlaceholder': 'كلمة المرور الخاصة بك', 'login.backHome': 'العودة للرئيسية', 'login.businessRegister': 'تسجيل الشركة', 'login.businessSpace': 'منطقة الأعمال', 'login.caricature': 'إنشاء كاريكاتيري', 'login.clientSpace': 'منطقة العميل', 'login.connect': 'تسجيل الدخول', 'login.connectYou': 'تسجيل الدخول', 'login.connecting': 'جاري الاتصال...', 'login.createAccount': 'إنشاء حساب', 'login.forgotPwd': 'نسيت كلمة المرور؟', 'login.noAccount': 'ليس لديك حساب بعد؟', 'login.notRegistered': 'لم تسجل بعد؟', 'login.phoneNumber': 'رقم الهاتف', 'login.pin': 'رمز PIN (4 أو 6 أرقام)', 'login.pinError': 'يجب أن يكون PIN من 4 أو 6 أرقام', 'login.pinHint': 'أدخل رمزك باستخدام لوحة المفاتيح.', 'login.proEmail': 'البريد المهني', 'login.secure': 'اتصال آمن', 'login.staffSpace': 'المنطقة الشخصية', 'login.wrongCredentials': 'بيانات دخول غير صحيحة', 'login.yourId': 'المعرّف الخاص بك',
    'notes.deleteConfirm': 'حذف هذه الملاحظة؟', 'notes.new': 'ملاحظة جديدة', 'notes.noNotes': 'لا ملاحظات', 'notes.title': 'الملاحظات',
    'pay.amount': 'المبلغ', 'pay.client': 'العميل', 'pay.date': 'التاريخ', 'pay.noPayments': 'لا مدفوعات', 'pay.ref': 'المرجع', 'pay.search': 'بحث...', 'pay.status': 'الحالة', 'pay.title': 'المدفوعات عبر الإنترنت', 'pay.type': 'النوع',
    'paySuccess.amountPaid': 'المبلغ المدفوع', 'paySuccess.checking': 'جاري التحقق...', 'paySuccess.confirmed': 'تم تأكيد الدفع!', 'paySuccess.depositDone': 'تم تسجيله.', 'paySuccess.depositFor': 'المقدم لعرض السعر', 'paySuccess.depositRegistered': 'تم تسجيل المقدم!', 'paySuccess.loginClient': 'الدخول لمنطقة العميل', 'paySuccess.payRemaining': 'دفع المتبقي', 'paySuccess.paymentFor': 'دفعتك لعرض السعر', 'paySuccess.pleaseWait': 'نحن نتحقق من دفعتك، يرجى الانتظار.', 'paySuccess.processing': 'جاري معالجة دفعتك. ستتلقى تأكيداً بالبريد.', 'paySuccess.registered': 'تم تسجيلها بنجاح.', 'paySuccess.remaining': 'المتبقي', 'paySuccess.totalInvoice': 'إجمالي الفاتورة', 'paySuccess.waitingConfirm': 'في انتظار التأكيد',
    'payment.accessClient': 'الوصول لمنطقة العميل', 'payment.alreadyPaid': 'مدفوعة بالكامل بالفعل.', 'payment.alreadyPaidAmount': 'المدفوع مسبقاً', 'payment.amountToPay': 'المبلغ المطلوب', 'payment.backToDevis': 'العودة للعرض', 'payment.client': 'العميل', 'payment.creationError': 'خطأ في إنشاء الدفع', 'payment.deposit50': 'مقدم 50%', 'payment.depositPercent': 'مقدم (50%)', 'payment.devis': 'عرض السعر', 'payment.error': 'خطأ', 'payment.fullPayment': 'دفع كامل', 'payment.fullyPaid': 'الفاتورة مدفوعة بالكامل', 'payment.mustAcceptFirst': 'يجب قبول العرض قبل الدفع.', 'payment.notAccepted': 'العرض غير مقبول', 'payment.pay': 'ادفع', 'payment.redirecting': 'جاري التحويل إلى Stripe...', 'payment.remaining': 'المتبقي', 'payment.secure': 'دفع آمن', 'payment.securedBy': 'الدفع مؤمن بواسطة Stripe', 'payment.totalDevis': 'إجمالي العرض', 'payment.urlNotAvailable': 'رابط الدفع غير متوفر', 'payment.viewDevis': 'عرض التقدير',
    'register.address': 'العنوان (اختياري)', 'register.alreadyAccount': 'لديك حساب بالفعل؟', 'register.backHome': 'العودة للرئيسية', 'register.clientTitle': 'إنشاء حساب عميل', 'register.confirmPin': 'تأكيد رمز PIN', 'register.createAccount': 'إنشاء حسابي', 'register.creating': 'جاري الإنشاء...', 'register.email': 'البريد (اختياري)', 'register.fullName': 'الاسم الكامل', 'register.login': 'تسجيل الدخول', 'register.phone': 'الهاتف', 'register.pin': 'رمز PIN (4 أو 6 أرقام)', 'register.pinError': 'يجب أن يكون PIN من 4 أو 6 أرقام', 'register.pinMinLength': 'يجب أن يكون PIN 4 أرقام على الأقل', 'register.pinNoMatch': 'رموز PIN غير متطابقة',
    'remcaches.noItems': 'لا عناصر', 'remcaches.title': 'حوالات نقدية',
    'rep.addDeposit': 'إضافة مقدم', 'rep.allStatuses': 'جميع الحالات', 'rep.changeStatus': 'تغيير الحالة', 'rep.client': 'العميل', 'rep.date': 'التاريخ', 'rep.deleteConfirm': 'حذف هذا الإصلاح؟', 'rep.deposit': 'المقدم', 'rep.depositAmount': 'مبلغ المقدم', 'rep.depositHistory': 'سجل المقدمات', 'rep.imei': 'IMEI / المسلسل', 'rep.manage': 'إدارة الإصلاحات', 'rep.noRepairs': 'لا إصلاحات', 'rep.noTimeline': 'لا أحداث', 'rep.notes': 'ملاحظات داخلية', 'rep.paymentMode': 'طريقة الدفع', 'rep.phone': 'الهاتف', 'rep.printEtiquette': 'طباعة الملصق', 'rep.printFiche': 'طباعة البطاقة', 'rep.sendChat': 'إرسال رسالة', 'rep.totalDeposits': 'إجمالي المقدمات',
    'repForm.brand': 'العلامة', 'repForm.client': 'العميل', 'repForm.editTitle': 'تعديل الإصلاح', 'repForm.imei': 'IMEI / الرقم المسلسل', 'repForm.lockCode': 'رمز القفل', 'repForm.model': 'الموديل', 'repForm.price': 'سعر الإصلاح', 'repForm.problem': 'المشكلة المكتشفة', 'repForm.submit': 'حفظ', 'repForm.submitting': 'جاري الحفظ...', 'repForm.technician': 'الفني المعين', 'repForm.title': 'إضافة جهاز',
    'reset.backLogin': 'العودة لتسجيل الدخول', 'reset.clientEmail': 'بريد حسابك', 'reset.confirmPwd': 'تأكيد كلمة المرور', 'reset.emailSent': 'تم إرسال البريد', 'reset.emailSentMsg': 'إذا كان الحساب موجوداً، ستتلقى رابط إعادة تعيين.', 'reset.enterEmail': 'أدخل بريدك الإلكتروني', 'reset.error': 'حدث خطأ', 'reset.forgotDesc': 'احصل على رابط إعادة تعيين بالبريد', 'reset.forgotTitle': 'نسيت كلمة المرور', 'reset.linkValid': 'الرابط صالح لمدة ساعة.', 'reset.newPwd': 'كلمة مرور جديدة', 'reset.newPwdDesc': 'اختر كلمة مرور جديدة', 'reset.newPwdTitle': 'كلمة مرور جديدة', 'reset.pwdMinLength': 'يجب أن تكون كلمة المرور 4 أحرف على الأقل', 'reset.pwdNoMatch': 'كلمات المرور غير متطابقة', 'reset.pwdReset': 'تم إعادة تعيين كلمة المرور', 'reset.pwdResetMsg': 'تم تغيير كلمة المرور بنجاح.', 'reset.resetPwd': 'إعادة تعيين كلمة المرور', 'reset.resetting': 'جاري إعادة التعيين...', 'reset.sendLink': 'إرسال رابط إعادة التعيين', 'reset.sending': 'جاري الإرسال...',
    'stats.avgRepairTime': 'متوسط المدة', 'stats.b2b': 'B2B', 'stats.b2bByCompany': 'حسب الشركة', 'stats.b2bCompanies': 'شركات B2B', 'stats.b2bRepairs': 'إصلاحات B2B', 'stats.b2bRevenue': 'إيرادات B2B', 'stats.back': 'رجوع', 'stats.clients': 'العملاء', 'stats.clientsByType': 'حسب النوع', 'stats.completionRate': 'معدل الإنجاز', 'stats.monthly': 'الاتجاه الشهري', 'stats.monthlyRevenue': 'الإيرادات الشهرية', 'stats.newThisMonth': 'جدد هذا الشهر', 'stats.noData': 'لا بيانات', 'stats.registrations': 'التسجيلات الشهرية', 'stats.repairs': 'الإصلاحات', 'stats.repairsByBrand': 'حسب العلامة', 'stats.repairsByStatus': 'حسب الحالة', 'stats.revenue': 'الإيرادات', 'stats.revenueByPayment': 'الإيرادات حسب طريقة الدفع', 'stats.revenueByType': 'الإيرادات حسب النوع', 'stats.title': 'الإحصائيات والتحليلات', 'stats.topModels': 'أفضل الموديلات', 'stats.totalClients': 'إجمالي العملاء', 'stats.totalRepairs': 'إجمالي الإصلاحات', 'stats.totalRevenue': 'إجمالي الإيرادات (12 شهراً)', 'stats.withAccount': 'مع حساب',
    'stock.addForm': 'إضافة مادة', 'stock.alert': 'تنبيه', 'stock.barcode': 'رمز شريطي', 'stock.deleteConfirm': 'حذف هذه المادة؟', 'stock.editForm': 'تعديل المادة', 'stock.lowStockAlert': 'مخزون منخفض', 'stock.manage': 'إدارة المخزون', 'stock.noItems': 'لا مواد', 'stock.reference': 'المرجع',
    'users.accessDenied': 'للمسؤولين فقط', 'users.active': 'نشط', 'users.count': 'مستخدم(ين)', 'users.createdAt': 'أُنشئ في', 'users.deleteConfirm': 'حذف هذا المستخدم؟', 'users.edit': 'تعديل', 'users.inactive': 'غير نشط', 'users.new': 'مستخدم جديد', 'users.newPassword': 'كلمة مرور جديدة (اتركها فارغة للاحتفاظ)', 'users.noUsers': 'لا مستخدمين', 'users.password': 'كلمة المرور', 'users.role': 'الدور', 'users.roleAdmin': 'مسؤول', 'users.roleTech': 'فني', 'users.roleUser': 'بائع', 'users.status': 'الحالة', 'users.title': 'إدارة المستخدمين', 'users.username': 'اسم المستخدم',
    // Missing common keys
    'common.actions': 'إجراءات', 'common.address': 'عنوان', 'common.all': 'الكل', 'common.amount': 'المبلغ', 'common.back': 'رجوع', 'common.date': 'تاريخ', 'common.description': 'وصف', 'common.download': 'تنزيل', 'common.export': 'تصدير', 'common.filter': 'تصفية', 'common.name': 'الاسم', 'common.next': 'التالي', 'common.payment': 'دفع', 'common.print': 'طباعة', 'common.quantity': 'كمية', 'common.ref': 'مرجع', 'common.refresh': 'تحديث',
    // Missing nav keys
    'nav.b2b': 'إدارة B2B', 'nav.b2bPayments': 'مدفوعات B2B', 'nav.boutiqueOrders': 'طلبات المتجر', 'nav.brandsModels': 'علامات ونماذج', 'nav.caisseHistory': 'سجل الصندوق', 'nav.chat': 'رسائل', 'nav.chatClients': 'محادثة الزبائن', 'nav.clientPwd': 'كلمات مرور الزبائن', 'nav.database': 'قاعدة البيانات', 'nav.historique': 'السجل', 'nav.notes': 'ملاحظات', 'nav.paiements': 'مدفوعات إلكترونية',
    // Missing login/dash keys
    'login.username': 'اسم المستخدم', 'login.password': 'رمز الدخول', 'login.clientAccess': 'دخول الزبون', 'login.staffAccess': 'دخول الموظف',
    'dash.openCaisse': 'فتح الصندوق', 'dash.closeCaisse': 'إغلاق الصندوق', 'dash.monthSales': 'مبيعات الشهر', 'dash.pendingOrders': 'طلبات معلقة',
    // Missing POS keys
    'pos.scanner': 'ماسح', 'pos.searchProduct': 'البحث عن منتج...', 'pos.outOfStock': 'غير متوفر', 'pos.article': 'منتج', 'pos.unitPrice': 'سعر الوحدة', 'pos.qty': 'الكمية', 'pos.checkout': 'الدفع', 'pos.clientOptional': 'الزبون (اختياري)', 'pos.discount': 'خصم', 'pos.subtotal': 'المجموع الفرعي', 'pos.validateSale': 'تأكيد البيع', 'pos.paymentMode': 'طريقة الدفع', 'pos.choosePayment': 'اختر طريقة الدفع:', 'pos.mixed': 'مختلط', 'pos.totalToCollect': 'المبلغ المطلوب', 'pos.change': 'الباقي', 'pos.validating': 'جارٍ التأكيد...', 'pos.lastTicket': 'آخر إيصال', 'pos.caisseClosed': 'الصندوق مغلق. افتحه من لوحة التحكم للبيع.', 'pos.insufficientCash': 'المبلغ النقدي غير كافٍ', 'pos.insufficientCard': 'مبلغ البطاقة غير كافٍ', 'pos.mixedMustEqual': 'الدفع المختلط يجب أن يساوي المجموع', 'pos.emptyCartAlert': 'السلة فارغة', 'pos.selectPayment': 'يرجى اختيار طريقة دفع', 'pos.saleValidated': 'تم تأكيد البيع!', 'pos.adminOverride': 'تفويض المسؤول', 'pos.outOfStockProduct': 'منتج غير متوفر', 'pos.adminId': 'معرف المسؤول', 'pos.adminCode': 'رمز المسؤول', 'pos.manualAdd': 'إضافة منتج غير متوفر', 'pos.designation': 'التسمية', 'pos.stockInsufficient': 'المخزون غير كافٍ',
    // Missing devis keys
    'devis.subtitle': 'مستندات حساب الأسعار.', 'devis.noDoc': 'لا مستندات', 'devis.type': 'النوع', 'devis.convertConfirm': 'تحويل العرض إلى طلب؟', 'devis.orderCreated': 'تم إنشاء الطلب', 'devis.deleteConfirm': 'حذف هذا المستند؟', 'devis.deleted': 'تم حذف المستند',
    // Missing devDep keys
    'devDep.subtitle': 'إدارة عروض التصليح بالمنزل', 'devDep.edit': 'تعديل العرض', 'devDep.clientName': 'اسم الزبون', 'devDep.clientPhone': 'الهاتف', 'devDep.clientEmail': 'البريد الإلكتروني', 'devDep.clientAddress': 'العنوان', 'devDep.repairDesc': 'وصف التصليح', 'devDep.lines': 'بنود العرض', 'devDep.addLine': 'إضافة', 'devDep.sendByEmail': 'إرسال بالبريد', 'devDep.sending': 'جارٍ الإرسال...', 'devDep.pdfDevis': 'PDF عرض', 'devDep.pdfBon': 'PDF طلب', 'devDep.pdfFacture': 'PDF فاتورة', 'devDep.searchPlaceholder': 'بحث بالمرجع، الاسم، البريد...', 'devDep.allStatuses': 'كل الحالات', 'devDep.depositPaid': 'تم دفع العربون', 'devDep.remind': 'تذكير', 'devDep.stats': 'إحصائيات', 'devDep.revenues': 'الإيرادات', 'devDep.activity30d': 'نشاط آخر 30 يوم', 'devDep.noResults': 'لا نتائج', 'devDep.bon': 'أمر شراء', 'devDep.facture': 'فاتورة', 'devDep.emailSent': 'تم إرسال البريد في', 'devDep.reminderSent': 'تم إرسال التذكير في',
    // Missing rep keys
    'rep.search': 'البحث عن تصليح...', 'rep.new': 'تصليح جديد', 'rep.deviceRef': 'مرجع الجهاز', 'rep.brand': 'العلامة', 'rep.model': 'الموديل', 'rep.problem': 'المشكلة', 'rep.technician': 'الفني', 'rep.timeline': 'التسلسل الزمني',
    // Missing cmd keys
    'cmd.search': 'البحث عن طلب...', 'cmd.piece': 'القطعة', 'cmd.supplier': 'المورد', 'cmd.deposit': 'العربون', 'cmd.remaining': 'المبلغ المتبقي',
    // Missing clients keys
    'clients.search': 'البحث عن زبون...', 'clients.name': 'الاسم', 'clients.address': 'العنوان', 'clients.addClient': 'زبون جديد',
    // Missing stock keys
    'stock.search': 'البحث عن مادة...', 'stock.addArticle': 'إضافة مادة', 'stock.category': 'الفئة', 'stock.buyPrice': 'سعر الشراء', 'stock.sellPrice': 'سعر البيع', 'stock.available': 'متوفر',
    // Missing client portal keys
    'client.repairs': 'تصليحات', 'client.boutique': 'المتجر', 'client.orders': 'طلبات', 'client.messages': 'رسائل', 'client.acceptRefuse': 'قبول / رفض', 'client.trackRepairs': 'تتبع تصليحاتك', 'client.noRepairs': 'لا تصليحات جارية', 'client.trackOrders': 'تتبع طلباتك', 'client.noOrders': 'لا طلبات جارية', 'client.shop': 'المتجر الإلكتروني', 'client.noProducts': 'لا منتجات متوفرة', 'client.addToCart': 'أضف للسلة', 'client.yourMessages': 'رسائلك', 'client.noMessages': 'لا رسائل', 'client.brand': 'العلامة', 'client.model': 'الموديل', 'client.problem': 'المشكلة', 'client.status': 'الحالة', 'client.deposit': 'العربون', 'client.remaining': 'المتبقي', 'client.total': 'المجموع', 'client.timeline': 'التسلسل الزمني',
    'sumup.acceptOnlinePayment': 'قبول الدفع عبر الإنترنت (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'يمكن للعميل طلب رابط دفع SumUp', 'sumup.requestLink': 'طلب رابط دفع SumUp', 'sumup.requestSent': 'تم إرسال الطلب! ستتلقى الرابط عبر البريد الإلكتروني قريبًا.', 'sumup.alreadyRequested': 'الطلب قيد المعالجة بالفعل.', 'sumup.onlinePayment': 'دفع عبر الإنترنت SumUp', 'sumup.receiveLink': 'تلقي رابط دفع آمن عبر البريد الإلكتروني', 'sumup.linkRequested': 'تم طلب الرابط', 'sumup.pendingRequests': 'طلبات روابط SumUp', 'sumup.pending': 'قيد الانتظار', 'sumup.pasteLinkHere': 'الصق رابط SumUp هنا...', 'sumup.send': 'إرسال', 'sumup.linkSent': 'تم إرسال رابط SumUp للعميل عبر البريد الإلكتروني!',
};

export default ar_SY;
